<template>
    <div id="RentalAgreementCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true && isClosedAgreement === false || canEditAfterClose === true">
                <div class="page-name">
                    <span class="page-title" id="rentalAgreementHeader" v-if="$route.params.id > 0">Update Rental Agreement</span>
                    <span class="page-title" id="rentalAgreementHeader" v-else>Add Rental Agreement</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content rental-agreement-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="RentalAgreementForm" onkeydown="return event.key != 'Enter';">
                                <h5 class="color-blue font-bold" style="width:50%" v-if="!onlyInsurance">Agreement </h5>
                                <h5 class="error" style="margin-left:25%;font-size: initial;">{{customer_comment}}</h5>

                                <div class="form-row row-cols-md-4 row-cols-1" v-if="!onlyInsurance">
                                    <div class="col form-group custom-checkbox customPadding">
                                        <div class="form-check form-check-inline">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="is_substitute" id="is_substitute" name="is_substitute" v-on:click="isSubstiute($event)">  Is Substitute
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <template v-if="is_substitute === true">
                                        <!-- <div class="col-md-3 form-group">
                                            <label class="control-label">Lease Contract Available:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="is_contract_available">
                                                        Yes
                                                        <input type="radio" v-model="is_contract_available" :value="1" id="is_contract_available" name="is_contract_available">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="is_contract_available">
                                                        No
                                                        <input type="radio" v-model="is_contract_available" :value="0" id="is_contract_available1" name="is_contract_available">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="col form-group">
                                            <label class="control-label require" for="contract_type_id">Sub Type:</label>
                                            <v-select v-model="sub_type" name="sub_type" placeholder="Select Sub Type."
                                                    label="text"
                                                    :options="subTypeArr" @input="onSubTypeChange($event)">
                                            </v-select>
                                            <div class="field-error">{{sub_type_error_msg}}</div>
                                        </div>

                                        <div class="col form-group" v-if="sub_type.value != undefined && sub_type.value == 'lease'">
                                            <label class="control-label require" for="contract_asset_id">Contract Asset:</label>
                                            <v-select v-model="contract_asset_id" name="contract_asset_id"
                                                    label="text" :filterable="false" :options="activeContractsArr"
                                                    @search="onSearchContractAsset" @input="selectContractAsset($event,'lease')"
                                                    placeholder="Select Contract Asset" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Contract Asset...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{contract_asset_error_msg}}</div>
                                        </div>
                                        <div class="col form-group" v-else-if="sub_type.value != undefined && sub_type.value == 'rental'">
                                            <label class="control-label require" for="contract_asset_id">Agreement:</label>
                                            <v-select v-model="sub_agreement" name="sub_agreement"
                                                    label="text" :filterable="false" :options="rentalAgreementArr"
                                                    @search="onSearchAgreement" @input="selectContractAsset($event,'rental')"
                                                    placeholder="Select Agreement Asset" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Agreement Asset...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{sub_agreement_error_msg}}</div>
                                        </div>
                                        <div class="col form-group" v-else>
                                            <label class="control-label require" for="contract_asset_id">Substitute Asset:</label>
                                            <v-select v-model="sub_unit" name="contract_asset_id"
                                                    label="text" :filterable="false" :options="leaseVehicleArr"
                                                    @search="onSearchLeaseVehicle"
                                                    placeholder="Select Sub Asset" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Original Asset...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{sub_unit_error_msg}}</div>
                                        </div>
                                    </template>
                                    <div class="clearfix"></div>
                                    <div class="clearfix" v-if="!is_substitute"></div>
                                    <div class="clearfix" v-if="!is_substitute"></div>
                                    <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label require" for="code">Agreement#:</label>
                                        <input disabled="disabled" type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="code">Enrich Reference:</label>
                                        <input type="text" class="form-control" v-model="enrich_code" id="enrich_code" placeholder="Enter Enrich Code" name="enrich_code">
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label" for="customer_id">Reservation Ref#:</label>
                                        <v-select v-model="source" name="customer_id"
                                                label="text" :filterable="false" :options="reservationArr"
                                                @search="onSearchReservation"
                                                placeholder="Reservation Reference No." class="custom-ci-auto-search" :disabled="disableFields">
                                            <template slot="no-options">
                                                Search Source...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ reservationerror }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="'control-label '+isRequired"  for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer" class="custom-ci-auto-search" @input="onCustomerInput($event)" :disabled="disableContractType">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error" id="customererror">{{ customererrors }}</div>
                                        <div :class="creditClass" v-if="credit_approved_msg != ''" style="font-size:12px;">{{ credit_approved_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="'control-label '+ requiredFlag" for="customer_id">PO:</label>
                                        <a href="javascript:void(0)" v-on:click="addNewPo()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add PO</a>
                                        <v-select v-model="po" name="customer_id"
                                                label="text" :filterable="false" :options="poArr"
                                                @search="onSearchPO"
                                                placeholder="Select PO" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search PO...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error" id="customererror">{{ customer_po_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="contract_type_id">Contract Type:</label>
                                        <!--a href="javascript:void(0)" v-if="osrSelection" v-on:click="addOsrAsset()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add Asset</a-->
                                        <a href="javascript:void(0)" v-if="osrSelection" v-on:click="addOsrPO()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add OSR PO</a>
                                        <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                label="text"
                                                :options="contracttypeArr" @input="onContractTypeSelect($event)">
                                        </v-select>
                                        <div class="field-error">{{contract_type_error_msg}}</div>
                                    </div>

                                    <div class="col form-group" v-if="osrSelection">
                                        <label class="control-label require" for="contract_type_id">OSR PO:</label>
                                        <v-select v-model="osrPO" name="checkUser"
                                                label="text" :filterable="false" :options="osrPOArr"
                                                @search="onSearchOSRPO"
                                                placeholder="Select OSR PO">
                                            <template slot="no-options">
                                                Search OSR PO...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{osr_po_error_msg}}</div>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label class="control-label">Is National Lease:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_national_lease1_item">
                                                    Yes
                                                    <input type="radio" v-model="is_national_lease" :value="1" id="is_national_lease1_item" name="is_national_lease" v-on:click="isNationalLeaseSelected($event)" :disabled="disableContractType">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_national_lease2_item">
                                                    No
                                                    <input type="radio" v-model="is_national_lease" :value="0" id="is_national_lease2_item" name="is_national_lease" v-on:click="isNationalLeaseSelected($event)" :disabled="disableContractType">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-md-3 form-group">
                                        <label class="control-label">Allow Future Rate Adjustment:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_future_rate_adj1_item">
                                                    Yes
                                                    <input type="radio" v-model="is_future_rate_adj" :value="1" id="is_future_rate_adj1_item" name="is_future_rate_adj" v-on:click="isFutureRateADJSelected($event)" :disabled="disableContractType">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_future_rate_adj2_item">
                                                    No
                                                    <input type="radio" v-model="is_future_rate_adj" :value="0" id="is_future_rate_adj2_item" name="is_future_rate_adj" v-on:click="isFutureRateADJSelected($event)" :disabled="disableContractType">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col form-group custom-checkbox customPadding" v-if="showFields === true">
                                        <!-- <div class="form-check form-check-inline">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="for_vtrl_use_only" id="for_vtrl_use_only" name="for_vtrl_use_only" v-on:click="forVTRLUseOnly($event)">  VTRL use only
                                                <span class="checkmark"></span>
                                            </label>
                                        </div> -->
                                        <div class="form-check form-check-inline">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="consolidated" id="consolidated" name="consolidated">  Consolidate
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <!-- <div class="form-check form-check-inline">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="is_substitute" id="is_substitute" name="is_substitute" v-on:click="isSubstiute($event)">  Is Substitute
                                            <span class="checkmark"></span>
                                            </label>
                                        </div> -->
                                    </div>
                                    <!-- <template v-if="is_substitute === true">
                                        <div class="col form-group">
                                            <label class="control-label require" for="contract_asset_id">Contract Asset:</label>
                                            <v-select v-model="contract_asset_id" name="contract_asset_id"
                                                    label="text" :filterable="false" :options="activeContractsArr"
                                                    @search="onSearchContractAsset"
                                                    placeholder="Select Contract Asset" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Contract Asset...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{contract_asset_error_msg}}</div>
                                        </div>
                                    </template> -->
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1" v-if="!onlyInsurance">
                                    <div class="col form-group">
                                        <label class="control-label" for="notes">Notes:</label>
                                        <textarea class='form-control' v-model="notes" ref="textarea" id="notes" rows="3"></textarea>
                                    </div>
                                    <div class="col form-group mt-5">
                                        <label class="control-label">Show on External Document:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="external_document">Yes
                                                    <input type="radio" v-model="external_document" :value="'yes'" id="external_document" name="external_document">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="external_document1"> No
                                                    <input type="radio" v-model="external_document" :value="'no'" id="external_document1" name="external_document">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="light-hr" v-if="!onlyInsurance"/>
                                <h5 class="color-blue font-bold" v-if="!onlyInsurance">Reservation Period</h5>
                                    <div class="form-row row-cols-md-6 row-cols-1" v-if="!onlyInsurance">
                                        <div v-show="!close" class="col form-group">
                                            <div class="example-label">
                                                <label class="control-label require">Due OUT Date</label>
                                            </div>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" @dp-change="onDueOutChange" id="due_out_date" name="due_out_date" v-model="due_out_date" :config="toDueOutDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="due_out_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </div>
                                        <div class="field-error">{{due_out_datetime_error_msg}}</div>

                                        </div>
                                    <!-- </div> -->
                                    <div v-show="!close" class="col form-group">
                                        <label class="control-label require" for="rentalType">Due OUT Time:</label>
                                        <div class="input-group">
                                            <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="due_out_time" @keyup="validateTime($event)" id="due_out_time" placeholder="HH:MM" name="due_out_time" @blur="populateTime('due_out_time',due_out_time)">
                                            <div class="input-group-append">
                                                <v-select id="due_out_ampm" v-model="due_out_ampm" @input="populateTime('due_out_ampm',due_out_ampm)" class="close-remove" name="dueOutAmPm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{due_out_time_error_msg}}</div>
                                    </div>

                                    <div v-show="!close" class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label require">Due IN Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" @dp-change="onDueInChange" id="due_in_date" name="due_in_date" v-model="due_in_date" :config="toDueInDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="due_in_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{due_in_datetime_error_msg}}</div>
                                    </div>
                                    <div v-show="!close" class="col form-group">
                                        <label class="control-label require" for="rentalType">Due IN Time:</label>
                                        <div class="input-group">
                                            <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="due_in_time" @keyup="validateTime($event)" id="due_in_time" placeholder="HH:MM" name="due_in_time1" @blur="populateTime('due_in_time',due_in_time)">
                                            <div class="input-group-append">
                                                <v-select v-model="due_in_ampm" class="close-remove" name="dueOutAmPm" @input="populateTime('due_in_ampm',due_in_ampm)" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{due_in_time_error_msg}}</div>
                                    </div>
                                    <div v-show="!close" class="col form-group">
                                        <label class="control-label require" for="due_out_location_id">Due OUT Location:</label>
                                        <v-select v-model="due_out_location_id" name="due_out_location_id" placeholder="Select Due OUT Location."
                                                label="text"
                                                :options="dueoutlocationArr">
                                        </v-select>
                                        <div class="field-error">{{due_out_location_error_msg}}</div>
                                    </div>
                                    <div v-show="!close" class="col form-group">
                                        <label class="control-label require" for="due_in_location_id">Due IN Location:</label>
                                        <v-select v-model="due_in_location_id" name="due_in_location_id" placeholder="Select Due IN Location."
                                                label="text"
                                                :options="dueinlocationArr">
                                        </v-select>
                                        <div class="field-error">{{due_in_location_error_msg}}</div>
                                    </div>
                                    <div v-show="!close" class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label">Actual From Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" @dp-change="onActualFromChange" id="actual_from_date" name="actual_from_date" v-model="actual_from_date" :config="toActualFromDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="actual_from_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{actual_from_datetime_error_msg}}</div>
                                    </div>
                                    <div v-show="!close" class="col form-group">
                                        <label class="control-label" for="rentalType">Actual From Time:</label>
                                        <div class="input-group">
                                            <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="actual_from_time" @keyup="validateTime($event)" id="actual_from_time" placeholder="HH:MM" name="actual_from_time1">
                                            <div class="input-group-append">
                                                <v-select v-model="actual_from_ampm" class="close-remove" name="actualFromAmPm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{actual_from_time_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label :class="'control-label '+reqClass">Actual To Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" @dp-change="onActualInChange" id="actual_to_date" name="actual_to_date" v-model="actual_to_date" :config="toActualInDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="actual_to_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{actual_to_datetime_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="'control-label '+reqClass" for="rentalType">Actual To Time:</label>
                                        <!-- <v-select class="close-remove" v-model="actual_to_time"  id="actual_to_time" label="text" :options="timeArr" placeholder="Select Actual To Time.">
                                        </v-select> -->
                                        <div class="input-group">
                                            <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="actual_to_time" @keyup="validateTime($event)" id="actual_to_time" placeholder="HH:MM" name="actual_to_time1">
                                            <div class="input-group-append">
                                                <v-select v-model="actual_to_ampm" class="close-remove" name="actualFromAmPm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{actual_to_time_error_msg}}</div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="clearfix"></div>
                                    <div v-show="!close" class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label require">Planned In To Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="planned_in_date" name="planned_in_date" v-model="planned_in_date" :config="toPlannedInDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="planned_in_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{planned_in_datetime_error_msg}}</div>
                                    </div>
                                    <div v-show="!close" class="col form-group">
                                        <label class="control-label require" for="rentalType">Planned in to Time:</label>
                                        <!-- <v-select class="close-remove" v-model="planned_in_time"  id="planned_in_time" label="text" :options="timeArr" placeholder="Select Planned in to Time.">
                                        </v-select> -->
                                        <div class="input-group">
                                            <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="planned_in_time" @keyup="validateTime($event)" id="planned_in_time" placeholder="HH:MM" name="planned_in_time1">
                                            <div class="input-group-append">
                                                <v-select v-model="planned_in_ampm" class="close-remove" name="actualFromAmPm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{planned_in_time_error_msg}}</div>
                                    </div>
                                </div>
                                <hr class="light-hr" v-if="!onlyInsurance"/>
                                <h5 class="color-blue font-bold" v-if="!onlyInsurance">Unit</h5>
                                <div class="form-row row-cols-md-4 row-cols-1" v-if="!onlyInsurance">
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Asset:</label>
                                        <a href="javascript:void(0)" v-on:click="checkAvailablity()" class="pull-right color-blue link-text"> <i class="fp-search font-weight-bold" style="font-size:10px;"></i> Check availability</a>
                                        <v-select v-model="vehicle_id" name="vehicle_id"
                                            label="text" :filterable="false" :disabled="disableFields" :options="vehicleArr"
                                            @search="onSearchVehicle"
                                            placeholder="Select Asset" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error" v-fp-html="vehicle_error_msg"></div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_type_id">Asset Type:</label>
                                        <v-select v-model="vehicle_type_id" :disabled="true" name="vehicle_type_id" placeholder="Select Vehicle Type."
                                                label="text"
                                                :options="vehicletypeArr">
                                        </v-select>
                                        <div class="field-error">{{vehicle_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="state">State/Province/Region</label>
                                        <v-select v-model="state" name="state"

                                                    label="text" :filterable="false" :options="stateArr"
                                                    @search="onSearchState"
                                                    placeholder="Select State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search State...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="reason">Reason:</label>
                                        <v-select v-model="reason" name="reason" placeholder="Select Reason." label="text" :options="reasonsArr" class="close-remove"></v-select>
                                        <div class="field-error"></div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_type_id">Requested Asset Type:</label>
                                        <v-select v-model="requested_vehicle_type_id" name="vehicle_type_id" placeholder="Select Vehicle Type."
                                                label="text"
                                                :options="vehicletypeArr" :disabled="disableFields">
                                        </v-select>
                                        <div class="field-error">{{requested_vehicle_type_error_msg}}</div>
                                    </div>

                                    <!-- <p>&nbsp;</p> -->

                                        <!-- <div class="clearfix"></div>
                                        <div class="clearfix"></div>
                                        <div class="clearfix"></div>
                                        <h6 class="color-blue font-bold">Available Asset</h6>
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>&nbsp;</th>
                                                        <th>Unit Number</th>
                                                        <th>Asset Type</th>
                                                        <th>Location</th>
                                                        <th>Pool</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="availableAssetArr && availableAssetArr.length > 0">
                                                        <tr v-for="(av, avkey) in availableAssetArr" :key="avkey">
                                                            <td>
                                                            <input type="checkbox" id="selectUnitCheckbox" @input="clickRows($event,av)"/>
                                                            </td>
                                                            <td>
                                                                <label>{{av.unit_no}}</label>
                                                            </td>
                                                            <td>
                                                                <label>{{av.asset_type}}</label>
                                                            </td>
                                                            <td>
                                                                <label>{{av.location}}</label>
                                                            </td>
                                                            <td>
                                                                <label>{{av.pool}}</label>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div> -->
                                </div>
                                <section class="bg-white data-table" v-if="checkAvailabilityFlag">
                                    <vue-good-table
                                        ref="listAssetAvailability"
                                        title="Asset Availability"
                                        @on-selected-rows-change="selectionChanged"
                                        :columns="columns"
                                        :rows="rows"
                                        max-height="600px"
                                        :totalRows="totalRecords"
                                        :pagination-options="{
                                            enabled: true,
                                            position:'top',
                                            mode: 'records',
                                            perPage: 50,
                                            perPageDropdown:[50,100],
                                            dropdownAllowAll: false,
                                        }"
                                        :search-options="{
                                            enabled: false,
                                            placeholder: 'Search Available Asset',
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                    >
                                        <div slot="emptystate">
                                            No Data Found.
                                        </div>
                                        <div slot="selected-row-actions">
                                            <button v-if="flag != 'other'" id="discardedBtn" v-on:click.prevent="undoDiscarded('discard')" class="btn btn-primary">Discard</button>
                                        </div>
                                    </vue-good-table>
                                </section>
                                <hr class="light-hr" v-if="!onlyInsurance"/>
                                <h5 class="color-blue font-bold" v-if="!onlyInsurance">Reading Out</h5>
                                <div class="table-responsive-sm" v-if="!onlyInsurance">
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <thead>
                                            <tr class="table-primary">
                                                <th class="require">Section</th>
                                                <th class="require">Reading Date</th>
                                                <th class="require">Reading</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="unitArr && unitArr.length > 0">
                                                <tr v-for="(uData, key) in unitArr" :key="key">
                                                    <td>
                                                        <label>{{uData.section}}</label>
                                                    </td>
                                                    <td>
                                                        <div class="input-group form-group mb-0">
                                                            <date-picker placeholder="MM/DD/YYYY HH:mm:ss" id="reading_date_out" name="reading_date" v-model="uData.reading_out_date" :config="optionsDateTime" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                                            <label for="reading_date" class="fp-calendar input-calender-icon"></label>
                                                        </div>
                                                        <div class="field-error">{{uData.reading_out_date_error_msg}}</div>
                                                    </td>
                                                    <td>
                                                        <input type="text" v-model="uData.reading_out" placeholder="Reading Out" class="form-control" @keypress="isAmountCheck($event)">
                                                        <div class="field-error">{{uData.reading_out_error_msg}}</div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <template v-if="readInArr && readInArr.length > 0 && !onlyInsurance">
                                    <hr class="light-hr"/>
                                    <h5 class="color-blue font-bold"> Reading In</h5>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th class="require">Section</th>
                                                    <th class="require">Reading Date</th>
                                                    <th class="require">Reading</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="readInArr && readInArr.length > 0">
                                                    <tr v-for="(readIn, inkey) in readInArr" :key="inkey">
                                                        <td>
                                                            <label>{{readIn.section}}</label>
                                                        </td>
                                                        <td>
                                                            <div class="input-group form-group mb-0">
                                                                <date-picker placeholder="MM/DD/YYYY HH:mm:ss" id="reading_date" name="reading_date" v-model="readIn.reading_in_date" :config="optionsDateTime" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                                                <label for="reading_date" class="fp-calendar input-calender-icon"></label>
                                                            </div>
                                                            <div class="field-error">{{readIn.reading_in_date_error_msg}}</div>
                                                        </td>
                                                        <td><input type="text" placeholder="Reading In" v-model="readIn.reading_in" class="form-control" @keypress="isAmountCheck($event)">
                                                        <div class="field-error">{{readIn.reading_in_error_msg}}</div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                                <div class="form-row row-cols-md-4 row-cols-1" v-if="!onlyInsurance">
                                    <div class="col form-group mt-5" v-show="close">
                                        <label class="control-label">Fuel Required:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_national_lease1_item">
                                                    Yes
                                                    <input type="radio" v-model="fuel_required" :value="1" id="fuel_required" name="fuel_required">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="fuel_required2">
                                                    No
                                                    <input type="radio" v-model="fuel_required" :value="0" id="fuel_required2" name="fuel_required">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col form-group mt-5" v-show="close">
                                        <label class="control-label">Unit Damaged on Return:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="damage_return">
                                                    Yes
                                                    <input type="radio" v-model="damage_return" :value="1" id="damage_return" name="damage_return">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="damage_return2">
                                                    No
                                                    <input type="radio" v-model="damage_return" :value="0" id="damage_return2" name="damage_return">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- create new insurance policy -->
                                <div id="workorder-detail work-order-view-top" class="admin-page-content work-order-view">
                                    <div class="wo-vendorinv-form invisible-icon" v-if="createNewPolicy">
                                        <insurance-policy-form :id="'createInsurancePolicy'" class="wo-vendorinv-panel" v-if="createNewPolicy" :policyFromAgreement="'policy_create'" :insuranceDataFromAgreement="dataForInsurance"></insurance-policy-form>
                                    </div>
                                </div>

                                <template v-if="!isTransferAgreement && (!close || onlyInsurance)">
                                    <hr class="light-hr" v-if="!onlyInsurance"/>
                                    <button type="submit" id="vendor_invoice" v-on:click.prevent="policyCreationForm('add')" class="btn btn-secondary pull-right" > Create New Policy</button>
                                    <h5 class="color-blue font-bold" v-show="!close">Insurance Details</h5>
                                    <div class="form-row row-cols-md-2 row-cols-1" v-if="!close">
                                        <template v-if="$route.params.id > 0 && customerInsuredLabel == 0">
                                        <div class="col form-group" v-if="$route.params.id > 0 && customerInsuredLabel == 0">
                                            <label class="control-label" for="unit_no">Customer Purchasing Insurance:&nbsp;&nbsp;
                                                <span class="active" v-if="customerInsuredLabel == 1">Yes</span>
                                                <span class="active" v-else>No</span>
                                            </label>
                                        </div>
                                        </template>
                                        <!-- <template v-if="!insAlreadyStored && !onlyinschargesAlreadyStored"> -->
                                        <div class="col form-group">
                                            <label class="control-label">Customer Purchasing Insurance :</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="customer_insured1"> Yes
                                                        <input type="radio" v-model="customer_insured" :value="1" id="customer_insured1" name="customer_insured" v-on:click="customerInsuredSelected(1)">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="customer_insured2"> No
                                                        <input type="radio" v-model="customer_insured" :value="0" id="customer_insured2" name="customer_insured" v-on:click="customerInsuredSelected(0)">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>

                                                <div v-if="!insAlreadyStored && !onlyinschargesAlreadyStored" class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="customer_insured3"> In Process
                                                        <input type="radio" v-model="customer_insured" :value="null" id="customer_insured3" name="customer_insured" v-on:click="addinsuranceNeeded()">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="field-error">{{customer_insured_error_msg}}</div>
                                            </div>
                                        </div>
                                        <!-- </template> -->
                                    </div>
                                    <!-- <div class="form-row row-cols-md-4 row-cols-1" v-if="customer_insured == 1 && !close && !onlyinschargesAlreadyStored && !insAlreadyStored"> -->
                                    <div class="form-row row-cols-md-4 row-cols-1" v-if="customer_insured == 1 && !close">
                                        <div class="col form-group" v-if="customer_insured == 1">
                                            <label class="control-label require" for="policy_type">Policy Type:</label>
                                            <v-select v-model="policy_type" name="policy_type" placeholder="Select Policy Type"
                                                        label="text"
                                                        :options="policyTypesArr" class="close-remove" @input="onPolicyTypeSelect($event)">
                                            </v-select>
                                            <div class="field-error">{{ policy_type_error_msg }}</div>
                                        </div>
                                        <div class="col form-group" v-if="customer_insured == 1 && $route.params.id == undefined">
                                            <label class="control-label require">Insurance From Date</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="insurance_from" name="insurance_from" v-model="insurance_from" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="insurance_from" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </div>
                                            <div class="field-error">{{insurance_from_error_msg}}</div>
                                        </div>
                                        <div class="col form-group" v-if="customer_insured == 1 && $route.params.id == undefined">
                                            <label class="control-label require">Insurance To Date</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="insurance_to" name="insurance_to" v-model="insurance_to" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="insurance_to" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </div>
                                            <div class="field-error">{{insurance_to_error_msg}}</div>
                                        </div>
                                    </div>
                                    <template v-if="$route.params.id > 0 && customerInsuredLabel == 1 && !close">
                                        <div class="form-row row-cols-md-2 row-cols-1">
                                            <div class="col form-group" v-if="$route.params.id > 0 && customerInsuredLabel == 1 && (insAlreadyStored || onlyinschargesAlreadyStored)">
                                                <label class="control-label" for="unit_no">Customer Purchasing Insurance:&nbsp;&nbsp;
                                                    <span class="active" v-if="customerInsuredLabel == 1">Yes</span>
                                                    <span class="active" v-else>No</span>
                                                </label>
                                            </div>
                                            <div class="col form-group" v-if="insAlreadyStored || onlyinschargesAlreadyStored">
                                                <label class="control-label" for="label_policy">Policy Type:&nbsp;&nbsp;
                                                    <span class="active">{{policyTypeLabel}}</span>
                                                </label>
                                            </div>

                                        </div>
                                        <template v-if="$route.params.id > 0 && customerInsuredLabel == 1">
                                            <!-- <div class="form-row row-cols-md-2 row-cols-1" v-if="!close && onlyinschargesAlreadyStored">
                                                <template v-if="$route.params.id > 0 && customerInsuredLabel == 0">
                                                <div class="col form-group" v-if="$route.params.id > 0 && customerInsuredLabel == 0">
                                                    <label class="control-label" for="unit_no">Customer Purchasing Insurance:&nbsp;&nbsp;
                                                        <span class="active" v-if="customerInsuredLabel == 1">Yes</span>
                                                        <span class="active" v-else>No</span>
                                                    </label>
                                                </div>
                                                </template>
                                                <div class="col form-group">
                                                    <label class="control-label">Customer Purchasing Insurance :</label>
                                                    <div class="custome-radiobtn">
                                                        <div class="form-check form-check-inline">
                                                            <label class="boolean optional radio-custom" for="customer_insured1"> Yes
                                                                <input type="radio" v-model="customer_insured" :value="1" id="customer_insured1" name="customer_insured" v-on:click="customerInsuredSelected(1)">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <label class="boolean optional radio-custom" for="customer_insured2"> No
                                                                <input type="radio" v-model="customer_insured" :value="0" id="customer_insured2" name="customer_insured" v-on:click="customerInsuredSelected(0)">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>

                                                        <div v-if="!insAlreadyStored && !onlyinschargesAlreadyStored" class="form-check form-check-inline">
                                                            <label class="boolean optional radio-custom" for="customer_insured3"> In Process
                                                                <input type="radio" v-model="customer_insured" :value="null" id="customer_insured3" name="customer_insured" v-on:click="addinsuranceNeeded()">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        <div class="field-error">{{customer_insured_error_msg}}</div>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <!-- <div class="form-row row-cols-md-4 row-cols-1" v-if="customer_insured == 1 && !close && onlyinschargesAlreadyStored">
                                                <div class="col form-group" v-if="customer_insured == 1">
                                                    <label class="control-label require" for="policy_type">Policy Type:</label>
                                                    <v-select v-model="policy_type" name="policy_type" placeholder="Select Policy Type"
                                                                label="text"
                                                                :options="policyTypesArr" class="close-remove" @input="onPolicyTypeSelect($event)">
                                                    </v-select>
                                                    <div class="field-error">{{ policy_type_error_msg }}</div>
                                                </div> -->
                                                <!-- <div class="col form-group" v-if="customer_insured == 1">
                                                    <label class="control-label require">Insurance From Date</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="insurance_from" name="insurance_from" v-model="insurance_from" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                        <label for="insurance_from" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                    </div>
                                                    <div class="field-error">{{insurance_from_error_msg}}</div>
                                                </div>
                                                <div class="col form-group" v-if="customer_insured == 1">
                                                    <label class="control-label require">Insurance To Date</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="insurance_to" name="insurance_to" v-model="insurance_to" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                        <label for="insurance_to" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                    </div>
                                                    <div class="field-error">{{insurance_to_error_msg}}</div>
                                                </div> -->
                                            <!-- </div> -->
                                            <div class="form-row row-cols-md-5 row-cols-1">
                                                <template v-if="policyTypeLabel.toLowerCase() == 'physical' || policyTypeLabel.toLowerCase() == 'both'">
                                                    <div class="col form-group">
                                                        <label class="control-label require" for="label_insurance_from">Physical From Date:</label>
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" id="physical_from" name="physical_from" v-model="physical_from" :config="optionsDateInsuranceFromLabel" aria-describedby="basic-addon3" :disabled="disableInsuranceFromDate"></date-picker>
                                                            <label for="physical_from" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                        </div>
                                                        <div class="field-error">{{physical_from_error_msg}}</div>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label class="control-label require" for="label_insurance_to">Physical To Date:</label>
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" id="physical_to" name="physical_to" v-model="physical_to" :config="optionsDateInsuranceToLabel" aria-describedby="basic-addon3" :disabled="disableInsuranceDates"></date-picker>
                                                            <label for="physical_to" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                        </div>
                                                        <div class="field-error">{{physical_to_error_msg}}</div>
                                                    </div>
                                                </template>
                                                <template v-if="policyTypeLabel.toLowerCase() == 'liability' || policyTypeLabel.toLowerCase() == 'both'">
                                                    <div class="col form-group">
                                                        <label class="control-label require" for="label_insurance_from">Liability From Date:</label>
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" id="liability_from" name="liability_from" v-model="liability_from" :config="optionsDateInsuranceFromLabel" aria-describedby="basic-addon3" :disabled="disableInsuranceFromDate"></date-picker>
                                                            <label for="liability_from" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                        </div>
                                                        <div class="field-error">{{liability_from_error_msg}}</div>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label class="control-label require" for="label_insurance_to">Liability To Date:</label>
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" id="liability_to" name="liability_to" v-model="liability_to" :config="optionsDateInsuranceToLabel" aria-describedby="basic-addon3" :disabled="disableInsuranceDates"></date-picker>
                                                            <label for="liability_to" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                                        </div>
                                                        <div class="field-error">{{liability_to_error_msg}}</div>
                                                    </div>
                                                </template>
                                                <div class="col form-group mt-4" v-if="policyTypeLabel != ''">
                                                    <button type="submit" class="btn btn-primary" v-on:click.prevent="changeInsuranceDetails()" v-if="customerInsuredLabel == 1">
                                                        <i class="fp-edit-icon"> </i>Update
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- <div class="form-row row-cols-md-4 row-cols-1">
                                                <div class="col form-group" v-if="chargesLabelArr && chargesLabelArr.length > 0">
                                                    <label class="control-label" for="label_charges">Charges:
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="table-responsive-sm" v-if="chargesLabelArr && chargesLabelArr.length > 0">
                                                <table aria-describedby="table" class="table table-sm table-bordered">
                                                    <thead>
                                                        <tr class="table-primary">
                                                            <th scope="col" style="width:300px;">Charge Name</th>
                                                            <th scope="col">Days</th>
                                                            <th scope="col">Charge</th>
                                                            <th scope="col">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(row, index) in chargesLabelArr">
                                                            <tr v-if="row.physical_ins_charges != undefined" :key="'physical_ins1' + index">
                                                                <td scope="col">{{row.phy_charges_name}}</td>
                                                                <td scope="col">{{row.days}} Days</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.physical_ins_charges)}}</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.physical_ins_total)}}</td>
                                                            </tr>
                                                            <tr v-if="row.physical_admin_charges != undefined" :key="'physical_admin1' + index">
                                                                <td scope="col">{{row.phy_admincharges_name}}</td>
                                                                <td scope="col">-</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.physical_admin_charges)}}</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.physical_admin_total)}}</td>
                                                            </tr>
                                                            <tr v-if="row.liability_insurance_charges != undefined" :key="'liability_ins1' + index">
                                                                <td scope="col">{{row.lia_insurance_name}}</td>
                                                                <td scope="col">{{row.days}} Days</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.liability_insurance_charges)}}</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.liability_insurance_total)}}</td>
                                                            </tr>
                                                            <tr v-if="row.liability_admin_charges != undefined" :key="'liability_admin1' + index">
                                                                <td scope="col">{{row.lia_admincharges_name}}</td>
                                                                <td scope="col">-</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.liability_admin_charges)}}</td>
                                                                <td scope="col" class="text-right">${{amountFormat(row.liability_admin_total)}}</td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div> -->
                                        </template>
                                        <!-- <div class="form-row row-cols-md-2 row-cols-1">
                                            <div class="col" v-if="policyLabelArr && policyLabelArr.length > 0">
                                                <label class="control-label" for="label_policy">Insurance Policy:</label>
                                            </div>
                                        </div>
                                        <div class="table-responsive" v-if="policyLabelArr && policyLabelArr.length > 0">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th scope="col" style="width:10px;" v-if="addInsurancePolicy"></th>
                                                        <th style="width:60px;">Policy Number</th>
                                                        <th>Insurance Company</th>
                                                        <th>Agent Name</th>
                                                        <th>Agent Contact</th>
                                                        <th>Status</th>
                                                        <th>Start Date</th>
                                                        <th>Expiry Date</th>
                                                        <th>Blanket Policy</th>
                                                        <th>Policy Type</th>
                                                        <th>Self Insured For</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, index) in policyLabelArr" :key="'policy' + index">
                                                        <template v-if="addInsurancePolicy">
                                                            <td scope="col" style="width:10px;" v-if="row.status.toLowerCase() == 'active'">
                                                                <input type="checkbox" :id="'selectCheckbox' + index" @input="policySelect($event,row,index)"/>
                                                            </td>
                                                            <td scope="col" style="width:10px;" v-else>&nbsp;&nbsp;</td>
                                                        </template>
                                                        <td  style="width:60px;">{{row.policy_number}}</td>
                                                        <td>{{row.insurance_company_name}}</td>
                                                        <td>{{row.agent_name}}</td>
                                                        <td>{{row.agent_contact}}</td>
                                                        <td>{{row.status}}</td>
                                                        <td>{{row.start_date}}</td>
                                                        <td>{{row.expiry_date}}</td>
                                                        <td v-if="row.is_rental_blanket == 1">Yes</td>
                                                        <td v-else>No</td>
                                                        <td>{{row.policy_type}}</td>
                                                        <td>{{row.self_insured_for}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div> -->
                                    </template>
                                    <template v-if="!close">
                                        <label class="control-label" for="charges_title" v-if="insuranceChargesArr && insuranceChargesArr.length > 0">Charges:</label>
                                        <div class="table-responsive-sm" v-if="insuranceChargesArr && insuranceChargesArr.length > 0">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th style="width:300px;">Charge Name</th>
                                                        <th>Days</th>
                                                        <th>Charge</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(row, index) in insuranceChargesArr">
                                                        <tr v-if="row.physical_ins_charges != undefined" :key="'physical_ins' + index">
                                                            <td scope="col" >{{row.phy_charges_name}}</td>
                                                            <td scope="col">{{row.days}} Days</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_ins_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_ins_total)}}</td>
                                                        </tr>
                                                        <tr v-if="row.physical_admin_charges != undefined" :key="'physical_admin' + index">
                                                            <td scope="col" >{{row.phy_admincharges_name}}</td>
                                                            <td scope="col">-</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_admin_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_admin_total)}}</td>
                                                        </tr>

                                                        <tr v-if="row.liability_insurance_charges != undefined" :key="'liability_ins' + index">
                                                            <td scope="col" >{{row.lia_insurance_name}}</td>
                                                            <td scope="col">{{row.days}} Days</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_insurance_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_insurance_total)}}</td>
                                                        </tr>
                                                        <tr v-if="row.liability_admin_charges != undefined" :key="'liability_admin' + index">
                                                            <td scope="col" >{{row.lia_admincharges_name}}</td>
                                                            <td scope="col">-</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_admin_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_admin_total)}}</td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                        <label class="control-label" for="insurance_policy_title" v-if="insurancePolicyArr && insurancePolicyArr.length > 0">Insurance Policy:</label>
                                        <div class="btn-groups badge-buttons text-left mb-3" v-if="insurancePolicyArr && insurancePolicyArr.length > 0">
                                            <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                                <button type="button" id="getFixedConfig" v-on:click="policyView = 'active';actPolicy = 'active';expPolicy = ''" :class="'btn btn-secondary ' +actPolicy"> Active </button>
                                                <button type="button" id="getDistConfig" v-on:click="expiredPolicy" :class="'btn btn-secondary ' +expPolicy"> Expired </button>
                                            </div>
                                        </div>
                                        <div class="table-responsive" v-if="insurancePolicyArr && insurancePolicyArr.length > 0">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th style="width:10px;"></th>
                                                        <th style="width:60px;">Policy Number</th>
                                                        <th>Insurance Company</th>
                                                        <th>Agent Name</th>
                                                        <th>Agent Contact</th>
                                                        <th>Status</th>
                                                        <th>Start Date</th>
                                                        <th>Expiry Date</th>
                                                        <th>Blanket Policy</th>
                                                        <th>Policy Type</th>
                                                        <th>Self Insured For</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, index) in insurancePolicyArr" :key="index" v-show="((row.status == 'Active' && policyView == 'active') || (row.status != 'Active' && policyView == 'expired')) ? true : false ">
                                                        <!-- <div v-show="((row.status == 'Active' && policyView == 'active') || row.status != 'Active' && policyView == 'expired') ? true : false "> -->
                                                            <td scope="col" style="width:10px;" v-if="row.status.toLowerCase() == 'active'"><!-- Active Policy allowed to select-->
                                                                <input type="checkbox" :id="'selectCheckbox' + index" @input="clickRows($event,row,index)"/>
                                                            </td>
                                                            <td scope="col" style="width:10px;" v-else>&nbsp;&nbsp;</td>
                                                            <td scope="col" style="width:60px;">{{row.policy_number}}</td>
                                                            <td scope="col">{{row.insurance_company_name}}</td>
                                                            <td scope="col">{{row.agent_name}}</td>
                                                            <td scope="col">{{row.agent_contact}}</td>
                                                            <td scope="col">{{row.status}}</td>
                                                            <td scope="col">{{row.start_date}}</td>
                                                            <td scope="col">{{row.expiry_date}}</td>
                                                            <td scope="col" v-if="row.is_rental_blanket == 1">Yes</td>
                                                            <td scope="col" v-else>No</td>
                                                            <td scope="col">{{row.policy_type}}</td>
                                                            <td scope="col">{{row.self_insured_for}}</td>
                                                        <!-- </div> -->
                                                    </tr>
                                                    <tr>
                                                        <td colspan="11" v-show="(expiredFound == 'no' && policyView != 'active')">No Policy Available.</td>
                                                        <td colspan="11" v-show="(activeFound == 'no' && policyView != 'expired')">No Policy Available.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                    <!--Insurance Certificate -->
                                    <div class="form-row row-cols-md-2 row-cols-1" v-if="(customer_insured == 1 && showDropZone && !close)">
                                        <div class="col form-group">
                                            <label class="control-label require" for="documents">Insurance Certificate (.jpg, .jpeg, .png and .pdf files are allowed)</label>
                                            <vue-dropzone
                                                id="insuranceCertificate"
                                                :options="insCertDropzoneOptions"
                                                :destroyDropzone=false
                                                ref="insuranceCertificate"
                                                :headers="insCertDropzoneOptions.headers"
                                                @vdropzone-files-added="manuallyAddFile"
                                                @vdropzone-complete="afterUploadComplete"
                                                @vdropzone-success="storeInsuranceCertificate"
                                                @vdropzone-removed-file="removeInsuranceCertificate"
                                                >
                                            </vue-dropzone>
                                            <div class="field-error">{{insurance_certificate_error_msg}}</div>
                                        </div>
                                    </div>
                                    <div class="form-row row-cols-md-2 row-cols-1" v-if="previewCertificates.length > 0">
                                        <div class="col form-group">
                                            <label class="control-label" for="attachments">Attachments</label>
                                            <template  v-for="(uFile,fKey) in previewCertificates">
                                                <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                    <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                    <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                        {{ uFile['display_name'] }}
                                                    </a>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);">
                                                        <i class="fp-close"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </div>
                                    </div>

                                    <!-- Show Message If No Policy Found on basis of Customer Purchasing Insurance -->
                                    <div class="field-error" v-if="noInsPolicyFound && addInsurancePolicy">
                                        <template v-if="customer_insured == 1">
                                            <template v-if="policy_type.value != undefined">
                                                <template v-if="policy_type.value == 'physical'">
                                                    <span v-if="notfoundPolicyMessage == 'not_valid'">The policy you have created is not applicable to this agreement please <a href="javascript:void(0)" v-on:click="policyCreationForm" style="color:blue">Click Here</a> to update.</span>
                                                    <span v-else>No Physical Policy Found For Customer.</span>
                                                </template>
                                                <template v-else-if="policy_type.value == 'liability'">
                                                    <span v-if="notfoundPolicyMessage == 'not_valid'">The policy you have created is not applicable to this agreement please <a href="javascript:void(0)" v-on:click="policyCreationForm" style="color:blue">Click Here</a> to update.</span>
                                                    <span v-else>No liability Policy Found For Customer.</span>
                                                </template>
                                                <template v-else>
                                                    <span v-if="notfoundPolicyMessage == 'not_valid'">The policy you have created is not applicable to this agreement please <a href="javascript:void(0)" v-on:click="policyCreationForm" style="color:blue">Click Here</a> to update.</span>
                                                    <span v-else>No Insurance Policy Found For Customer.</span>
                                                </template>
                                            </template>
                                        </template>
                                    </div>
                                    <div class="field-error" v-if="noInsPolicyFound">
                                        <template v-if="customer_insured == 1">
                                            <template v-if="policy_type.value != undefined">
                                                <template v-if="policy_type.value == 'physical'">
                                                    <span v-if="notfoundPolicyMessage == 'not_valid'">The policy you have created is not applicable to this agreement please <a href="javascript:void(0)" v-on:click="policyCreationForm" style="color:blue">Click Here</a> to update.</span>
                                                    <span v-else>No Liability Policy Found For Customer.</span>
                                                </template>
                                                <template v-else-if="policy_type.value == 'liability'">
                                                    <span v-if="notfoundPolicyMessage == 'not_valid'">The policy you have created is not applicable to this agreement please <a href="javascript:void(0)" v-on:click="policyCreationForm" style="color:blue">Click Here</a> to update.</span>
                                                    <span v-else>No Physical Policy Found For Customer.</span>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else-if="customer_insured == 0">

                                            <span v-if="notfoundPolicyMessage == 'not_valid'">The policy you have created is not applicable to this agreement please <a href="javascript:void(0)" v-on:click="policyCreationForm" style="color:blue">Click Here</a> to update.</span>
                                            <span v-else>{{notfoundPolicyMessage}}</span>
                                        </template>
                                    </div>
                                </template>
                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateRentalAgreementBtn"  v-if="$route.params.id > 0 && from === 'return' && isTransferCheck === false" class="btn btn-primary" v-on:click.prevent="CreateRentalAgreement('post')" >
                                    <i class="fp-reload"> </i>  Update And Post Invoice
                                    </button>
                                    <button type="submit" id="CreateRentalAgreementBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateRentalAgreement" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateRentalAgreementBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateRentalAgreement">
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelRentalAgreementBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                            <!-- <app-program-trigger ref="triggerEnable" v-show="displaySchedule"></app-program-trigger> -->
                        </section>
                        <div class="modal fade make-bill-date-modal" id="postInvoiceModal" ref="postInvoiceModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Post Invoice</h5>
                                        <button type="button" class="close" id="btnBillModalClose" v-on:click="hideBillModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row">
                                            <div class="col form-group">
                                                <label class="control-label require" for="bill_date">Bill Date:</label>
                                                <div class="input-group">
                                                    <date-picker placeholder="MM/DD/YYYY" id="bill_date" name="bill_date" v-model="bill_date" :config="optionsDate"></date-picker>
                                                    <label for="bill_date" class="fp-calendar input-calender-icon"></label>
                                                </div>
                                                <div class="field-error">{{ bill_date_error }}</div>
                                            </div>
                                        </div>
                                        <div class="table-responsive-sm">
                                                <table aria-describedby="table" class="table table-sm table-bordered">
                                                    <thead>
                                                        <tr class="table-primary">
                                                            <th>Unit No.</th>
                                                            <th>Section/Charge</th>
                                                            <th class="text-right">Billed Days</th>
                                                            <th class="text-right">Billing Rate</th>
                                                            <th class="text-center">&nbsp;&nbsp;</th>
                                                            <th class="text-right">Billed Amount</th>
                                                            <!-- <th class="text-right">Billed Taxes</th> -->
                                                            <th class="text-center">Selected</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="billingArr && billingArr.length > 0">
                                                            <template v-for="(bill, index) in billingArr">
                                                                <tr v-bind:key="'recordRow'+index">
                                                                    <td>{{bill.unit_no}}</td>
                                                                    <td>{{bill.description}}</td>
                                                                    <td class="text-right">{{bill.billed_days}}</td>
                                                                    <td class="text-right">{{bill.rate}}</td>
                                                                    <td class="text-center">{{bill.per_value}}</td>
                                                                    <td class="text-right">{{bill.billed_amount}}</td>
                                                                    <!-- <td class="text-right">{{bill.taxes}}</td> -->
                                                                    <td class="text-center">{{bill.selected}}</td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <tr><td colspan="8" class="no-data-field">No Record Found</td></tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                                <p style="color:red" v-if="!amountFound">No billing found. You can close the agreement by clicking on Close</p>
                                            </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="btnPostInvoiceModalProcess" v-if="amountFound" v-on:click="postInvoice()"> Post Invoice </button>
                                        <button class="btn btn-primary" v-if="!amountFound" id="btnPostInvoiceModalClose" v-on:click="closeAgreement()"> Close </button>
                                        <button class="btn btn-tertiary" id="btnPostInvoiceModalCancel" v-on:click="hideBillModal()"> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="isClosedAgreement === true && !canEditAfterClose">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          Rental Agreement Close </h2>
                      <div class="error-details">
                          Agreement Already Closed.
                      </div>
                  </div>
              </div>
          </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';

// import ProgramTrigger from "@/components/ProgramTrigger.vue";
import {contractMixins} from '../mixins/contractMixins';
//Vue DropZone
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

// Vue.component("app-program-trigger", ProgramTrigger);
import moment from 'moment';

export default {
  name: "RentalAgreementCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Rental Agreement | " +process.env.COPYRIGHT_NAME : "Create Rental Agreement | " +process.env.COPYRIGHT_NAME
    }
  },
  components: {
        vueDropzone: vue2Dropzone,
        // appProgramTrigger: () => import('@/components/ProgramTrigger')
    },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    isDisableVehicle: false,
    osrPO: '',
    osrPOArr: [],
    osr_po_error_msg: '',
    isEdit:false,
    isClosedAgreement:false,
    // optionsDate: {
    //     format: 'MM/DD/YYYY',
    //     useCurrent: false,
    // },
    availableAssetArr:[],
    permissions: [],
    cantAccessPage: "",
    code: "",
    code_error_msg: "",
    contract_type_id: null,
    contracttypeArr: [],
    contract_type_error_msg: "",
    source: "",
    po: "",
    customer_id: null,
    customerArr: [],
    customererrors: "",
    vehicle_type_id: null,
    vehicletypeArr: [],
    vehicle_type_error_msg: "",
    vehicle_id: null,
    vehicleArr: [],
    vehicle_error_msg: "",
    state: null,
    stateArr: [],
    reason: "",

    due_out_date: "",
    due_out_time: "",
    due_out_datetime_error_msg: "",
    due_out_location_id: null,
    dueoutlocationArr: [],
    due_out_location_error_msg: "",

    due_in_date: "",
    due_in_time: "",
    due_in_datetime_error_msg: "",
    due_in_location_id: null,
    dueinlocationArr: [],
    due_in_location_error_msg: "",

    // charge_from_date: "",
    // charge_from_time: "",
    // charge_from_datetime_error_msg: "",
    // charge_from_location_id: null,
    // chargefromlocationArr: [],
    // charge_from_location_error_msg: "",
    // charge_to_date : "",
    // charge_to_time: "",
    // charge_to_datetime_error_msg: "",
    planned_in_date: "",
    planned_in_time: "",
    actual_to_time: "",
    actual_from_time: "",
    actual_from_date:'',
    actual_to_date:'',
    planned_in_datetime_error_msg: "",
    actual_to_datetime_error_msg: "",
    actual_from_datetime_error_msg: "",

    customer_insured: null,
    insurance_company_id: null,
    insurancecompanyArr: [],
    loading:false,
    reservationArr:[],
    TrucksArr:[],
    //estimatedMiles:'',
    mileserror_msg:'',
    reservationerror:'',
    resId:'',
    firstLoad: 0,
    readingIn:0,
    readingOut:0,
    reading_in_msg:'',
    reading_out_msg:'',
    distance:0,
    poArr:[],
    watchCall:0,
    notes:'',
    is_substitute:false,
    checkPolicies:1,
    consolidated:true,
    sectionArr:[],
    reading_date:'',
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    optionsDateTime:{
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: true,
        showClose:true
    },
    reading_out_error_msg:'',
    reading_date_error_msg:'',
    reading_in_error_msg:'',
    reading_in:'',
    reading_out:'',
    section_error:'',
    section:'',
    rows:[],
    agreement_id:'',
    unitArr:[],
    readInArr:[],
    from:'',
    close:false,
    enrich_code:'',
    credit_approved_msg:"",
    creditClass:"field-error",
    customer_insured_error_msg:"",
    policy_type:"",
    policy_type_error_msg:"",
    insurancePolicyArr:[],
    insuranceChargesArr:[],
    insPolicyArr:[],
    common_error_msg:"",
    actualFrom:false,
    actualTo:false,
    fromVehicle:false,
    fillValues:false,
    insurance_from:"",
    insurance_from_error_msg:"",
    insurance_to:"",
    insurance_to_error_msg:"",
    insuranceFrom:false,
    insuranceTo:false,
    noInsPolicyFound:false,
    customerInsuredLabel:"",
    policyTypeLabel:"",
    physical_from:"",
    physical_to:"",
    chargesLabelArr:[],
    policyLabelArr:[],
    insDetailLink:false,
    optionsDateInsuranceFrom:{
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    optionsDateInsuranceTo:{
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    optionsDateInsuranceFromLabel:{
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    optionsDateInsuranceToLabel:{
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    disableInsuranceDates:false,
    disableInsuranceFromDate:false,
    addInsurancePolicy:false,
    liability_from:"",
    liability_to:"",
    liability_from_error_msg:"",
    liability_to_error_msg:"",
    physical_from_error_msg:"",
    physical_to_error_msg:"",
    existingPolicyArr:[],
    actualFromChange:false,
    actualToChange:false,
    physicalTo:false,
    liabilityTo:false,
    dateChange:false,
    contract_asset_id:"",
    activeContractsArr:[],
    contract_asset_error_msg:"",
    showFields:false,
    isChargeDate:false,
    due_out_time_error_msg:"",
    due_in_time_error_msg:"",
    // charge_from_time_error_msg:"",
    // charge_to_time_error_msg:"",
    actual_from_time_error_msg:"",
    actual_to_time_error_msg:"",
    planned_in_time_error_msg:"",
    showDropZone:false,
    insCertDropzoneOptions: {
        url: process.env.ROOT_API +"/store-insurance-certificate",
        method: 'POST',
        maxFilesize: 5.00, //MB
        maxFiles: 2,
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        headers: {
            'Accept': 'application/json',
            "Authorization": "Bearer "+localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
        },
        dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
        destroyDropzone:false,
        dictDefaultMessage: "Drop files here to upload. Files upto maximum 5 MB size are allowed.",
    },
    insCertificateFiles:[],
    validateCertificates:[],
    previewCertificates:[],
    insurance_certificate_error_msg:"",
    requiredFlag:'',
    customer_po_error_msg:'',
    external_document:'no',
    due_out_ampm:{value:"am",text:"AM"},
    due_in_ampm:{value:"am",text:"AM"},
    actual_from_ampm:{value:"am",text:"AM"},
    actual_to_ampm:{value:"am",text:"AM"},
    planned_in_ampm:{value:"am",text:"AM"},
    insAlreadyStored:false,
    onlyinschargesAlreadyStored:false,
    insuranceNeeded:true,
    alreadyReturned:false,
    requested_vehicle_type_id:'',
    requested_vehicle_type_error_msg:'',
    firstAssetSelected:false,
    isTransferAgreement:false,
    disableContractType:false,
    is_national_lease:0,
    fuel_required:0,
    damage_return:0,
    is_future_rate_adj:0,
    is_contract_available:1,
    sub_unit_error_msg:'',
    sub_unit:'',
    leaseVehicleArr:[],
    disableFields:false,
    osrSelection:false,
    displaySchedule:false,
    vehicleId:'',
    miles:'',
    onlyChargeUpdate:false,
    chargeDateChange:0,
    canEditAfterClose:false,
    toDueInDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false
    },
    toActualInDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
        maxDate: new Date()
    },
    toPlannedInDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    toDueOutDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false
    },
    toActualFromDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
        maxDate: new Date()
    },
    columns:[
            {
                label: 'Asset',
                field: 'unit_no',
                width:'auto',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Asset', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Type',
                field: 'asset_type',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Type', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            // {
            //     label: 'Location',
            //     field: 'location',
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: 'Location', // placeholder for filter input
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.columnFilterFn, //custom filter function that
            //         trigger: 'enter', //only trigger on enter not on keyup
            //     },
            //     sortable:true
            // },
            // {
            //     label: 'Pool',
            //     field: 'pool',
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: 'Pool', // placeholder for filter input
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.columnFilterFn, //custom filter function that
            //         trigger: 'enter', //only trigger on enter not on keyup
            //     },
            //     sortable:true
            // },
            // {
            //     label: 'Status',
            //     field: 'status',
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: 'Status', // placeholder for filter input
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.columnFilterFn, //custom filter function that
            //         trigger: 'enter', //only trigger on enter not on keyup
            //     },
            //     sortable:true
            // },
            // {
            //     label: 'Asset Group',
            //     field: 'group',
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: 'Asset Group', // placeholder for filter input
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.columnFilterFn, //custom filter function that
            //         trigger: 'enter', //only trigger on enter not on keyup
            //     },
            //     sortable:true
            // },

        ],
        totalRecords:0,
        checkAvailabilityFlag:false,
        reqClass:'',
        bill_date:'',
        bill_date_error:'',
        billingArr:[],
        createNewPolicy:false,
        dataForInsurance:{},
        notfoundPolicyMessage:'No Insurance Policy Found For Customer.',
        attachedInsPol:'',
        policyView:'active',
        expPolicy:'',
        actPolicy:'active',
        expiredFound:'no',
        activeFound:'no',
        unitReserved:false,
        resLoad:false,
        onlyInsurance:false,
        isRequired:'require',
        isTransferCheck: false,
        customer_comment:'',
        postOnce:0,
        subTypeArr:[{text:'Lease Sub',value:'lease'},{text:'Rental Sub',value:'rental'},{text:'Unit Sub',value:'unit'}],
        sub_type:'',
        sub_agreement_error_msg:'',
        sub_type_error_msg:'',
        sub_agreement:'',
        rentalAgreementArr:[],
        postBillOnce : 0,
        amountFound:false
  }),
  watch:{

        disableContractType: function(disableContractType) {
          this.isDisableVehicle = disableContractType
        },

        due_out_location_id: function(locId){

            var self  = this;

            if(locId != null && locId.value != undefined){

                // self.charge_from_location_id = self.due_out_location_id;

            }
        },

        source: function(resId,oldId){

            var self = this;

            // if( self.$route.params.id == undefined){
            //     self.getAgreementCode();
            // }

            self.watchCall = 1;

            if( self.$route.query.id != undefined && resId != null && resId.value != undefined && oldId.value != resId.value ) {
                //self.getReservationData(resId.value);

            }
        },
        due_in_date: function(date){

            var self  = this;

            var path = window.location.pathname;
            var segments = path.split("/");
            // alert(date);
            if ( date != null && date != undefined ) {

                if(!segments[3]){

                    // self.charge_to_date = date;
                    self.planned_in_date = date;
                    // self.actual_to_date = date;
                }

                setTimeout(function(){
                    if ( self.checkPolicies == 1 ) {
                        setTimeout(function(){

                            // self.getInsurancePolicies('');

                        },2000);
                    } else {
                        self.checkPolicies = 1;
                    }

                },400);

            }
             //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.actualTo) {
                return;
            }else{
                //restrict insurance from and insurance to date selection between actual from and actual to
                if (self.customer_insured == 1 && !self.close) {
                    if (self.due_in_date != null && self.due_in_date != "") {
                        self.optionsDateInsuranceFrom.maxDate = self.due_in_date;
                        self.optionsDateInsuranceTo.maxDate = self.due_in_date;
                    }
                    if (self.$route.params.id > 0) {
                        // var policy_type = self.policyTypeLabel.toLowerCase();
                        // if (policy_type == "physical" || policy_type == "both") {
                        //     self.physical_to = self.actual_to_date;
                        // }
                        // if (policy_type == "liability" || policy_type == "both") {
                        //     self.liability_to = self.actual_to_date;
                        // }
                        // self.addInsurancePolicy = true;
                        self.actualToChange = true;
                        self.disableInsuranceDates = false;
                        self.dateChange = true;
                        //actual to date changed
                        // if (policy_type == "physical") {
                        //     self.fetchInsurancePolicy("physical-both");
                        // }else if (policy_type == "liability") {
                        //     self.fetchInsurancePolicy("liability-both");
                        // }else{
                        //     self.fetchInsurancePolicy("both");
                        //     // self.addInsurancePolicy = false;
                        // }
                    }else{
                        if (self.due_in_date != null && self.due_in_date != "") {
                            self.insurance_to = self.due_in_date;
                        }
                        self.refreshInsurancePolicy(); //refresh insurance policy and charges
                    }
                }else if (self.customer_insured == 0 && !self.close){
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
        },
        due_out_date: function(date){

            var self  = this;

            var path = window.location.pathname;
            var segments = path.split("/");
            //Commented Below line Bcz Agreement is never for one day
            // self.due_in_date=moment(date).add(1,'days').format("MM/DD/YYYY");
            if ( date != null && date != undefined && !segments[3] ) {

                // self.actual_from_date = date;
                if(self.osrPO == null || self.osrPO == "") {
                  self.vehicle_id = '';
                  self.vehicleArr = [];
                }

                // self.charge_from_date = date;
            }
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.actualFrom) {
                return;
            }else{
                //restrict insurance from and insurance to date selection between actual from and actual to
                if (self.customer_insured == 1) {
                    if (self.due_out_date != null && self.due_out_date != "") {
                        self.optionsDateInsuranceFrom.minDate = self.due_out_date;
                        self.optionsDateInsuranceTo.minDate = self.due_out_date;
                    }
                    if (self.$route.params.id > 0) {
                        // var policy_type = self.policyTypeLabel.toLowerCase();
                        // if (policy_type == "physical" || policy_type == "both") {
                        //     self.physical_from = self.actual_from_date;
                        // }
                        // if (policy_type == "liability" || policy_type == "both") {
                        //     self.liability_from = self.actual_from_date;
                        // }
                        // self.addInsurancePolicy = true;
                        self.actualFromChange = true;
                        // self.disableInsuranceDates = false;
                        self.dateChange = true;
                        //actual from date changed
                        // if (policy_type == "physical") {
                        //     self.fetchInsurancePolicy("physical-both");
                        // }else if (policy_type == "liability") {
                        //     self.fetchInsurancePolicy("liability-both");
                        // }else{
                        //     self.fetchInsurancePolicy("both");
                        //     self.addInsurancePolicy = false;
                        // }
                    }else{
                        if (self.due_out_date != null && self.due_out_date != "") {
                            self.insurance_from = self.due_out_date;
                        }
                        self.refreshInsurancePolicy(); //refresh insurance policy and charges
                    }
                }else if (self.customer_insured == 0){
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
            // self.planned_out_date = date;
        },
        actual_from_date: function() {
            var self = this;
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.actualFrom) {
                return;
            }else{
                //restrict insurance from and insurance to date selection between actual from and actual to
                if (self.customer_insured == 1) {
                    if (self.actual_from_date != null && self.actual_from_date != "") {
                        self.optionsDateInsuranceFrom.minDate = self.actual_from_date;
                        self.optionsDateInsuranceTo.minDate = self.actual_from_date;
                    }
                    if (self.$route.params.id > 0) {
                        // var policy_type = self.policyTypeLabel.toLowerCase();
                        // if (policy_type == "physical" || policy_type == "both") {
                        //     self.physical_from = self.actual_from_date;
                        // }
                        // if (policy_type == "liability" || policy_type == "both") {
                        //     self.liability_from = self.actual_from_date;
                        // }
                        // self.addInsurancePolicy = true;
                        self.actualFromChange = true;
                        // self.disableInsuranceDates = false;
                        self.dateChange = true;
                        //actual from date changed
                        // if (policy_type == "physical") {
                        //     self.fetchInsurancePolicy("physical-both");
                        // }else if (policy_type == "liability") {
                        //     self.fetchInsurancePolicy("liability-both");
                        // }else{
                        //     self.fetchInsurancePolicy("both");
                        //     self.addInsurancePolicy = false;
                        // }
                    }else{
                        if (self.actual_from_date != null && self.actual_from_date != "") {
                            self.insurance_from = self.actual_from_date;
                        }
                        self.refreshInsurancePolicy(); //refresh insurance policy and charges
                    }
                }else if (self.customer_insured == 0){
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
        },
        actual_to_date: function() {
            var self = this;
            if ((!self.alreadyReturned) && (self.close == true || (self.$route.params.id != undefined && self.$route.params.id > 0))){
                if (self.readInArr.length){
                    for (var i = 0; i < self.readInArr.length; i++) {

                        self.readInArr[i].reading_in_date = moment(self.actual_to_date+' '+self.actual_to_time+' '+self.actual_to_ampm.value).format("MM/DD/YYYY hh:mm:ss a");

                    }
                }
            }
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.actualTo) {
                return;
            }else{
                //restrict insurance from and insurance to date selection between actual from and actual to
                if (self.customer_insured == 1 && !self.close) {
                    if (self.actual_to_date != null && self.actual_to_date != "") {
                        self.optionsDateInsuranceFrom.maxDate = self.actual_to_date;
                        self.optionsDateInsuranceTo.maxDate = self.actual_to_date;
                    }
                    if (self.$route.params.id > 0) {
                        // var policy_type = self.policyTypeLabel.toLowerCase();
                        // if (policy_type == "physical" || policy_type == "both") {
                        //     self.physical_to = self.actual_to_date;
                        // }
                        // if (policy_type == "liability" || policy_type == "both") {
                        //     self.liability_to = self.actual_to_date;
                        // }
                        // self.addInsurancePolicy = true;
                        self.actualToChange = true;
                        self.disableInsuranceDates = false;
                        self.dateChange = true;
                        //actual to date changed
                        // if (policy_type == "physical") {
                        //     self.fetchInsurancePolicy("physical-both");
                        // }else if (policy_type == "liability") {
                        //     self.fetchInsurancePolicy("liability-both");
                        // }else{
                        //     self.fetchInsurancePolicy("both");
                        //     // self.addInsurancePolicy = false;
                        // }
                    }else{
                        if (self.actual_to_date != null && self.actual_to_date != "") {
                            self.insurance_to = self.actual_to_date;
                        }
                        self.refreshInsurancePolicy(); //refresh insurance policy and charges
                    }
                }else if (self.customer_insured == 0 && !self.close){
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
        },
        actual_to_time: function() {
            var self = this;

            if ((!self.alreadyReturned) && (self.close == true || (self.$route.params.id != undefined && self.$route.params.id > 0))){
                if (self.readInArr.length){
                    for (var i = 0; i < self.readInArr.length; i++) {

                        self.readInArr[i].reading_in_date = moment(self.actual_to_date+' '+self.actual_to_time+' '+self.actual_to_ampm.value).format("MM/DD/YYYY hh:mm:ss a");

                    }
                }
            }
        },
        actual_to_ampm:function(){
            var self = this;
            if ((!self.alreadyReturned) && (self.close == true || (self.$route.params.id != undefined && self.$route.params.id > 0))){
                if (self.readInArr.length){
                    for (var i = 0; i < self.readInArr.length; i++) {

                        self.readInArr[i].reading_in_date = moment(self.actual_to_date+' '+self.actual_to_time+' '+self.actual_to_ampm.value).format("MM/DD/YYYY hh:mm:ss a");

                    }
                }
            }
        },
        insurance_from: function() {
            var self = this;
            self.insurance_from_error_msg = "";
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.insuranceFrom) {
                return;
            }else{
                if (self.customer_insured == 1) {
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
        },
        insurance_to: function() {
            var self = this;
            self.insurance_to_error_msg = "";
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.insuranceTo) {
                return;
            }else{
                if (self.customer_insured == 1) {
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
        },
        physical_to: function() {
            var self = this;
            self.physical_to_error_msg = "";
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.physicalTo) {
                return;
            }else{
                if (self.policyTypeLabel != "") {
                    self.isChargeDate = true;
                    if (!self.actualToChange) {
                        if (self.policyTypeLabel.toLowerCase() == "physical") {
                            // self.fetchInsurancePolicy("physical"); //refresh insurance policy and charges
                        }else if (self.policyTypeLabel.toLowerCase() == "both") {
                            // self.fetchInsurancePolicy("both"); //refresh insurance policy and charges
                        }
                    }
                }
            }
        },
        liability_to: function() {
            var self = this;
            self.physical_to_error_msg = "";
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.liabilityTo) {
                return;
            }else{
                if (self.policyTypeLabel != "") {
                    self.isChargeDate = true;
                    if (!self.actualToChange) {
                        if (self.policyTypeLabel.toLowerCase() == "liability") {
                            // self.fetchInsurancePolicy("liability"); //refresh insurance policy and charges
                        }else if (self.policyTypeLabel.toLowerCase() == "both") {
                            // self.fetchInsurancePolicy("both"); //refresh insurance policy and charges
                        }
                    }
                }
            }
        },
        vehicle_id: function(idval,oldidval) {
            var self = this;

            // if(self.vehicle_id == null || self.vehicle_id == "") {
            //   self.vehicle_error_msg = "";
            // } else {
            //   if(self.vehicle_id.deposit_required > self.vehicle_id.customer_remain_deposit) {
            //     self.vehicle_error_msg = "Sufficient Deposit not found. Please contact the AR team.";
            //   }
            // }
            if (self.vehicle_id != null && JSON.stringify(self.vehicle_id.vehicle_type_id) != null){
              self.vehicle_type_id = {text: self.vehicle_id.vehicle_type, value: self.vehicle_id.vehicle_type_id};
              self.requested_vehicle_type_id = {text: self.vehicle_id.vehicle_type, value: self.vehicle_id.vehicle_type_id};
            }
            if (self.vehicle_type_id == null || self.vehicle_type_id == ''){
                self.firstAssetSelected = true;
            }
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.fromVehicle) {
                return;
            }else{
                if (self.$route.params.id > 0 && self.customer_insured == 1) {
                    // var policy_type = self.policyTypeLabel.toLowerCase();
                    // if (policy_type == "physical" || policy_type == "both") {
                    //     self.physical_to = self.actual_to_date;
                    // }
                    // if (policy_type == "liability" || policy_type == "both") {
                    //     self.liability_to = self.actual_to_date;
                    // }
                    // self.addInsurancePolicy = true;
                    self.actualToChange = true;
                    self.disableInsuranceDates = false;
                    self.dateChange = true;
                    //asset changed
                    // if (policy_type == "physical") {
                    //     self.fetchInsurancePolicy("physical-both");
                    // }else if (policy_type == "liability") {
                    //     self.fetchInsurancePolicy("liability-both");
                    // }else{
                    //     self.fetchInsurancePolicy("both");
                    //     self.addInsurancePolicy = false;
                    // }
                }else{

                    if(self.resId != undefined && self.resId != '' && !oldidval){
                        setTimeout(function(){
                            if (self.requested_vehicle_type_id != null && self.requested_vehicle_type_id.value){
                                self.getSections();

                            }
                        },500);
                        return;
                    }

                    if(self.penresId != undefined && self.penresId != ''){
                        setTimeout(function(){
                            if (self.requested_vehicle_type_id != null && self.requested_vehicle_type_id.value){
                                self.getSections();

                            }
                        },500);
                        return;
                    }
                    if (self.vehicle_id != null && self.vehicle_id.vehicle_type_id){
                        self.vehicle_type_id = {text: self.vehicle_id.vehicle_type,value:self.vehicle_id.vehicle_type_id};
                        self.requested_vehicle_type_id = {text: self.vehicle_id.vehicle_type,value:self.vehicle_id.vehicle_type_id};
                    }
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                    setTimeout(function(){
                    if (self.requested_vehicle_type_id != null && self.requested_vehicle_type_id.value){
                        self.getSections();

                    }

                    },500);
                }
            }
            if (self.vehicle_id != null && self.vehicle_id.value){
                self.searchAvailableAsset(self.vehicle_id.unit_no);
            }else{
                self.vehicle_error_msg = '';
                self.unitReserved = false;
            }
        },

        osrPO: function(osrPO) {
          var self  = this;

          if(osrPO != null) {
            self.isDisableVehicle = true;
            self.vehicle_id = {text:osrPO.vehicle, value:osrPO.vehicle_id, vehicle_type: osrPO.vehicle_type,
            vehicle_type_id: osrPO.vehicle_type_id, location_id: osrPO.location_id };
            self.vehicle_type_id = {text: osrPO.vehicle_type, value:osrPO.vehicle_type_id};
            self.requested_vehicle_type_id = {text: osrPO.vehicle_type, value:osrPO.vehicle_type_id};

          } else {
            self.isDisableVehicle = false;
          }
        },
        osrSelection: function(osrSelection) {
          if(!osrSelection) {
            var self  = this;
            self.vehicle_id = null;
            self.vehicle_type_id = null;
            self.requested_vehicle_type_id = null;
            self.osrPO = null;
          }

        },
        // vehicle_type_id: function(type,oldType){

        //     var self  = this;
        //     var path = window.location.pathname;
        //     var segments = path.split("/");
        //     if (oldType && oldType != null && !firstAssetSelected){

        //         self.vehicle_id = '';

        //     }

        //     if (type.value && type.value != null && type.value != undefined && !segments[3] ) {
        //     //     self.getSections();
        //     self.requested_vehicle_type_id = type;
        //     }

        // },
        // requested_vehicle_type_id:function(type,oldType){
        //     var self  = this;
        //     var path = window.location.pathname;
        //     var segments = path.split("/");
        //      if (type.value && type.value != null && type.value != undefined && !segments[3] ) {
        //         // self.getSections();
        //     }
        // },
        // due_out_time:function(outTime) {

        //     var self = this;
        //     var path = window.location.pathname;
        //     var segments = path.split("/");
        //     self.due_out_time_error_msg = "";
        //     self.charge_from_time_error_msg = "";
        //     self.actual_from_time_error_msg = "";

        //     if (outTime.value && outTime.value != null && outTime.value != undefined && !segments[3]) {

        //         if (self.charge_from_time == "" || !self.charge_from_time.value || self.charge_from_time == null) {
        //             self.charge_from_time = outTime;
        //         }

        //         if (self.actual_from_time == "" || !self.actual_from_time.value || self.actual_from_time == null) {
        //             self.actual_from_time = outTime;
        //         }
        //     }
        // },
        // due_in_time:function(inTime) {
        //     var self = this;
        //     var path = window.location.pathname;
        //     var segments = path.split("/");
        //     self.due_in_time_error_msg = "";
        //     self.charge_to_time_error_msg = "";
        //     self.actual_to_time_error_msg = "";
        //     self.planned_in_time_error_msg = "";

        //     if (inTime.value && inTime.value != null && inTime.value != undefined && !segments[3]) {

        //         if (self.charge_to_time == "" || !self.charge_to_time.value || self.charge_to_time == null) {
        //             self.charge_to_time = inTime;
        //         }

        //         if (self.actual_to_time == "" || !self.actual_to_time.value || self.actual_to_time == null) {
        //             self.actual_to_time = inTime;
        //         }

        //         if (self.planned_in_time == "" || !self.planned_in_time.value || self.planned_in_time == null) {
        //             self.planned_in_time = inTime;
        //         }
        //     }
        // },
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_rental_agreement' ) {
                        self.cantAccessPage = true;

                    }
                    if ( permissions[i].name == 'edit_after_close_agreement' ) {
                        self.canEditAfterClose = true;
                        self.isClosedAgreement = false;
                    }
                }
            }
            self.loadRentalAgreementSearchData();

        },
        po:function(newVal){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            if (!segments[3] && newVal.value != undefined){
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/customer-purchase-order/" + newVal.value,
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;


                        if (data.status == "success") {

                            if(data.content.type == "contract"){
                                self.due_out_date = data.content.effective_from;
                                self.due_in_date = data.content.effective_to;

                            }else{

                                self.due_out_date = data.content.order_date;
                                self.due_in_date = data.content.due_date;
                            }
                            self.notes = data.content.notes;

                            // if((data.content.cust_id)!=null)
                            // {
                            //     var name=(data.content.cust_name != null)? data.content.cust_name :"";
                            //     var code=(data.content.cust_code != null)?data.content.cust_code:"";

                            //     self.customer_id={value: data.content.cust_id, text: self.titleCase(name + " (" + code +")")};
                            // }else{
                            //     self.customer_id = null;
                            // }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-customer-po-detail');
                    }
                });
            }

        },

        customer_id: function(customer_id){
          if(customer_id != null && customer_id != "") {

            this.searchPo(null,customer_id.value);

          } else {
            this.poArr = [];
          }

        }
   },
   computed: {
    timeMask () {
      if (!this.due_out_time || this.due_out_time === '' || this.due_out_time[0] === '2') {
        return '23:59'
      }
      return '29:59'
    },
    timeMaskOptions () {
      return { formatChars: { '2': '[0-1]', '3': '[0-9]', '5': '[0-5]', '9': '[0-9]' }, alwaysShowMask: false }
    }
  },
  beforeRouteLeave(to, from, next) {
        var self = this;
        self.left_view_edit_channel(from.fullPath);
        next();
  },
  mounted: function() {

        var self = this;

        self.getPermissions();

        setTimeout(function(){

            //self.loadRentalAgreementSearchData();

        },500);

        var path = window.location.pathname;
        var segments = path.split("/");
        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if(userObj != null){
            var dateTimeFormat = userObj["date_format"];
            if(dateTimeFormat != null){
                //set date time format in optionsDate format of date picker
            }
        }

        if (segments[3]) {
            self.loadRentalAgreement();
            self.agreement_id = segments[3];

            //Join ViewEdit Channel
            self.join_view_edit_channel(segments[1],segments[2],segments[3]);

        }else{

            //self.getAgreementCode();
            self.resId = self.$route.query.resId;
            if(self.resId != undefined && self.resId != '' && self.firstLoad == 0){
                self.getReservationData(self.resId , "reservation");
            }

            self.penresId = self.$route.query.penresId;
            if(self.penresId != undefined && self.penresId != '' && self.firstLoad == 0){
                self.getReservationData(self.penresId ,"pending");
            }

        }
        if (self.$route.params.id == undefined) {
            self.insDetailLink = true;
        }

        this.loadFieldData(['section']);

        if (self.$route.query.from != undefined) {
            self.from = self.$route.query.from;
            if(self.from == 'return'){
                self.reqClass = 'require';
                self.close = true;
            }
            if(self.from == 'policy'){
                self.onlyInsurance = true;
            }
            self.optionsDate.maxDate = moment().format("MM/DD/YYYY");
            //current day date time for readings
            var currentDayTime = self.optionsDate.maxDate + " 11:59:59 pm";
            self.optionsDateTime.maxDate = moment(currentDayTime).format("MM/DD/YYYY hh:mm:ss a");

        }

    //    $(document).ready(function() {
    //         $("#policyNotValid").click(function(){
    //             console.log('herer it is');
    //             self.policyCreationForm();
    //         });
    //     });
  },
  methods: {

    onSearchOSRPO(search, loading)
    {
        if (search.length > 1) {
            loading(true);
            this.searchOSRPO(loading, search, this);
        }
    },

    searchOSRPO(loading, search) {
        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/search",
            type: "POST",
            crossDomain: true,
            headers: this.ajxHeaders,
            data: {
                search: search,
                flag:"vendor_po",
                for:"osr",
            },
            dataType: "json",
            success: function (data) {
                //console.log(data.content[0]["id"]);
                //self.CheckBtn = 'Check';
                if (data.status == "success") {
                    self.loading = false;
                    loading(false);
                    self.osrPOArr = [];
                    self.osrPOArr = data.content;


                }
            },

            error: function (jqXHR, exception) {
                self.loading = false;
                //self.CheckBtn = 'Check';
                self.generateStatusCodeMessage(jqXHR,true,'ach-check-customer')
            }
        });

    },

    onDueOutChange(e) {
        this.$set(this.toDueInDate, 'minDate', e.date);
    },
    onDueInChange(e) {
        this.$set(this.toDueOutDate, 'maxDate', e.date);
    },

    onActualFromChange(e) {
        this.$set(this.toActualInDate, 'minDate', e.date);
    },
    onActualInChange(e) {
        this.$set(this.toActualFromDate, 'maxDate', e.date);
    },


    // On cahnge time it will populate time in below fields
    populateTime: function(id,value) {

        if ( value ) {
            if ( id == "due_out_time" ) {
                // this.actual_from_time = value;

            } else if ( id == "due_out_ampm" ) {
                // this.actual_from_ampm.value = value.value;
                // this.actual_from_ampm.text = value.text;

            } else if ( id == "due_in_time" ) {

                // this.actual_to_time = value;
                this.planned_in_time = value;

            } else if ( id == "due_in_ampm" ) {

                // this.actual_to_ampm.value = value.value;
                // this.actual_to_ampm.text = value.text;
                this.planned_in_ampm.value = value.value;
                this.planned_in_ampm.text = value.text;

            }
        }

    },


    onSearchVehicle(search, loading) {
        var self = this;
        if (search.length > 3) {
            self.vehicle_error_msg = '';
            // loading(true);
            // active vehicle status
            if (self.contract_type_id != null){
                self.searchField(loading, search, 'active rental vehicle status', self.contract_type_id.code);
            }else{
                self.searchField(loading, search, 'active rental vehicle status', '');
            }
            // self.searchAvailableAsset(search);
        }

    },
    onSearchLeaseVehicle(search, loading) {
        var self = this;
        if (search.length > 3) {
            self.vehicle_error_msg = '';
            // loading(true);
            self.searchField(loading, search, 'active lease vehicle', '');
            // self.searchAvailableAsset(search);
        }

    },
    selectContractAsset:function(evt,from){
        var self = this;

        if (from == 'lease'){
            if (self.contract_asset_id != null && self.contract_asset_id.value){
                self.customer_id = {text:self.contract_asset_id.customer,value:self.contract_asset_id.customer_id};
            }
        }else if (from == 'rental'){
            if (self.sub_agreement != null && self.sub_agreement.value){
                self.customer_id = {text:self.sub_agreement.customer,value:self.sub_agreement.customer_id};
            }
        }

    },

    onSearchPolicy(search, loading) {
        var self = this;
        // alert(search.length);
        if (search.length > 0) {
            // loading(true);
            self.getInsurancePolicies(search);
        }

    },
    onSearchPO(search, loading) {
        var self = this;
        if(self.customer_id == null || !self.customer_id.value){

            self.customererrors = 'Customer require to search PO';
        }else{

            self.customererrors = "";
        }
        if (search.length > 0 && self.customer_id != null && self.customer_id.value && self.customer_id.value != '') {
            // loading(true);

            self.searchPo(search,self.customer_id.value);
        }

    },
    searchPo(searchValue,custId){

        var self = this;

        // self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/cust-po/search",
            type: "POST",
            headers: this.ajxHeaders,
            data: {
                customer_id:custId,
                search:searchValue,
                flag: "rental"
            },
            dataType : "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.poArr = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-search-po')
            }
        });
    },
    getSections:function(){
        var self = this;
        var truckId = 0;
        if (self.vehicle_id != null && self.vehicle_id.value){
            truckId = self.vehicle_id.value;
        }
        $.ajax({
            url: process.env.ROOT_API + "/get-section",
            type: "GET",
            headers: this.ajxHeaders,
            data: {
                truck_type:self.requested_vehicle_type_id.value,
                agreementId:self.agreement_id,
                vehicle_id:truckId,
                // rental_type:self.osrSelection
            },
            dataType : "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    // self.unitArr = data.content;
                    // self.readInArr = data.content;
                    if (data.content.length > 0){
                        self.unitArr = [];
                        for (var i = 0; i < data.content.length; i++) {

                            self.unitArr.push({
                                section_id:data.content[i].section_id,
                                section:data.content[i].section,
                                sectionName:data.content[i].sectionName,
                                reading_out:data.content[i].reading_out,
                                reading_out_date:moment(self.due_out_date+' '+self.due_out_time+' '+self.due_out_ampm.value).format("MM/DD/YYYY hh:mm:ss a"),
                                reading_out_error_msg:'',
                                reading_out_date_error_msg:'',
                            });

                            // self.readInArr.push({
                            //     section_id:data.content[i].section_id,
                            //     section:data.content[i].section,
                            //     reading_in:'',
                            //     reading_in_date:'',
                            //     reading_in_error_msg:'',
                            //     reading_in_date_error_msg:'',
                            // });
                        }
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-search-po')
            }
        });
    },
    selectionChanged:function(evt){
        var self = this;
        // evt.selectedRows
        if (evt.selectedRows.length > 1){
            self.$swal('','Please select only one asset','info');
        }else{
            if (evt.selectedRows.length == 1){
                var ev = evt.selectedRows[0];
                self.vehicle_error_msg = '';
                self.vehicle_id = {value:ev.id,text:ev.unit_no + ' | '+ev.type_code + ' | '+ev.name,vehicle_type:ev.type_name + ' | '+ev.type_code,vehicle_type_id:ev.asset_type_id,unit_no:ev.unit_no};
                self.checkAvailabilityFlag = false;
            }
        }
    },
    searchAvailableAsset(searchValue){

        var self = this;

        var pickdate = self.due_out_date;
        var dropdate = self.due_in_date;
        var locationId = self.due_out_location_id.value;
        var truckType = '';
        var error = false;
        //user can select any asset
        if (self.penresId != null && self.penresId != ''){
            truckType = self.vehicle_type_id.value;
        }
        var res_id = 0;
        if (self.source && self.source.value){
            res_id = self.source.value;
        }
        if (searchValue == '' || searchValue == undefined){
            return;
        }

        if ( self.due_out_time.indexOf("_") > -1 ) {
            self.due_out_time_error_msg = "Please check Due out time format.";
            error = true;
        }

        if ( self.due_in_time.indexOf("_") > -1 ) {
            self.due_in_time_error_msg = "Please check Due In time format.";
            error = true;
        }

        if (error){
            return;
        }
        var fields = [];
        fields.push({name: "pickUpDate", value: pickdate});

        fields.push({name: "customer_id", value: (self.customer_id == null) ? null : self.customer_id.value});
        fields.push({name: "dropOffDate", value: dropdate});
        var dueOutTime = self.changeTime12To24Hrs(self.due_out_time+" "+ self.due_out_ampm.value);

        fields.push({name: "pickTime", value: dueOutTime});

        var dueInTime = self.changeTime12To24Hrs(self.due_in_time+" "+ self.due_in_ampm.value);

        fields.push({name: "dropTime", value: dueInTime});

        // fields.push({name: "location", value: locationId});
        //change location id to 0 to search vehicle from all location
        fields.push({name: "location", value: 0});
        fields.push({name: "searchValue", value: searchValue});

        if ( truckType == null || !truckType ) {
            fields.push({name: "assetType", value: ""});
        }else{
            fields.push({name: "assetType", value: truckType});
        }
        if ( self.contract_type_id == null || !self.contract_type_id.code ) {
            fields.push({name: "conType", value: ""});
        }else{
            fields.push({name: "conType", value: self.contract_type_id.code});
        }
        fields.push({name: "from", value: 'search'});

        fields.push({name: "res_id", value: self.res_id});

        // self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/available-asset/search",
            type: "POST",
            headers: this.ajxHeaders,
            data: fields,
            dataType : "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    // self.vehicleArr = data.content;
                    // self.availableAssetArr = data.content;
                    if (data.content[0] == undefined){
                        self.vehicle_error_msg = 'Unit Not Found';
                        self.unitReserved = true;
                    }else{
                        if (data.content[0].reserved_msg != undefined && data.content[0].reserved_msg != ''){
                            self.vehicle_error_msg = data.content[0].reserved_msg;
                            self.unitReserved = true;
                        }else{
                            self.vehicle_error_msg = '';
                            self.unitReserved = false;
                        }

                    }

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-search-avail-asset')
            }
        });
    },

    onSearchReservation(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'reservation', '');
        }
    },

    onSearchState(search, loading) {
        if (search.length > 2) {

            loading(true);
            this.searchField(loading, search, 'state', '');
        }
    },
    getReservationData: function(id, actionFor) {
        var self =  this;

        var flagAction = "";
        if(actionFor == "reservation") {
          flagAction = 'agreement';
        } else {
          flagAction = "pendingReservation";
        }

        // self.firstLoad = 1;
        $.ajax({
            url: process.env.ROOT_API + "/get_only_reservation_data",
           type: "POST",
            headers: this.ajxHeaders,
            data:{
                resId:id,
                flag:flagAction
            },
            crossDomain: true,
            dataType: 'json',
            success: function (data) {

                if (data.status == "success") {

                    if(self.resId != '' && self.watchCall == 0){
                        self.firstLoad = 1;
                        self.source = {value:data.content.id,text:data.content.resRefNo};
                        self.contract_type_id = {text:data.content.conType,value:data.content.conTypeId,code:'R1'};
                    }
                    self.customer_id = {text:data.content.custCode+' | '+data.content.custName,value:data.content.custId};
                    self.due_out_date = data.content.pkDate;
                    // self.charge_from_datetime = data.content.pickUpDate;
                    self.due_in_date = data.content.dpDate;
                    self.due_out_time = {value:data.content.pkTime24,text:data.content.pkTime12};
                    self.due_in_time = {value:data.content.dpTime24,text:data.content.dpTime12};
                    self.planned_in_date = data.content.dpDate;
                    self.planned_in_time = {value:data.content.dpTime24,text:data.content.dpTime12};

                    if ( data.content.pkTime24 ) {

                        //self.due_in_time = {value:data.content.due_in_time24,text:data.content.due_in_time};
                        var dueOutTime =  data.content.pkTime12.split(" ");
                        self.due_out_time = dueOutTime[0];
                        self.due_out_ampm = {value:dueOutTime[1].toLowerCase(),text:dueOutTime[1]};
                    }

                    self.due_out_location_id = {value: data.content.due_out_location_id, text: self.titleCase(data.content.locOutName)};

                    if ( data.content.dpTime24 ) {

                        //self.due_in_time = {value:data.content.due_in_time24,text:data.content.due_in_time};
                        var dueInTime =  data.content.dpTime12.split(" ");
                        self.due_in_time = dueInTime[0];
                        self.due_in_ampm = {value:dueInTime[1].toLowerCase(),text:dueInTime[1]};
                    }

                    if ( data.content.pkTime24 ) {

                        //self.actual_from_time = {value:data.content.actual_from_time24,text:data.content.actual_from_time};
                        var actualFromTime =  data.content.pkTime12.split(" ");
                        self.actual_from_time = actualFromTime[0];
                        self.actual_from_ampm = {value:actualFromTime[1].toLowerCase(),text:actualFromTime[1]};
                    }

                    if ( data.content.dpTime24 ) {

                        //self.actual_to_time = {value:data.content.actual_to_time24,text:data.content.actual_to_time};
                        var actualToTime =  data.content.dpTime12.split(" ");
                        self.actual_to_time = actualToTime[0];
                        self.actual_to_ampm = {value:actualToTime[1].toLowerCase(),text:actualToTime[1]};
                    }

                    if ( data.content.dpTime24 ) {

                        //self.planned_in_time = {value:data.content.planned_in_time24,text:data.content.planned_in_time};
                        var plannedInTime =  data.content.dpTime12.split(" ");
                        self.planned_in_time = plannedInTime[0];
                        self.planned_in_ampm = {value:plannedInTime[1].toLowerCase(),text:plannedInTime[1]};
                    }
                    // self.charge_to_datetime = data.content.dropOffDate;
                    self.due_out_location_id = {text:data.content.locName+' | '+data.content.locCode,value:data.content.locId};
                    // self.charge_from_location_id = {text:data.content.locName+' | '+data.content.locCode,value:data.content.locId};
                    self.due_in_location_id = {text:data.content.locName+' | '+data.content.locCode,value:data.content.locId};
                    //self.estimatedMiles = data.content.miles;
                    if (data.content.contract_asset_id != undefined){
                        self.contract_asset_id = {text:data.content.contract_asset,value:data.content.contract_asset_id};
                    }
                    if (data.content.is_substitute != undefined && data.content.is_substitute == 1){
                        self.is_substitute = true;
                    }else{
                        self.is_substitute = false;
                    }
                    self.showFields = true;
                    if (self.$route.params.id == undefined ) {


                            self.vehicle_type_id = {text:data.content.vehTypeName+' | '+data.content.vehTypeCode,value:data.content.vehTypeId};
                            self.requested_vehicle_type_id = {text:data.content.vehTypeName+' | '+data.content.vehTypeCode,value:data.content.vehTypeId};

                            // self.getSections();

                            if(data.content.unit_no != null ) {

                              setTimeout(function(){
                                  //in case when unit not selected while create
                                  if ( data.content.unit_no ) {
                                      self.vehicle_id = {text:data.content.unit_no+' | '+data.content.vehTypeCode,value:data.content.vehicle_id};
                                  }

                              },500);
                            }
                    }
                    setTimeout(function(){
                        if(actionFor == "reservation") {
                            self.customer_insured = data.content.customer_insured_val;
                            if (self.customer_insured == 0) {
                                self.customerInsuredSelected(0);
                                self.fetchInsurancePolicy("");
                                self.insPolicyArr = data.content.insurance_policy;
                                self.insurancePolicyArr = data.content.insurance_policy_details;
                            }else if (self.customer_insured == 1) {
                                self.customerInsuredSelected(1);
                                self.insPolicyArr = data.content.insurance_policy;
                                self.insuranceChargesArr = data.content.insurance_charges_details;
                                if (self.insPolicyArr.length < 1) {
                                    //policy type is both
                                    self.policy_type = { text: "Both",value: "both"};
                                }
                            }
                            //insurance charge dates on the basis of policy type
                            if (data.content.policy_type != "") {
                                if (data.content.policy_type == "physical") {
                                    self.insurance_from = data.content.physical_from;
                                    self.insurance_to = data.content.physical_to;
                                    self.policy_type = { text: "Physical",value: "physical"};
                                    self.fetchInsurancePolicy("liability");
                                }
                                if(data.content.policy_type == "liability") {
                                    self.insurance_from = data.content.liability_from;
                                    self.insurance_to = data.content.liability_to;
                                    self.policy_type = { text: "Liability",value: "liability"};
                                    self.fetchInsurancePolicy("physical");
                                }
                                if (data.content.policy_type == "both") {
                                    self.policy_type = { text: "Both",value: "both"};
                                    self.policyTypeLabel = "Both";
                                    self.insurance_from = data.content.physical_from;
                                    self.insurance_to = data.content.physical_to;
                                }
                            }
                            if (self.customer_insured == 1) {
                                self.showDropZone = true;
                                if(data.content.insurance_certificates != null) {
                                    self.previewCertificates = data.content.insurance_certificates;
                                    self.loadFilesPreview();
                                }
                            }else{
                                self.showDropZone = false;
                            }
                            self.actualFrom = true;
                            self.actualTo = true;
                            self.fromVehicle = true;
                            self.fillValues = true;
                            self.insuranceFrom = true;
                            self.insuranceTo = true;
                            self.physicalTo = true;
                            self.liabilityTo = true;
                        }else{
                            if(data.content.insurance_type=="from_us"){
                                self.customer_insured=1;
                                self.customerInsuredSelected(1);
                                self.policy_type={text:'Both',value:'both'};
                            }
                            if(data.content.insurance_type=="from_their"){
                                self.customer_insured=0;
                                self.customerInsuredSelected(0);
                            }
                        }
                    },1000);
                    if(actionFor == "reservation") {
                        setTimeout(function(){
                            self.loadInsurancePolicy();
                        },3000);
                    }

                }
            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-get-resrvation')
            }
        });
    },

    getInsurancePolicies: function(search){
        var self =  this;

        self.due_out_datetime_error_msg = "";
        self.due_in_datetime_error_msg = "";
        self.customererrors = "";
        var error = false;

        if (!self.due_out_date || self.due_out_date == null || self.due_out_date == "") {
            self.due_out_datetime_error_msg = "Due OUT Date require.";
            error = true;
        }

        if (!self.due_in_date || self.due_in_date == null || self.due_in_date == "") {
            self.due_in_datetime_error_msg = "Due IN DateTime require.";
            error = true;
        }

        if (new Date(self.due_out_date) > new Date(self.due_in_date)){
            alert("Due IN Date should not be earlier than Due OUT Date");
            error = true;
        }

        if (self.customer_id == null || !self.customer_id.value) {
            self.customererrors = "Customer Name require.";
            error = true;
        }


        if (!error) {

            // self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/find_customer_insurance_data",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    search:search,
                    customer_id:self.customer_id.value,
                    pickup_date:self.due_out_date,
                    dropoff_date:self.due_in_date,
                    vehicle_id:self.vehicle_id.value
                },
                crossDomain: true,
                dataType: 'json',
                success: function (data) {

                    if (data.status == "success") {
                        self.insurancecompanyArr = data.content;

                        if(self.insurancecompanyArr.length > 0){

                            self.customer_insured = 1;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-find-cust-insurance')
                }
            });
        }
    },
    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    BackRentalAgreementList() {
      var self = this;
      self.$router.push("/rentalagreement/list");
    },

    loadRentalAgreementSearchData() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/rentalagreement/search",
           type: "GET",
            headers: this.ajxHeaders,
            data:{
                // params:['rentalVehicleType']
            },
            crossDomain: true,
            dataType: 'json',
            success: function (data) {
                if (data.status == "success") {

                    self.dueoutlocationArr = data.Location;
                    self.dueinlocationArr = data.Location;
                    self.chargefromlocationArr = data.Location;
                    // self.insurancecompanyArr = data.InsuranceCompany;
                    self.contracttypeArr = data.ContractType;
                    self.vehicletypeArr = data.AssetType;
                    // self.vehicleArr = data.Asset;

                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'load-rental-agreement-search')
            }
        });
    },

    // openModal: function(flag){
    //     var self = this;
    //     self.bill_date = self.actual_to_date;
    //     self.fetchBilling(flag);
    //     $("#postInvoiceModal").modal("show");
    // },
    hideBillModal() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        $("#postInvoiceModal").modal("hide");
        self.bill_date = '';
        self.bill_date_error = '';
        self.$router.push("/rentalagreement/view/"+segments[3]);

    },
    postInvoice() {
        var self = this;
        // var forecastId = self.$route.params.id;

        var path = window.location.pathname;
        var segments = path.split("/");
        var invoiceFor = 'last';
        self.bill_date_error = '';

        if (self.bill_date == '' || self.bill_date == null){
            self.bill_date_error = 'Bill Date Required';
            return;
        }

        if (self.bill_date != '' && new Date(self.bill_date) < new Date(self.actual_to_date)){//bill date should not be earlier than Actual In Date
            self.bill_date_error = 'Bill Date Should Not Be earlier than Actual In Date';
            return;
        }

        if (self.postBillOnce == 1){
            return;
        }

        self.postBillOnce = 1;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/agreement-invoice/post",
            type: "POST",
            data: {
                agreement_id:segments[3],
                bill_date:self.bill_date,
                invoiceFor:invoiceFor
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                self.postBillOnce = 0;
                if (data.status == "success") {

                    if (data.content.id && data.content.id != undefined){
                        self.$router.push("/rental-agreement/invoice/"+data.content.id+'?from=agreement&ra='+segments[3]);
                    }

                    if (data.code == 201){

                        self.$swal('',data.message,'info');
                        self.bill_date = '';
                        self.bill_date_error = '';

                        $("#postInvoiceModal").modal("hide");

                    }else{
                        self.bill_date = '';
                        self.bill_date_error = '';
                        $("#postInvoiceModal").modal("hide");
                    }

                }else{

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.postBillOnce = 0;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },

    CreateRentalAgreement(flag) {
      var self = this;
      var error = false;
      var codeError = "";
        self.code_error_msg = "";
        self.contract_type_error_msg = "";
        self.vehicle_type_error_msg = "";
        self.vehicle_error_msg = "";
        self.due_out_datetime_error_msg = "";
        self.due_out_location_error_msg = "";
        self.due_in_datetime_error_msg = "";
        self.due_in_location_error_msg = "";
        // self.charge_from_datetime_error_msg = "";
        // self.charge_from_location_error_msg = "";
        // self.charge_to_datetime_error_msg = "";
        self.customererrors = "";
        self.planned_in_datetime_error_msg = "";
        self.reading_out_msg = "";
        self.reading_in_msg = "";
        self.actual_from_datetime_error_msg = "";
        self.actual_to_datetime_error_msg = "";
        self.mileserror_msg = "";
        self.credit_approved_msg = "";
        self.customer_insured_error_msg = "";
        self.policy_type_error_msg = "";
        self.common_error_msg = "";
        self.insurance_from_error_msg = "";
        self.insurance_to_error_msg = "";
        self.physical_from_error_msg = "";
        self.physical_to_error_msg = "";
        self.liability_from_error_msg = "";
        self.liability_to_error_msg = "";
        self.contract_asset_error_msg = "";
        self.sub_agreement_error_msg = '';
        self.sub_type_error_msg = '';
        self.due_out_time_error_msg = "";
        self.due_in_time_error_msg = "";
        // self.charge_from_time_error_msg = "";
        // self.charge_to_time_error_msg = "";
        self.actual_from_time_error_msg = "";
        self.actual_to_time_error_msg = "";
        self.planned_in_time_error_msg = "";
        self.insurance_certificate_error_msg = "";
        self.customer_po_error_msg = "";
        self.requested_vehicle_type_error_msg = '';
        self.osr_po_error_msg = '';
        self.sub_unit_error_msg = '';

      if(self.contract_type_id == null || !self.contract_type_id.value || ( self.contract_type_id.code != "TRANSF" && self.contract_type_id.text != "Transfer Agreement")){
        if (self.customer_id == null || !self.customer_id.value) {
          self.customererrors = "Customer Name require.";
          error = true;
        }
      }

      if (self.customer_id && self.customer_id.po_required == 1){
          if (self.po == null || !self.po.value) {
            self.customer_po_error_msg = "Customer PO Required.";
            error = true;
        }
      }

    //   if (!self.code || self.code == null || self.code == "") {
    //     self.code_error_msg = "Code require.";
    //     error = true;
    //   }

    //   codeError = self.validateLength(self.code, 8, 12);
    //   if (codeError) {
    //     self.code_error_msg = codeError;
    //     error = true;
    //   }

      if (self.contract_type_id == null || !self.contract_type_id.value) {
        self.contract_type_error_msg = "Contract Type require.";
        error = true;
      }

      if (self.vehicle_type_id == null || !self.vehicle_type_id.value) {
        self.vehicle_type_error_msg = "Vehicle Type require.";
        error = true;
      }

      if (self.requested_vehicle_type_id == null || !self.requested_vehicle_type_id.value) {
        self.requested_vehicle_type_error_msg = "Requested Vehicle Type require.";
        error = true;
      }

      if (self.vehicle_id == null || !self.vehicle_id.value) {
        self.vehicle_error_msg = "Vehicle require.";
        error = true;
      }

      // if(self.vehicle_id.deposit_required > self.vehicle_id.customer_remain_deposit) {
      //   self.vehicle_error_msg = "Sufficient Deposit not found. Please contact the AR team.";
      //   error = true;
      // }

      if (!self.due_out_date || self.due_out_date == null || self.due_out_date == "") {
        self.due_out_datetime_error_msg = "Due OUT Date require.";
        error = true;
      }

      if (self.due_out_time == null || self.due_out_time == "") {
        self.due_out_time_error_msg = "Due OUT Time Required.";
        error = true;
      } else {
          if ( self.due_out_time.indexOf("_") > -1 ) {
              self.due_out_time_error_msg = "Please check Due out time format.";
              error = true;
          }
          var validateTime = self.validateTimeFormat(self.due_out_time);
          if ( !validateTime ) {
            self.due_out_time_error_msg = "Please check Due out time format.";
            error = true;
          }

      }

      if (self.actual_from_time == null || self.actual_from_time == "") {
        if(self.actual_from_date != null && self.actual_from_date != ""){
            self.actual_from_time_error_msg = "Actual out time require.";
            error = true;
        }
      } else {
          if (self.actual_from_date != '' && self.actual_from_date != null && self.actual_from_time.indexOf("_") > -1 ) {
              self.actual_from_time_error_msg = "Please check Actual out time format.";
              error = true;
          }
      }

      if (!self.due_in_date || self.due_in_date == "") {
        self.due_in_datetime_error_msg = "Due IN DateTime require.";
        error = true;
      }

      if (self.due_in_time == null || self.due_in_time == "") {
        self.due_in_time_error_msg = "Due IN Time Required.";
        error = true;
      } else {

          if ( self.due_in_time.includes("_") ) {
              self.due_in_time_error_msg = "Please check Due out time format.";
              error = true;
          }
          var validateTime = self.validateTimeFormat(self.due_in_time);
          if ( !validateTime ) {
            self.due_in_time_error_msg = "Please check Due in time format.";
            error = true;
          }
      }

      if (self.actual_to_time == null || self.actual_to_time == "") {
        if(self.actual_to_date != null && self.actual_to_date != ""){
            self.actual_to_time_error_msg = "Actual in time require.";
            error = true;
        }
      } else {

          if (self.actual_to_date != '' && self.actual_to_date != null && self.actual_to_time.indexOf("_") > -1 ) {
              self.actual_to_time_error_msg = "Please check Actual in time format.";
              error = true;
          }
          var validateTime = self.validateTimeFormat(self.actual_to_time);
          if ( !validateTime ) {
            self.actual_to_time_error_msg = "Please check Actual in time format.";
            error = true;
          }
      }

      if (self.due_out_location_id == null || !self.due_out_location_id.value) {
        self.due_out_location_error_msg = "Due OUT Location require.";
        error = true;
      }

      if (self.due_in_location_id == null || !self.due_in_location_id.value) {
        self.due_in_location_error_msg = "Due IN Location require.";
        error = true;
      }

    //   if (!self.charge_from_date || self.charge_from_date == null || self.charge_from_date == "") {
    //     self.charge_from_datetime_error_msg = "Charge from Date require.";
    //     error = true;
    //   }

    //   if (self.charge_from_location_id == null || !self.charge_from_location_id.value) {
    //     self.charge_from_location_error_msg = "Charge from Location require.";
    //     error = true;
    //   }

    //   if (!self.charge_to_date || self.charge_to_date == null || self.charge_to_date == "") {
    //     self.charge_to_datetime_error_msg = "Charge to Date require.";
    //     error = true;
    //   }

      if (!self.planned_in_date || self.planned_in_date == null || self.planned_in_date == "") {
        self.planned_in_datetime_error_msg = "Planned in Date require.";
        error = true;
      }
        // if (self.from == 'process'){

        // if (!self.actual_from_date || self.actual_from_date == null || self.actual_from_date == "") {
        //     self.actual_from_datetime_error_msg = "Actual from Date require.";
        //     error = true;
        // }

        // if (self.actual_from_time == null || self.actual_from_time == "") {
        //     self.actual_from_time_error_msg = "Actual from Time Required.";
        //     error = true;
        // } else {

        //     if ( self.actual_from_time.includes("_") ) {
        //         self.actual_from_time_error_msg = "Please check Actual from time format.";
        //         error = true;
        //     }
        // }

        // }
      if (self.from == 'return'){
        if (!self.actual_to_date || self.actual_to_date == null || self.actual_to_date == "") {
            self.actual_to_datetime_error_msg = "Actual to Date require.";
            error = true;
        }

        if (self.actual_to_time == null || self.actual_to_time == "") {
            self.actual_to_time_error_msg = "Actual To Time Required.";
            error = true;
        } else {

            if ( self.actual_to_time.includes("_") ) {
                self.actual_to_time_error_msg = "Please check Actual to time format.";
                error = true;
            }
            var validateTime = self.validateTimeFormat(self.actual_to_time);
            if ( !validateTime ) {
                self.actual_to_time_error_msg = "Please check Actual in time format.";
                error = true;
            }
        }

        // if (self.actual_to_date && (new Date(self.due_out_date+' '+self.due_out_time+' '+self.due_out_ampm.value) > new Date(self.actual_to_date+' '+self.actual_to_time+' '+self.actual_to_ampm.value) || new Date(self.actual_from_date+' '+self.actual_from_time+' '+self.actual_from_ampm.value) > new Date(self.actual_to_date+' '+self.actual_to_time+' '+self.actual_to_ampm.value))){
        if (self.actual_to_date && new Date(self.actual_from_date+' '+self.actual_from_time+' '+self.actual_from_ampm.value) > new Date(self.actual_to_date+' '+self.actual_to_time+' '+self.actual_to_ampm.value)){
            self.$swal('','Actual In Date should not be earlier than Actual Out Date','info');
            error = true;
        }
      }


    //   if (self.charge_from_time == null || !self.charge_from_time.value || self.charge_from_time == "") {
    //     self.charge_from_time_error_msg = "Charge from Time Required.";
    //     error = true;
    //   }

    //   if (self.charge_to_time == null || !self.charge_to_time.value || self.charge_to_time == "") {
    //     self.charge_to_time_error_msg = "Charge To Time Required.";
    //     error = true;
    //   }


    if (self.planned_in_time == null || self.planned_in_time == "") {

        self.planned_in_time_error_msg = "Planned in Time Required.";
        error = true;
    } else {

        if ( self.planned_in_time.includes("_") ) {
            self.planned_in_time_error_msg = "Please check Planned in time format.";
            error = true;
        }
    }

    //   if (!self.readingOut || self.readingOut == 0 || self.readingOut == "") {
    //     self.reading_out_msg = "Reading Out require.";
    //     error = true;
    //   }

    //   if (self.readingIn && self.readingIn < self.readingOut) {
    //     self.reading_in_msg = "Reading In must be greater than Reading Out";
    //     error = true;
    //   }

      if (self.due_in_date && (new Date(self.due_out_date+' '+self.due_out_time+' '+self.due_out_ampm.value) > new Date(self.due_in_date+' '+self.due_in_time+' '+self.due_in_ampm.value))){
          self.$swal('',"Due IN Date should not be earlier than Due OUT Date",'info');
          return;
          //error = true;
      }
      var now = new Date();

      if (self.actual_from_date && (new Date(self.actual_from_date+' '+self.actual_from_time+' '+self.actual_from_ampm.value) > new Date(moment(now).format('MMM/DD/YYYY hh:mm A')))){
        //   self.$swal('',"Actual From Date Should Not Be Later Than Current Date",'info');
        //   return;
        // self.actual_from_datetime_error_msg = 'Actual From Date Should Not Be Later Than Current Date';
        // error = true;
      }

    //   if (self.charge_to_date && (new Date(self.charge_from_date) > new Date(self.charge_to_date))){
    //       self.$swal('',"Charge to Date should not be earlier than Charge from Date",'info');
    //       return;
    //       error = true;
    //   }

      //reading out validations
      if (self.unitArr && self.unitArr.length > 0){
        for (var i=0; i<self.unitArr.length; i++) {
            if (self.unitArr[i].reading_out == '' || self.unitArr[i].reading_out == 0){
                self.unitArr[i].reading_out_error_msg = 'Reading Out require.';
                error = true;
            }else{
                self.unitArr[i].reading_out_error_msg = '';
            }
            if (self.unitArr[i].reading_out_date == '' || self.unitArr[i].reading_out_date == null){
                self.unitArr[i].reading_out_date_error_msg = 'Reading Date require.';
                error = true;
            }else{
                self.unitArr[i].reading_out_date_error_msg = "";
            }
            // if (self.readInArr && self.readInArr.length > 0){
            //     for (var j=0; j<self.readInArr.length; j++){
            //         if (self.unitArr[j].section_id == self.readInArr[i].section_id){
            //             if (self.readInArr[j].reading_in_date != '' && self.readInArr[j].reading_in_date <= self.unitArr[i].reading_out_date){
            //                 self.readInArr[j].reading_in_date_error_msg = 'Reading Date Should be greater than reading out date.';
            //                 error = true;
            //             }else{
            //                 self.readInArr[j].reading_in_date_error_msg = '';
            //             }
            //             if (self.readInArr[j].reading_in != '' && self.readInArr[j].reading_in <= self.unitArr[i].reading_out){
            //                 self.readInArr[j].reading_in_error_msg = 'Reading In Should be greater than reading out.';
            //                 error = true;
            //             }else{
            //                 self.readInArr[j].reading_in_error_msg = '';
            //             }
            //         }
            //     }
            // }
        }
    }

    // if (self.$route.query.from != undefined && self.$route.query.from == 'return'){

        if (self.readInArr && self.readInArr.length > 0){
            for (var i=0; i<self.readInArr.length; i++) {

                if (self.readInArr[i].reading_in == '' || self.readInArr[i].reading_in == 0){
                    self.readInArr[i].reading_in_error_msg = 'Reading In require';
                    error = true;
                }else{
                    self.readInArr[i].reading_in_error_msg = '';
                }
                if (self.readInArr[i].reading_in_date == '' || self.readInArr[i].reading_in_date == null){
                    self.readInArr[i].reading_in_date_error_msg = 'Reading Date require';
                    error = true;
                }else{
                    self.readInArr[i].reading_in_date_error_msg = "";
                }

                for (var j=0; j<self.unitArr.length; j++){
                    if (self.unitArr[j].section_id == self.readInArr[i].section_id){
                        // self.readInArr[i].reading_in_error_msg = '';
                        // self.readInArr[i].reading_in_date_error_msg = '';
                        if (new Date(self.readInArr[i].reading_in_date) != '' && new Date(self.readInArr[i].reading_in_date) < new Date(self.unitArr[j].reading_out_date)){
                            self.readInArr[i].reading_in_date_error_msg = 'Reading Date Should be greater than reading out date.';
                            error = true;
                        }
                        // if (self.readInArr[i].reading_in != '' && parseInt(self.readInArr[i].reading_in) < parseInt(self.unitArr[j].reading_out)){
                        //     self.readInArr[i].reading_in_error_msg = 'Reading In Should be greater than reading out.';
                        //     error = true;
                        // }
                    }
                }
            }
        }
    // }
    if (self.insuranceNeeded){
        if (self.$route.params.id > 0 && self.customer_insured == 1 && !self.close && (self.insAlreadyStored || self.onlyinschargesAlreadyStored)) {
            //in case if Charge to Date Changed and Click on Update
            if (self.policy_type.value == "physical" || self.policy_type.value == "both") {
                if (!self.physical_from || self.physical_from == null || self.physical_from == "") {
                    self.physical_from_error_msg = "Physical From Date Required.";
                    error = true;
                }

                if (self.actual_from_date != null && self.actual_from_date != "") {
                    if (new Date(self.physical_from) < new Date(self.actual_from_date)){
                        self.physical_from_error_msg = "Physical From Date should not be earlier than Actual Out Date";
                        error = true;
                    }
                }else{
                    if (self.due_out_date != null && self.due_out_date != "") {
                        if (new Date(self.physical_from) < new Date(self.due_out_date)){
                            self.physical_from_error_msg = "Physical From Date should not be earlier than Due Out Date";
                            error = true;
                        }
                    }
                }

                if (!self.physical_to || self.physical_to == null || self.physical_to == "") {
                    self.physical_to_error_msg = "Physical To Date Required.";
                    error = true;
                }

                if (new Date(self.physical_from) > new Date(self.physical_to)){
                    alert("Physical To Date should not be earlier than Physical From Date");
                    error = true;
                }

                if (new Date(self.physical_to) > new Date(self.due_in_date)){
                    self.physical_to_error_msg = "Physical To Date should not be greater than Due In Date.";
                    error = true;
                }
            }

            if (self.policy_type.value == "liability" || self.policy_type.value == "both") {
                if (!self.liability_from || self.liability_from == null || self.liability_from == "") {
                    self.liability_from_error_msg = "Liability From Date Required.";
                    error = true;
                }

                if (self.actual_from_date != null && self.actual_from_date != "") {
                    if (new Date(self.liability_from) < new Date(self.actual_from_date)){
                        self.liability_from_error_msg = "Liability From Date should not be earlier than Actual Out Date";
                        error = true;
                    }
                }else{
                    if (self.due_out_date != null && self.due_out_date != "") {
                        if (new Date(self.liability_from) < new Date(self.due_out_date)){
                            self.liability_from_error_msg = "Liability From Date should not be earlier than Due Out Date";
                            error = true;
                        }
                    }
                }

                if (!self.liability_to || self.liability_to == null || self.liability_to == "") {
                    self.liability_to_error_msg = "Liability To Date Required.";
                    error = true;
                }

                if (new Date(self.liability_from) > new Date(self.liability_to)){
                    alert("Liability To Date should not be earlier than Liability From Date");
                    error = true;
                }

                if (new Date(self.liability_to) > new Date(self.due_in_date)){
                    self.liability_to_error_msg = "Liability To Date should not be greater than Due In Date.";
                    error = true;
                }
            }

            if (!self.addInsurancePolicy && self.isChargeDate) {
                if (self.policy_type.value == "physical" || self.policy_type.value == "both") {
                    if (new Date(self.physical_to) < new Date(self.due_in_date)) {
                        self.common_error_msg = "Charge Date is Changed So Update Policy Details.";
                        error = true;
                    }
                }

                if (self.policy_type.value == "liability" || self.policy_type.value == "both") {

                    if (new Date(self.liability_to) < new Date(self.due_in_date)) {
                        self.common_error_msg = "Charge Date is Changed So Update Policy Details.";
                        error = true;
                    }
                }
            }
        }
        if (self.$route.params.id > 0 && self.addInsurancePolicy && !self.close && (self.insAlreadyStored || self.onlyinschargesAlreadyStored)) {

            if (self.policy_type != null && self.policy_type != "") {

                if (self.policy_type.value == "physical" || self.policy_type.value == "both") {

                    if (!self.physical_from || self.physical_from == null || self.physical_from == "") {
                        self.physical_from_error_msg = "Physical From Date require.";
                        error = true;
                    }

                    if (!self.physical_to || self.physical_to == null || self.physical_to == "") {
                        self.physical_to_error_msg = "Physical To Date require.";
                        error = true;
                    }

                    if (new Date(self.physical_from) > new Date(self.physical_to)){
                        self.$swal('',"Physical To Date should not be earlier than Physical From Date",'info');
                        error = true;
                        return;
                    }
                }

                if (self.policy_type.value == "liability" || self.policy_type.value == "both") {
                    if (!self.liability_from || self.liability_from == null || self.liability_from == "") {
                        self.liability_from_error_msg = "Liability From Date require.";
                        error = true;
                    }

                    if (!self.liability_to || self.liability_to == null || self.liability_to == "") {
                        self.liability_to_error_msg = "Liability To Date require.";
                        error = true;
                    }

                    if (new Date(self.liability_from) > new Date(self.liability_to)){
                        self.$swal('',"Liability To Date should not be earlier than Liability From Date",'info');
                        error = true;
                    }
                }

                if (self.insPolicyArr.length < 1) {
                    self.common_error_msg = "Select Insurance Policy.";
                    error = true;
                }

                if (self.insPolicyArr.length > 0) {

                    var alreadySelected = self.insPolicyArr[0].policy_type; //already selected policy
                    var errorMsg = "";

                    if (self.policy_type.value == "physical") {

                        if (alreadySelected == "physical") {

                            errorMsg = "You have selected Policy with Type Physical. Please select policy with type Liability.";

                        }else if (alreadySelected == "liability") {

                            errorMsg = "You have selected Policy with Type Liability. Please select policy with type Physical.";

                        }

                        if (new Date(self.physical_to) < new Date(self.due_in_date) || new Date(self.physical_from) > new Date(self.due_out_date)) {

                            if (self.insPolicyArr.length == 1) {
                                self.common_error_msg = errorMsg;
                                error = true;
                            }else{
                                for(var i=0;i<self.insPolicyArr.length;i++) {

                                    if (self.insPolicyArr[i] != undefined) {
                                        if (self.insPolicyArr[i].policy_type == "physical") {
                                            if (self.insPolicyArr[i].start_date != undefined && self.insPolicyArr[i].start_date != "" && self.insPolicyArr[i].start_date != null) {
                                                if (new Date(self.physical_to) < new Date(self.due_in_date)){
                                                    var momentDate = moment(self.physical_to).add(1, 'days').format('MM/DD/YYYY');
                                                    var startDate = moment(self.insPolicyArr[i].start_date).format('MM/DD/YYYY');
                                                    if (Date.parse(startDate) > Date.parse(momentDate)) {
                                                        self.common_error_msg = "Select Valid Policy containing Date Next to Physical To Date and Agreement End Date";
                                                        error = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                        }else{
                            var physicalFound = 0;

                            for(var i=0;i<self.insPolicyArr.length;i++) {
                                //check if physical found
                                if (self.insPolicyArr[i].policy_type != undefined && self.insPolicyArr[i].policy_type != null) {
                                    if (self.insPolicyArr[i].policy_type == "physical") {
                                        physicalFound = 1;
                                    }
                                }
                            }

                            if (physicalFound == 1 || self.insPolicyArr.length > 1) {
                                self.common_error_msg = "Policy with Type Liability Required As Physical Charges Applied.";
                                error = true;
                            }
                        }
                    }

                    if (self.policy_type.value == "liability") {

                        var errorMsg = "";
                        if (alreadySelected == "physical") {

                            errorMsg = "You have selected Policy with Type Physical. Please select policy with type Liability.";

                        }else if (alreadySelected == "liability") {

                            errorMsg = "You have selected Policy with Type Liability. Please select policy with type Physical.";

                        }

                        if (new Date(self.liability_to) < new Date(self.due_in_date) || new Date(self.liability_from) > new Date(self.due_out_date)) {
                            if (self.insPolicyArr.length == 1) {
                                self.common_error_msg = errorMsg;
                                error = true;
                            }else{
                                for(var i=0;i<self.insPolicyArr.length;i++) {
                                    if (self.insPolicyArr[i] != undefined) {
                                        if (self.insPolicyArr[i].policy_type == "liability") {
                                            if (self.insPolicyArr[i].start_date != undefined && self.insPolicyArr[i].start_date != "" && self.insPolicyArr[i].start_date != null) {
                                                if (new Date(self.liability_to) < new Date(self.due_in_date)){
                                                    var momentDate = moment(self.liability_to).add(1, 'days').format('MM/DD/YYYY');
                                                    var startDate = moment(self.insPolicyArr[i].start_date).format('MM/DD/YYYY');
                                                    if (Date.parse(startDate) > Date.parse(momentDate)) {
                                                        self.common_error_msg = "Select Valid Policy containing Date Next to Liability To Date and Agreement End Date";
                                                        error = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }else{

                            var liabilityFound = 0;

                            for(var i=0;i<self.insPolicyArr.length;i++) {
                                //check if liability found
                                if (self.insPolicyArr[i].policy_type != undefined && self.insPolicyArr[i].policy_type != null) {
                                    if (self.insPolicyArr[i].policy_type == "liability") {
                                        liabilityFound = 1;
                                    }
                                }
                            }

                            if (liabilityFound == 1 || self.insPolicyArr.length > 1) {
                                self.common_error_msg = "Policy with Type Physical Required As Liability Charges Applied.";
                                error = true;
                            }
                        }
                    }

                    if (self.policy_type.value == "both") {
                        var liabilityCheck = 0;
                        var physicalCheck = 0;

                        if (new Date(self.liability_to) < new Date(self.due_in_date) || new Date(self.liability_from) > new Date(self.due_out_date)) {
                            liabilityCheck = 1;
                        }

                        if (new Date(self.physical_to) < new Date(self.due_in_date) || new Date(self.physical_from) > new Date(self.due_out_date)) {
                            physicalCheck = 1;
                        }

                        console.log("liabilityCheck :: " + liabilityCheck + " physicalCheck :: " + physicalCheck);

                        for(var i=0;i<self.insPolicyArr.length;i++) {

                            if (self.insPolicyArr[i] != undefined) {

                                if (liabilityCheck == 1) {
                                    if (self.insPolicyArr[i].policy_type == "liability") {
                                        if (new Date(self.liability_to) < new Date(self.due_in_date)) {
                                            if (self.insPolicyArr[i].start_date != undefined && self.insPolicyArr[i].start_date != "" && self.insPolicyArr[i].start_date != null) {
                                                var momentDate = moment(self.liability_to).add(1, 'days').format('MM/DD/YYYY');
                                                var startDate = moment(self.insPolicyArr[i].start_date).format('MM/DD/YYYY');
                                                if (Date.parse(startDate) > Date.parse(momentDate)) {
                                                    self.common_error_msg = "Select Valid Policy containing Date Next to Liability To Date and Agreement End Date";
                                                    error = true;
                                                    return;
                                                }
                                            }
                                        }
                                    }
                                }

                                if (physicalCheck == 1) {
                                    if (self.insPolicyArr[i].policy_type == "physical") {
                                        if (new Date(self.physical_to) < new Date(self.due_in_date)) {
                                            if (self.insPolicyArr[i].start_date != undefined && self.insPolicyArr[i].start_date != "" && self.insPolicyArr[i].start_date != null) {
                                                var momentDate = moment(self.physical_to).add(1, 'days').format('MM/DD/YYYY');
                                                var startDate = moment(self.insPolicyArr[i].start_date).format('MM/DD/YYYY');
                                                if (Date.parse(startDate) > Date.parse(momentDate)) {
                                                    self.common_error_msg = "Select Valid Policy containing Date Next to Physical To Date and Agreement End Date";
                                                    error = true;
                                                    return;
                                                }
                                            }
                                        }
                                    }
                                }

                                if (self.insPolicyArr[i].policy_type == "both") {
                                    var physicalDate = moment(self.physical_to).add(1, 'days').format('MM/DD/YYYY');
                                    var liabilityDate = moment(self.liability_to).add(1, 'days').format('MM/DD/YYYY');

                                    if (new Date(self.physical_to) < new Date(self.due_in_date) || new Date(self.liability_to) < new Date(self.due_in_date)) {
                                        if (new Date(self.physical_to) > new Date(self.liability_to) || new Date(self.physical_to) < new Date(self.liability_to)
                                            || new Date(self.liability_to) > new Date(self.physical_to) || new Date(self.liability_to) < new Date(self.physical_to)) {
                                            self.common_error_msg = "Physical To and Liability To Date should be same";
                                            error = true;
                                            return;
                                        }
                                        if (self.insPolicyArr[i].start_date != undefined && self.insPolicyArr[i].start_date != "" && self.insPolicyArr[i].start_date != null) {
                                            var startDate = moment(self.insPolicyArr[i].start_date).format('MM/DD/YYYY');
                                            if (Date.parse(startDate) > Date.parse(physicalDate) || Date.parse(startDate) > Date.parse(liabilityDate)) {
                                                self.common_error_msg = "Select Valid Policy containing Date Next to Physical To Date and Liability To Date and Agreement End Date";
                                                error = true;
                                                return;
                                            }
                                        }
                                    }
                                }
                            }

                        }

                        if (physicalCheck == 1 && liabilityCheck == 1) {
                            //both physical or liability required
                            if (alreadySelected == "physical") {

                                errorMsg = "You have selected Policy with Type Physical. Please select policy with type Liability.";

                            }else if (alreadySelected == "liability") {

                                errorMsg = "You have selected Policy with Type Liability. Please select policy with type Physical.";

                            }

                            if (alreadySelected == "physical" || alreadySelected == "liability") {

                                if (self.insPolicyArr.length == 1) {
                                    self.common_error_msg = errorMsg;
                                    error = true;
                                }
                            }
                        }else if (physicalCheck == 1 && liabilityCheck == 0) {
                            //physical required
                            if (alreadySelected == "liability") {
                                errorMsg = "Policy with Type Physical Required.";
                                self.common_error_msg = errorMsg;
                                error = true;
                            }
                        }else if (physicalCheck == 0 && liabilityCheck == 1) {
                            //liability required
                            if (alreadySelected == "physical") {

                                errorMsg = "Policy with Type Liability Required.";
                                self.common_error_msg = errorMsg;
                                error = true;
                            }
                        }


                    }

                }
            }

        }

        // if (self.$route.params.id > 0 && !self.insDetailLink && !self.addInsurancePolicy && !self.close) {
        //     self.prefillValues(); //while update if Insurance Detail Link Clicked
        // }

        if (String(self.customer_insured) == "") {
            self.customer_insured_error_msg = "Customer Purchasing Insurance From Us require.";
            error = true;
        }else{

            if (self.customer_insured == 1 && !self.close) {
                if (self.policy_type == "" || !self.policy_type.value) {
                    self.policy_type_error_msg = "Policy Type require.";
                    error = true;
                }else{
                    if (self.policy_type.value == "physical" || self.policy_type.value == "liability") {
                        if (self.insPolicyArr.length < 1) {
                            self.common_error_msg = "Select Insurance Policy.";
                            error = true;
                        }
                    }
                }

                if (self.insDetailLink) {
                    if (!self.insurance_from || self.insurance_from == null || self.insurance_from == "") {
                        self.insurance_from_error_msg = "Insurance From Date require.";
                        error = true;
                    }

                    if (!self.insurance_to || self.insurance_to == null || self.insurance_to == "") {
                        self.insurance_to_error_msg = "Insurance To Date require.";
                        error = true;
                    }

                    if (new Date(self.insurance_from) > new Date(self.insurance_to)){
                        self.$swal('',"Insurance To Date should not be earlier than Insurance From Date",'info');
                        error = true;
                        return;
                        // error = true;
                    }
                }

            }

            else if (self.customer_insured == 0 && !self.close) {

                    if (self.insPolicyArr.length < 1) {
                        self.common_error_msg = "Select Insurance Policy.";
                        error = true;
                    }

                    if (self.insPolicyArr.length > 0) {

                        //as per new change
                        var policyTypeArr = [];
                        for (var i = 0;i < self.insPolicyArr.length;i++) {
                            if (self.insPolicyArr[i] != undefined && self.insPolicyArr[i] != null) {
                                if (self.insPolicyArr[i].policy_type != undefined && self.insPolicyArr[i].policy_type != null && self.insPolicyArr[i].policy_type != "") {
                                    policyTypeArr.push(self.insPolicyArr[i].policy_type);
                                }
                            }
                        }
                        //check all values in array are equal or not
                        const allEqual = arr => arr.every( v => v === arr[0] );
                        var found = allEqual(policyTypeArr);
                        var errorMsg = "";
                        if (found) {
                            if (policyTypeArr[0] == "physical") {
                                errorMsg = "You have selected Policy with Type Physical. Please select policy with type Liability.";
                                self.common_error_msg = errorMsg;
                                error = true;
                            }else if (policyTypeArr[0] == "liability") {
                                errorMsg = "You have selected Policy with Type Liability. Please select policy with type Physical.";
                                self.common_error_msg = errorMsg;
                                error = true;
                            }
                        }
                        if ((policyTypeArr.includes("physical") && policyTypeArr.includes("liability")) || policyTypeArr.includes("both")) {
                            //no need to check anything if both is selected
                        }else{
                            errorMsg = "Please select policy with type Physical AND Liability OR Both.";
                            self.common_error_msg = errorMsg;
                            error = true;
                        }

                        /*var alreadySelected = self.insPolicyArr[0].policy_type; //already selected policy
                        var errorMsg = "";

                        if (alreadySelected == "physical") {

                            errorMsg = "You have selected Policy with Type Physical. Please select policy with type Liability.";

                        }else if (alreadySelected == "liability") {

                            errorMsg = "You have selected Policy with Type Liability. Please select policy with type Physical.";

                        }

                        if (alreadySelected == "physical" || alreadySelected == "liability") {

                            if (self.insPolicyArr.length == 1) {
                                self.common_error_msg = errorMsg;
                                error = true;
                            }
                        }*/

                    }
                }
        }

        if (self.customer_insured == 1 && !self.close) {
            if (self.showDropZone) {
                if (self.insCertificateFiles.length == 0) {
                    self.insurance_certificate_error_msg = "Insurance Certificate Required.";
                    error = true;
                }

                if (self.insCertificateFiles.length > 0) {

                    if (self.insCertificateFiles.length > 2) {
                        self.insurance_certificate_error_msg = "Maximum 2 Files are allowed.";
                        error = true;
                        return;
                    }

                    if (self.validateCertificates.length > 0) {
                        for (var i = 0;i < self.validateCertificates.length;i++) {
                            let fileObj = self.validateCertificates[i];

                            if (fileObj.extension != undefined) {
                                if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf") {

                                }else{
                                    self.insurance_certificate_error_msg = "Only Images or PDF Files Are Allowed (.jpg / .jpeg / .png / .pdf).";
                                    error = true;
                                }
                            }

                            if (fileObj.size != undefined) {
                                if(fileObj.size > 5000000){
                                    self.insurance_certificate_error_msg = "File Size Should Not Be Greater Than 5 MB.";
                                    error = true;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    if (self.is_substitute) {
        if (self.sub_type.value != undefined){
            if (self.sub_type.value == 'lease'){
                if (self.contract_asset_id == "" || self.contract_asset_id == null || !self.contract_asset_id.value) {
                    self.contract_asset_error_msg = "Contract Asset Required.";
                    error = true;
                }
            }else if (self.sub_type.value == 'rental'){
                if (self.sub_agreement == "" || self.sub_agreement == null || !self.sub_agreement.value) {
                    self.sub_agreement_error_msg = "Agreement Required.";
                    error = true;
                }
            }else{
                if (self.sub_unit == "" || self.sub_unit == null || !self.sub_unit.value) {
                    self.sub_unit_error_msg = "Original Asset Required.";
                    error = true;
                }
            }
        }else{
            self.sub_type_error_msg = 'Please select sub type';
            error = true;
        }
        // if (self.is_contract_available == 1){
        //     if (self.contract_asset_id == "" || self.contract_asset_id == null || !self.contract_asset_id.value) {
        //         self.contract_asset_error_msg = "Contract Asset Required.";
        //         error = true;
        //     }
        // }else{
        //     if (self.sub_unit == "" || self.sub_unit == null || !self.sub_unit.value) {
        //         self.sub_unit_error_msg = "Original Asset Required.";
        //         error = true;
        //     }
        // }

    }

    if (self.osrSelection) {
        if (self.osrPO == "" || self.osrPO == null || !self.osrPO.value) {
            self.osr_po_error_msg = "OSR PO is Required.";
            error = true;
        }
    }
    //   if (!self.estimatedMiles || self.estimatedMiles == null || self.estimatedMiles == "") {
    //     self.mileserror_msg = "Miles require.";
    //     error = true;
    //   }
      console.log(error);
    //   return;
      if (!error) {

        if (self.unitReserved){
            self.$swal('','Unit Already Reserved','info');
            self.vehicle_error_msg = 'Unit Already Reserved';
            return;
        }

        //   if (self.$route.params.id == undefined && flag != 'no_program'){
        //     var miles = 0;
        //     var date = self.actual_from_date;
        //     if (self.unitArr && self.unitArr.length > 0){
        //         for (var i=0; i<self.unitArr.length; i++) {
        //             if (self.unitArr[i].section && self.unitArr[i].section == 'DIST'){
        //                 miles = self.unitArr[i].reading_out;
        //                 date = self.unitArr[i].reading_out_date;
        //             }
        //         }
        //     }
        //     self.$refs.triggerEnable.getMappedProgram(self.vehicle_id.value,miles,date);
        //     return;
        //   }

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            var agId = 0;
            if (segments[3])
            {
                agId = segments[3];
                $("#CreateRentalAgreementBtn").val("Updating ...");
                $("#CreateRentalAgreementBtn").prop("disabled", true);
                $("#cancelRentalAgreementBtn").prop("disabled",true);

            } else {

                if (flag == "Save and Continue") {

                    $("#createAndContinueRentalAgreementBtn").val("Saving ...");
                    $("#CreateRentalAgreementBtn").prop("disabled", true);
                    $("#createAndContinueRentalAgreementBtn").prop("disabled", true);
                    $("#cancelRentalAgreementBtn").prop("disabled",true);

                }else{

                    $("#CreateRentalAgreementBtn").val("Saving ...");
                    $("#CreateRentalAgreementBtn").prop("disabled", true);
                    $("#createAndContinueRentalAgreementBtn").prop("disabled", true);
                    $("#cancelRentalAgreementBtn").prop("disabled",true);
                }

            }

            var fields = $("#RentalAgreementForm").serializeArray();
            fields.push({name: "id", value: agId});
            fields.push({name: "contract_type_id", value: self.contract_type_id.value});
            fields.push({name: "vehicle_type_id", value: self.vehicle_type_id.value});
            fields.push({name: "requested_vehicle_type_id", value: self.requested_vehicle_type_id.value});
            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            fields.push({name: "customer_id", value: (self.customer_id == null) ? null : self.customer_id.value});
            // fields.push({name: "reading_out", value: self.readingOut});
            // fields.push({name: "reading_in", value: self.readingIn});
            fields.push({name: "due_out_date", value: self.due_out_date});
            fields.push({name: "due_in_date", value: self.due_in_date});
            fields.push({name: "planned_in_date", value: self.planned_in_date});
            fields.push({name: "distance", value: self.distance});

            var dueOutTime = self.changeTime12To24Hrs(self.due_out_time+" "+ self.due_out_ampm.value);
            fields.push({name: "due_out_time", value: dueOutTime});

            var dueInTime = self.changeTime12To24Hrs(self.due_in_time+" "+ self.due_in_ampm.value);
            fields.push({name: "due_in_time", value: dueInTime});

            // fields.push({name: "charge_from_time", value: self.charge_from_time.value});
            // fields.push({name: "charge_to_time", value: self.charge_to_time.value});

            var plannedInTime = self.changeTime12To24Hrs(self.planned_in_time+" "+ self.planned_in_ampm.value);
            fields.push({name: "planned_in_time", value: plannedInTime});

            if (self.actual_to_time.includes("_") == false && self.actual_to_time != '' && (self.actual_to_ampm != null ) && self.actual_to_ampm.value){
                var actualToTime = self.changeTime12To24Hrs(self.actual_to_time+" "+ self.actual_to_ampm.value);
            }else{
                var actualToTime = '';

            }
            // var actualToTime = self.changeTime12To24Hrs(self.actual_to_time+" "+ self.actual_to_ampm.value);
            fields.push({name: "actual_to_time", value: actualToTime});

            if (self.actual_from_time.includes("_") == false && self.actual_from_time != '' && (self.actual_from_ampm != null ) && self.actual_from_ampm.value){
                var actualFromTime = self.changeTime12To24Hrs(self.actual_from_time+" "+ self.actual_from_ampm.value);
            }else{
                var actualFromTime = '';

            }
            fields.push({name: "actual_from_date", value: self.actual_from_date});
            fields.push({name: "actual_to_date", value: self.actual_to_date});
            fields.push({name: "planned_in_date", value: self.planned_in_date});
            fields.push({name: "actual_from_time", value: actualFromTime});

            fields.push({name: "reading_out", value: JSON.stringify(self.unitArr)});
            fields.push({name: "reading_in", value: JSON.stringify(self.readInArr)});
            if(self.po.value){

                fields.push({name: "po", value: self.po.value});

            }

            if(self.distance && self.distance > 0 && self.distance != ''){

//                fields.push({ name: "miles", value: self.distance });
            }
//            else{
                fields.push({ name: "miles", value: self.estimatedMiles });
//            }

            fields.push({name: "source", value: self.source.value});
            fields.push({name: "insurance_company_id", value: ""});
            // if ( self.insurance_company_id == null ) {
            //     fields.push({name: "insurance_company_id", value: ""});
            // }else{
            //     fields.push({name: "insurance_company_id", value: self.insurance_company_id.value});
            // }

            if ( self.state == null ) {
                fields.push({ name: "state_id", value: "" });
            } else {
                fields.push({ name: "state_id", value: self.state.value });
            }

            fields.push({name: "due_out_location_id", value: self.due_out_location_id.value});
            fields.push({name: "due_in_location_id", value: self.due_in_location_id.value});
            //fields.push({name: "charge_from_location_id", value: self.charge_from_location_id.value});
            fields.push({name: "notes", value: self.notes});
            if (self.showFields) {//consolidated and is substitute option available
                if ( self.is_substitute == true ) {
                    fields.push({name: "is_substitute", value: 1});
                    // fields.push({name: "is_contract_available", value: self.is_contract_available});
                    fields.push({name: "sub_type", value: self.sub_type.value});
                    // if (self.is_contract_available == 1){
                    //     fields.push({name: "contract_asset_id", value: self.contract_asset_id.value});
                    // }else{
                    //     fields.push({name: "sub_unit", value: self.sub_unit.value});
                    // }
                    if (self.sub_type.value == 'lease'){
                        fields.push({name: "contract_asset_id", value: self.contract_asset_id.value});
                    }else if (self.sub_type.value == 'rental'){
                        fields.push({name: "sub_agreement", value: self.sub_agreement.value});
                    }else{
                        fields.push({name: "sub_unit", value: self.sub_unit.value});
                    }

                }else{
                    fields.push({name: "is_substitute", value: 0});
                    fields.push({name: "contract_asset_id", value: ""});
                    fields.push({name: "sub_unit", value: ""});
                }
                if ( self.consolidated == true ) {
                    fields.push({name: "consolidated", value: 'yes'});
                }else{
                    fields.push({name: "consolidated", value: 'no'});
                }
            }else{
                fields.push({name: "consolidated", value: 'yes'});
                fields.push({name: "is_substitute", value: 0});
            }
            if (self.from != '' && self.from == 'return'){
                fields.push({name: "closed", value: 'yes'});
            }
            var idArr = []; //insurance policy id array
            for (var i = 0;i < self.insPolicyArr.length;i++) {
                idArr.push(self.insPolicyArr[i].insurance_policy_id);
            }
            fields.push({ name: "insurance_policies", value:JSON.stringify(idArr)});
            // if (self.customer_insured != null && self.customer_insured != ''){

                fields.push({ name: "customer_insured", value:self.customer_insured});

            // }
            if (self.customer_insured == 1) {
                fields.push({ name: "insurance_charges", value:JSON.stringify(self.insuranceChargesArr)});
                fields.push({name: "insurance_from", value: self.insurance_from});
                fields.push({name: "insurance_to", value: self.insurance_to});
                fields.push({name: "charge_type", value: self.policy_type.value});
                if (self.$route.params.id > 0) {
                    if (self.policy_type.value == "physical" || self.policy_type.value == "both") {
                        fields.push({name: "physical_from", value: self.physical_from});
                        fields.push({name: "physical_to", value: self.physical_to});
                    }
                    if (self.policy_type.value == "liability" || self.policy_type.value == "both") {
                        fields.push({name: "liability_from", value: self.liability_from});
                        fields.push({name: "liability_to", value: self.liability_to});
                    }
                }
                if (self.showDropZone) {
                    fields.push({name: "doc_found", value: 1});
                    if(self.insCertificateFiles.length > 0){
                        fields.push({name: "insurance_certificates", value: JSON.stringify(self.insCertificateFiles)});
                    }else{
                        fields.push({name: "insurance_certificates", value: null});
                    }
                }else{
                    fields.push({name: "doc_found", value: 0});
                }
            }else{
                fields.push({ name: "insurance_charges", value:""});
                fields.push({name: "insurance_from", value: ""});
                fields.push({name: "insurance_to", value: ""});
                fields.push({name: "charge_type", value: ""});
            }
            if (self.reason != "" && self.reason != null) {
                fields.push({ name: "reason", value:self.reason.value});
            }else{
                fields.push({ name: "reason", value:""});
            }
            if (self.close) {
                fields.push({ name:"from_return", value:1});
            }else{
                fields.push({ name:"from_return", value:0});
            }

            fields.push({ name: "external_document", value:self.external_document});
            fields.push({name: "is_national_lease", value: self.is_national_lease});
            fields.push({name: "fuel_required", value: self.fuel_required});
            fields.push({name: "damage_return", value: self.damage_return});
            fields.push({name: "is_future_rate_adj", value: self.is_future_rate_adj});

            // if (self.disableFields) {
                fields.push({ name: "code", value:self.code});
            // }

            if(self.osrSelection) {
              fields.push({ name: "osr_po", value:self.osrPO.value});
            }

            if(self.penresId != null && self.penresId != '') {
              fields.push({ name: "pending", value:self.penresId});
            } else {
              fields.push({ name: "pending", value:""});
            }

            if (flag != '' && flag == 'post'){
                fields.push({ name: "from", value:"post"});
            }
            if (self.postOnce == 1){
                return;
            }
            self.postOnce = 1;
            $.ajax({
                url: process.env.ROOT_API + "/rentalagreement/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.postOnce = 0;
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateRentalAgreementBtn").val("Update");
                        $("#CreateRentalAgreementBtn").prop("disabled", false);
                        $("#cancelRentalAgreementBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueRentalAgreementBtn").val("Save and Continue");
                            $("#CreateRentalAgreementBtn").prop("disabled", false);
                            $("#createAndContinueRentalAgreementBtn").prop("disabled", false);
                            $("#cancelRentalAgreementBtn").prop("disabled",false);

                        }else{

                            $("#CreateRentalAgreementBtn").val("Save");
                            $("#CreateRentalAgreementBtn").prop("disabled", false);
                            $("#createAndContinueRentalAgreementBtn").prop("disabled", false);
                            $("#cancelRentalAgreementBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == 'post' && data.content.billing_post){
                            self.billingArr = data.content.billing_post;
                            self.amountFound = false;
                            if (self.billingArr.length > 0){
                                for (var i=0;i<self.billingArr.length;i++){
                                    if (self.billingArr[i].billed_days != 0){
                                        self.amountFound = true;
                                    }
                                }
                            }
                            self.bill_date = self.actual_to_date;
                            $("#postInvoiceModal").modal("show");
                            return;
                        }
                        if (flag == "Save and Continue") {

                            //to skip call getInurancepolicy call
                            self.checkPolicies = 0;

                            $("#RentalAgreementForm").trigger("reset");
                            self.code = "";
                            self.contract_type_id = null;
                            self.source = "";
                            self.customer_id = null;
                            self.po = "";
                            self.vehicle_type_id = null;
                            self.requested_vehicle_type_id = null;
                            self.vehicle_id = null;
                            self.state = null;
                            self.reason = "";
                            self.due_out_date = "";
                            self.due_out_location_id = null;
                            self.due_in_date = "";
                            self.due_in_location_id = null;
                            // self.charge_from_date = "";
                            // self.charge_from_location_id = null;
                            // self.charge_to_date = "";
                            self.planned_in_date = "";
                            self.customer_insured = "";
                            // self.insurance_company_id = null;
                            self.estimatedMiles = "";
                            self.readingOut = 0;
                            self.readingIn = 0;
                            self.distance = 0;
                            self.notes = "";
                            self.is_substitute = false;
                            self.policy_type = "";
                            self.insurancePolicyArr = [];
                            self.insuranceChargesArr = [];
                            self.insPolicyArr = [];

                        }else{
                            if (data.content.scope_rate_id){

                                self.$router.push("/scoperate/edit/"+data.content.scope_rate_id+'?from=agreement');

                            }else{

                                // self.$router.push("/rentalagreement/list");
                                self.$router.push("/rentalagreement/view/"+data.content.id);

                            }
                        }

                    } else {
                        self.common_error_msg = data.message;
                        setTimeout(function () {
                            self.common_error_msg = "";
                        }, 10000);
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.postOnce = 0;
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateRentalAgreementBtn").val("Update");
                        $("#CreateRentalAgreementBtn").prop("disabled", false);
                        $("#cancelRentalAgreementBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#RentalAgreementForm").trigger("reset");


                            $("#createAndContinueRentalAgreementBtn").val("Save and Continue");
                            $("#CreateRentalAgreementBtn").prop("disabled", false);
                            $("#createAndContinueRentalAgreementBtn").prop("disabled", false);
                            $("#cancelRentalAgreementBtn").prop("disabled",false);

                        }else{

                            $("#CreateRentalAgreementBtn").val("Save");
                            $("#CreateRentalAgreementBtn").prop("disabled", false);
                            $("#createAndContinueRentalAgreementBtn").prop("disabled", false);
                            $("#cancelRentalAgreementBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-create-data')
                }
            });
      }else{
            self.errorValidationFocus();
      }

    },

    loadRentalAgreement() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/rentalagreement/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                action_flag : 'edit', // pass action for notify: view, edit
                is_notify_flag : true // notify if user viewing or editing
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.isEdit = true;
                    self.code = data.content.code;

                    // self.enrich_code = data.content.enrich_code;
                    self.contract_type_id = {value: data.content.contract_type_id, text: self.titleCase(data.content.contTypeName)};
                    if (data.content.contTypeCode.toLowerCase() == "comp") {
                        self.showFields = false;
                    }else{
                        self.showFields = true;
                    }
                    if (data.content.contTypeCode.toLowerCase() == "transf" || data.content.contTypeCode.toLowerCase() == "comp") {
                        self.isTransferAgreement = true;//agreement type is TRANSF
                    }else{
                        self.isTransferAgreement = false;
                    }
                    if (data.content.contTypeCode.toLowerCase() == "transf" ){
                      self.isRequired = '';
                      self.isTransferCheck = true;
                    }else{
                      self.isRequired = 'require';
                      self.isTransferCheck = false;
                    }
                    //disable contract type if insurance detail already attached
                    if (data.content.customer_insured == 0 || data.content.customer_insured == 1) {
                        self.disableContractType = true;
                    }else{
                        self.disableContractType = false;
                    }
                    if (data.content.reason != null && data.content.reason != "") {
                        self.reason = {text:data.content.reason_value,value:data.content.reason};
                    }else{
                        self.reason = "";
                    }
                    // self.source = data.source;
                    if(data.content.po_no != null){
                        self.po = {text:data.content.po_no + " | " + data.content.poTotal,value:data.content.poId};
                    }else{
                        self.po = "";
                    }
                    if (data.content.custCode != undefined && data.content.custCode != null) {
                        self.customer_id = {value: data.content.customer_id, text: self.titleCase(data.content.custCode + " | " +data.content.custName)};
                    }else{
                        self.customer_id = {value: data.content.customer_id, text: self.titleCase(data.content.custName)};
                        if(data.content.contTypeCode.toLowerCase() == "transf" && data.content.customer_id == null){
                          self.customer_id = null;
                        }
                    }
                    self.vehicle_type_id = {value: data.content.vehicle_type_id, text: self.titleCase(data.content.vehicleTypeName)+' | '+data.content.vehicleTypeCode};
                    if (data.content.requested_vehicle_type_id){

                        self.requested_vehicle_type_id = {value: data.content.requested_vehicle_type_id, text: self.titleCase(data.content.req_vehicleTypeName)+' | '+data.content.req_vehicleTypeCode};

                    }else{
                        self.requested_vehicle_type_id = {value: data.content.vehicle_type_id, text: self.titleCase(data.content.vehicleTypeName)+' | '+data.content.vehicleTypeCode};
                    }
                    // setTimeout(function(){
                        self.vehicle_id = {value: data.content.vehicle_id, text: self.titleCase(data.content.unitNo)};
                    // },1000);
                    if(data.content.state_id == null) {
                        self.state = "";
                    } else{
                        self.state = {value: data.content.state_id, text: self.titleCase(data.content.stateName)};
                    }

                    self.due_out_date = data.content.due_out_date;
                    if ( data.content.due_out_time24 ) {

                        //self.due_in_time = {value:data.content.due_in_time24,text:data.content.due_in_time};
                        var dueOutTime =  data.content.due_out_time.split(" ");
                        self.due_out_time = dueOutTime[0];
                        self.due_out_ampm = {value:dueOutTime[1].toLowerCase(),text:dueOutTime[1]};
                    }

                    self.due_out_location_id = {value: data.content.due_out_location_id, text: self.titleCase(data.content.locOutName)};

                    self.due_in_date = data.content.due_in_date;
                    if ( data.content.due_in_time24 ) {

                        //self.due_in_time = {value:data.content.due_in_time24,text:data.content.due_in_time};
                        var dueInTime =  data.content.due_in_time.split(" ");
                        self.due_in_time = dueInTime[0];
                        self.due_in_ampm = {value:dueInTime[1].toLowerCase(),text:dueInTime[1]};
                    }
                    self.due_in_location_id = {value: data.content.due_in_location_id, text: self.titleCase(data.content.locInName)};

                    // set min and max date for start and end date as some time its not called...
                    if ( self.due_in_date != "" && self.due_in_date != null ) {
                        self.$set(self.toDueOutDate, 'maxDate', moment(self.due_in_date,"MM/DD/YYYY"));
                    }
                    self.$set(self.toDueInDate, 'minDate', moment(self.due_out_date,"MM/DD/YYYY"));

                    // self.charge_from_date = data.content.charge_from_date;

                    // if ( data.content.charge_from_time24 ) {

                    //     self.charge_from_time = {value:data.content.charge_from_time24,text:data.content.charge_from_time};

                    // }

                    // self.charge_from_location_id = {value: data.content.charge_from_location_id, text: self.titleCase(data.content.locfromName)};

                    // self.charge_to_date = data.content.charge_to_date;

                    // if ( data.content.charge_to_time24 ) {

                    //     self.charge_to_time = {value:data.content.charge_to_time24,text:data.content.charge_to_time};

                    // }
                    self.actual_to_date = data.content.actual_to_date;
                    self.actual_from_date = data.content.actual_from_date;
                    // set min and max date for start and end date as some time its not called...
                    if ( self.actual_to_date != "" && self.actual_to_date != null ) {
                        self.$set(self.toActualFromDate, 'maxDate', moment(self.actual_to_date,"MM/DD/YYYY"));
                    }
                    if (self.actual_from_date != ''){
                        self.$set(self.toActualInDate, 'minDate', moment(self.actual_from_date,"MM/DD/YYYY"));
                    }

                    if ( data.content.actual_from_time24 ) {

                        //self.actual_from_time = {value:data.content.actual_from_time24,text:data.content.actual_from_time};
                        var actualFromTime =  data.content.actual_from_time.split(" ");
                        self.actual_from_time = actualFromTime[0];
                        self.actual_from_ampm = {value:actualFromTime[1].toLowerCase(),text:actualFromTime[1]};
                    }

                    if ( data.content.actual_to_time24 ) {

                        //self.actual_to_time = {value:data.content.actual_to_time24,text:data.content.actual_to_time};
                        var actualToTime =  data.content.actual_to_time.split(" ");
                        self.actual_to_time = actualToTime[0];
                        self.actual_to_ampm = {value:actualToTime[1].toLowerCase(),text:actualToTime[1]};
                    }

                    self.planned_in_date = data.content.planned_in_date;

                    if ( data.content.planned_in_time24 ) {

                        //self.planned_in_time = {value:data.content.planned_in_time24,text:data.content.planned_in_time};
                        var plannedInTime =  data.content.planned_in_time.split(" ");
                        self.planned_in_time = plannedInTime[0];
                        self.planned_in_ampm = {value:plannedInTime[1].toLowerCase(),text:plannedInTime[1]};
                    }
                    self.customer_insured = data.content.customer_insured;
                    self.estimatedMiles = data.content.miles;
                    self.readingOut = data.content.reading_out;
                    self.readingIn = data.content.reading_in;
                    self.distance = data.content.difference;
                    // if(data.content.insurance_company_id == null) {
                    //     self.insurance_company_id = "";
                    // } else{
                    //     self.insurance_company_id = {value: data.content.insurance_company_id, text:data.content.policy_number+' | ' + self.titleCase(data.content.inName)};
                    // }
                    self.source = {value: data.content.resId, text:data.content.reference_no};
                    self.notes = data.content.notes;
                    if (data.content.is_national_lease != undefined && data.content.is_national_lease != null) {
                        self.is_national_lease = data.content.is_national_lease;
                    }
                    if (data.content.fuel_required != undefined && data.content.fuel_required != null) {
                        self.fuel_required = data.content.fuel_required;
                    }
                    if (data.content.damage_return != undefined && data.content.damage_return != null) {
                        self.damage_return = data.content.damage_return;
                    }
                    if (data.content.is_future_rate_adj != undefined && data.content.is_future_rate_adj != null) {
                        self.is_future_rate_adj = data.content.is_future_rate_adj;
                    }

                    if(data.content.is_substitute == 1){
                        $("#is_substitute").prop("checked",true);
                        self.is_substitute = true;
                        if (data.content.contract_asset_id != null) {
                            self.contract_asset_id = {text:data.content.contract_code + " | " + data.content.contract_asset,value:data.content.contract_asset_id};
                            self.sub_type = {text:'Lease Sub',value:'lease'};
                        }else if (data.content.sub_agreement_id != null){
                            self.sub_agreement = {text:data.content.sub_ag_code + " | " + data.content.sub_ag_unit,value:data.content.sub_agreement_id};
                            self.sub_type = {text:'Rental Sub',value:'rental'};
                        }else{
                            if (data.content.contract_available == 0){
                                // $("#is_contract_available1").prop("checked",true);
                                self.is_contract_available = 0;
                                self.sub_unit = {text:data.content.sub_unit_number,value:data.content.sub_unit};
                                self.sub_type = {text:'Unit Sub',value:'unit'};
                            }
                        }
                    }else{
                        $("#is_substitute").prop("checked",false);
                        self.is_substitute = false;
                    }

                    if(data.content.consolidated == 'yes'){
                        $("#consolidated").prop("checked",true);
                        self.consolidated = true;
                    }else{
                        $("#consolidated").prop("checked",false);
                        self.consolidated = false;
                    }

                    if(data.content.show_on_external_document == 'yes'){
                        self.external_document = 'yes';
                    }else{
                        self.external_document = 'no';
                    }

                    if (data.content.reading_out && data.content.reading_out.length > 0){
                        for (var i = 0; i < data.content.reading_out.length; i++) {
                            self.unitArr.push({
                                section_id:data.content.reading_out[i].section_id,
                                section:data.content.reading_out[i].section,
                                sectionName:(data.content.reading_out[i].sectionName != undefined && data.content.reading_out[i].sectionName != null) ? data.content.reading_out[i].sectionName :'',
                                reading_out:data.content.reading_out[i].reading_out,
                                reading_out_date:data.content.reading_out[i].reading_out_date,
                                reading_out_error_msg:'',
                                reading_out_date_error_msg:''
                            });

                        }

                        if (self.close == true){

                            // prevent different section populate while return according to vehicle id and requested vehicle type id
                             for (var k = 0; k < data.content.reading_out.length; k++) {

                                self.readInArr.push({
                                    section_id:data.content.odometer[k].section_id,
                                    section:data.content.odometer[k].section,
                                    sectionName:(data.content.odometer[k].sectionName != undefined && data.content.odometer[k].sectionName != null) ? data.content.odometer[k].sectionName : '',
                                    reading_in:'',
                                    reading_in_error_msg:'',
                                    reading_in_date:moment(self.due_in_date+' '+self.due_in_time+' '+self.due_in_ampm.value).format("MM/DD/YYYY hh:mm:ss a"),
                                    reading_in_date_error_msg:'',
                                });
                            }
                        }
                    }else{
                        self.getSections();
                    }

                    if (data.content.closed == 1){

                        if (data.content.reading_in && data.content.reading_in.length > 0){
                            self.readInArr = [];
                            for (var j = 0; j < data.content.reading_in.length; j++) {
                                self.readInArr.push({
                                    section_id:data.content.reading_in[j].section_id,
                                    section:data.content.reading_in[j].section,
                                    reading_in:data.content.reading_in[j].reading_in,
                                    reading_in_date:data.content.reading_in[j].reading_in_date,
                                    sectionName:(data.content.reading_in[j].sectionName != undefined && data.content.reading_in[j].sectionName != null) ? data.content.reading_in[j].sectionName : '',
                                    reading_in_error_msg:'',
                                    reading_in_date_error_msg:''
                                });
                            }
                        }
                    }

                    if (data.content.closed == 1){
                        self.alreadyReturned = true;
                        self.close = true;
                    }


                    //insurance charge dates on the basis of policy type
                    if (data.content.policy_type != "") {
                        if (data.content.policy_type == "physical") {
                            self.physical_from = data.content.physical_from;
                            self.physical_to = data.content.physical_to;
                            self.policy_type = { text: "Physical",value: "physical"};
                            self.policyTypeLabel = "Physical";
                        }
                        if(data.content.policy_type == "liability") {
                            self.liability_from = data.content.liability_from;
                            self.liability_to = data.content.liability_to;
                            self.policy_type = { text: "Liability",value: "liability"};
                            self.policyTypeLabel = "Liability";
                        }
                        if (data.content.policy_type == "both") {
                            self.policy_type = { text: "Both",value: "both"};
                            self.policyTypeLabel = "Both";
                            self.physical_from = data.content.physical_from;
                            self.physical_to = data.content.physical_to;
                            self.liability_from = data.content.liability_from;
                            self.liability_to = data.content.liability_to;
                        }
                    //    self.insurance_from = self.physical_from;
                    //    self.insurance_to = self.physical_to;
                    }
                    self.customerInsuredLabel = data.content.customer_insured;
                    if (self.customerInsuredLabel == 0) {
                        self.insDetailLink = true;
                    }

                    if (data.content.customer_insured == 0) {
                        self.fetchInsurancePolicy("");
                        self.insPolicyArr = data.content.insurance_policy;
                        self.policyLabelArr = data.content.insurance_policy_details;
                        // self.insurancePolicyArr = data.content.insurance_policy_details;

                    }else{
                       self.insPolicyArr = data.content.insurance_policy;
                       self.insuranceChargesArr = data.content.insurance_charges_details;
                       self.policyLabelArr = data.content.insurance_policy_details;
                       self.chargesLabelArr = data.content.insurance_charges_details;
                       self.existingPolicyArr = data.content.insurance_policy_details;
                       self.insurancePolicyArr = data.content.insurance_policy_details;
                    //    self.addInsurancePolicy = true;
                    //    self.fetchInsurancePolicy("both");
                       if (self.insPolicyArr.length < 1) {
                            //policy type is both
                            self.policy_type = { text: "Both",value: "both"};
                            self.policyTypeLabel = "Both";
                            // self.fetchInsurancePolicy("both");
                       }else{

                            /*if (self.insPolicyArr[0].policy_type == "physical") {
                                //policy with type physical selected
                                self.policy_type = { text: "Liability",value: "liability"};
                                self.policyTypeLabel = "Liability";
                                // self.fetchInsurancePolicy("physical");
                            }else{
                                //policy with type liability selected
                                self.policy_type = { text: "Physical",value: "physical"};
                                self.policyTypeLabel = "Physical";
                                // self.fetchInsurancePolicy("liability");
                            }*/

                       }

                       if (self.customer_insured == 1) {
                           self.showDropZone = true;
                           if(data.content.insurance_certificates != null) {
                                self.previewCertificates = data.content.insurance_certificates;
                                self.loadFilesPreview();
                           }
                       }else{
                           self.showDropZone = false;
                       }
                    }
                    if(data.content.insurance_stored && data.content.insurance_stored == 'true'){
                        self.insAlreadyStored = true;
                    }else{
                        self.insAlreadyStored = false;
                    }
                    if(data.content.insurance_charges_stored && data.content.insurance_charges_stored == 'true'){
                        self.onlyinschargesAlreadyStored = true;
                    }else{
                        self.onlyinschargesAlreadyStored = false;
                    }

                    setTimeout(function(){
                        self.actualFrom = true;
                        self.actualTo = true;
                        self.fromVehicle = true;
                        self.fillValues = true;
                        self.insuranceFrom = true;
                        self.insuranceTo = true;
                        // self.disableInsuranceDates = true;
                        // self.disableInsuranceFromDate = true;
                        self.physicalTo = true;
                        self.liabilityTo = true;
                        self.loadInsurancePolicy();
                    },2000);
                    //in case of return
                    if (self.close == true){
                        self.$set(self.optionsDate,'minDate',moment(data.content.actual_from_date).format("MM/DD/YYYY"));
                        var actualFromTime = data.content.actual_from_date + " " +data.content.actual_from_time24;
                        // self.$set(self.optionsDateTime,'minDate',moment(actualFromTime).format("MM/DD/YYYY hh:mm:ss a"));

                        if (data.content.actual_to_date == '' || data.content.actual_to_date == null || data.content.actual_to_date == undefined){
                            self.actual_to_date = moment().format("MM/DD/YYYY");
                            self.actual_to_time = moment().format("hh:mm");
                            self.actual_to_ampm.value = moment().format('a');
                            self.actual_to_ampm.text = moment().format('A');
                        }

                    }
                    if (data.content.status.toLowerCase() != "pending") {
                        self.disableFields = true;
                        self.disableContractType = true;
                    }

                    if (data.content.closed != 0){
                        self.isClosedAgreement = true;
                    }

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-load-data')
                }
            }
        });
    },
    getAgreementCode() {
        let self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/agreement/code",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.code = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true, 'get-agreement-code');
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    addNewPolicy(){
        var self = this;
        // self.$router.push('/insurancepolicy/create');
        self.customererrors = "";
        var error = false;

        if (self.customer_id == null || !self.customer_id.value) {

            self.customererrors = "Customer Name require.";
            error = true;

            setTimeout(function(){

                $('html, body').animate({
                    scrollTop: $(".rental-agreement-title").offset().top
                }, 500);

            },300);
        }

        if(!error){
            var string = "&customer_id="+self.customer_id.value+"&custName="+self.customer_id.text;

            let routeData = self.$router.resolve({name: 'InsurancePolicyCreate', query: {data: btoa(string)}});
            window.open(routeData.href, '_blank');

        }


        // v-bind:to="'/insurancepolicy/create'" target="_blank"
    },
    isSubstiute:function(e) {
        var self = this;
        self.contract_asset_error_msg = "";
        if(e.target.checked) {
            self.is_substitute = true;
            if(self.contract_type_id.code == 'TRANSF'){
              self.contract_type_id = null;
            }
        }else{
            self.is_substitute = false;
            self.contract_asset_id = "";
        }
    },
    onCustomerInput(event) {
        var self = this;
        self.customererrors = "";
        if (self.customer_id != null && self.customer_id != "") {
            if (self.customer_id.stage == "new" || self.customer_id.stage == "existing" || self.customer_id.stage == "credit approved") {
                self.credit_approved_msg = "Customer's Credit is Approved.";
                self.creditClass="color-green";
            }else{
                self.credit_approved_msg = "Customer's Credit is Not Approved.";
                self.creditClass="field-error";
            }
            if (self.customer_id.comment != undefined && self.customer_id.comment != ''){
                self.customer_comment = self.customer_id.comment;
            }else{
                self.customer_comment = '';
            }
        }else{
            self.credit_approved_msg = "";
            self.creditClass="field-error";
        }
        self.source='';
        if (self.customer_id != null && self.customer_id != "") {
            if (self.customer_id.po_required == 1){

            self.requiredFlag = 'require';

            }else{
                self.requiredFlag = '';
            }
            self.refreshInsurancePolicy(); //refresh insurance policy and charges
        }

    },
    customerInsuredSelected(value) {
        var self = this;
        var error = false;
        self.customer_insured_error_msg = "";
        self.policy_type = "";
        self.policy_type_error_msg = "";
        self.common_error_msg = "";
        self.customer_insured = value;
        self.customerInsuredLabel = value;
        self.insurancePolicyArr = [];
        self.insuranceChargesArr = [];
        self.insPolicyArr = [];
        self.insurance_from = "";
        self.insurance_to = "";
        self.insurance_from_error_msg = "";
        self.insurance_to_error_msg = "";
        self.noInsPolicyFound = false;
        self.insCertificateFiles = [];
        self.validateCertificates = [];
        if (self.customer_id == null || !self.customer_id.value) {
            self.$swal('','Please Select Customer.','info');
            error = true;
            return;
        }
        self.insuranceNeeded = true;
        if (!error) {
            if (self.customer_insured == 1) {
                self.showDropZone = true;
                if (self.due_out_date != null && self.due_out_date != "") {
                    //restrict insurance from and insurance to date selection between actual from and actual to
                    self.optionsDateInsuranceFrom.minDate = self.due_out_date;
                    self.optionsDateInsuranceTo.minDate = self.due_out_date;
                    self.insurance_from = self.due_out_date;
                }
                if (self.due_in_date != null && self.due_in_date != "") {
                    //restrict insurance from and insurance to date selection between actual from and actual to
                    self.optionsDateInsuranceFrom.maxDate = self.due_in_date;
                    self.optionsDateInsuranceTo.maxDate = self.due_in_date;
                    self.insurance_to = self.due_in_date;
                }
                if (self.$route.params.id > 0){
                    if (self.due_out_date != null && self.due_out_date != "") {
                        //restrict insurance from and insurance to date selection between actual from and actual to
                        self.optionsDateInsuranceFromLabel.minDate = self.due_out_date;
                        self.optionsDateInsuranceToLabel.minDate = self.due_out_date;
                        self.physical_from = self.due_out_date;
                        self.liability_from = self.due_out_date;
                    }
                    if (self.due_in_date != null && self.due_in_date != "") {
                        //restrict insurance from and insurance to date selection between actual from and actual to
                        self.optionsDateInsuranceFromLabel.maxDate = self.due_in_date;
                        self.optionsDateInsuranceToLabel.maxDate = self.due_in_date;
                        self.physical_to = self.due_in_date;
                        self.liability_to = self.due_in_date;
                    }
                }
                self.removeCertificateFiles();
            }else{
                self.showDropZone = false;
                self.fetchInsurancePolicy("");
            }
        }
    },
    onPolicyTypeSelect(event) {
        var self = this;
        self.policy_type_error_msg = "";
        self.common_error_msg = "";
        self.insurancePolicyArr = [];
        self.insuranceChargesArr = [];
        self.insPolicyArr = [];
        self.noInsPolicyFound = false;
        self.insCertificateFiles = [];
        self.validateCertificates = [];
        self.removeCertificateFiles();
        if (self.policy_type != "") {
            if (self.policy_type.value == "physical") {
                //fetch liability insurance policy
                self.fetchInsurancePolicy("liability");
            }else if (self.policy_type.value == "liability") {
                //fetch physical insurance policy
                self.fetchInsurancePolicy("physical");
            }else if (self.policy_type.value == "both") {
                //fetch charges
                self.insurancePolicyArr = [];
                self.fetchInsurancePolicy("both");
            }
        self.policyTypeLabel = self.policy_type.text;
        }
    },
    fetchInsurancePolicy(policyType) {
        var self = this;
        var error = false;
        self.due_out_datetime_error_msg = "";
        self.due_in_datetime_error_msg = "";
        self.customererrors = "";
        self.vehicle_error_msg = "";
        self.physical_to_error_msg = "";
        self.liability_to_error_msg = "";
        self.common_error_msg = "";
        self.contract_type_error_msg = "";
        self.physical_from_error_msg = "";
        self.liability_from_error_msg = "";
        var validate = false;
        var agreementId = "";

        if (self.$route.params.id > 0) {
            //update insurance dates and insurance charges
            if (self.customer_insured == 1 && self.addInsurancePolicy) {
                validate = true;
            }
            if (self.customer_insured == 1 && self.addInsurancePolicy) {
                validate = true;
            }
            agreementId = self.$route.params.id;
        }
        if (self.customer_id == null || !self.customer_id.value) {
            self.customererrors = "Customer Name require.";
            error = true;
        }

        if (self.vehicle_id == null || !self.vehicle_id.value) {
            self.vehicle_error_msg = "Vehicle Required.";
            error = true;
        }
        if (validate || self.onlyChargeUpdate) {
            //update insurance dates and insurance charges

            if (policyType == "physical" || policyType == "both") {
                if (!self.physical_from || self.physical_from == null || self.physical_from == "") {
                    self.physical_from_error_msg = "Physical From Date Required.";
                    error = true;
                }

                if (self.actual_from_date != null && self.actual_from_date != "") {
                    if (new Date(self.physical_from) < new Date(self.actual_from_date)){
                        self.physical_from_error_msg = "Physical From Date should not be earlier than Actual Out Date";
                        error = true;
                    }
                }else{
                    if (self.due_out_date != null && self.due_out_date != "") {
                        if (new Date(self.physical_from) < new Date(self.due_out_date)){
                            self.physical_from_error_msg = "Physical From Date should not be earlier than Due Out Date";
                            error = true;
                        }
                    }
                }

                if (!self.physical_to || self.physical_to == null || self.physical_to == "") {
                    self.physical_to_error_msg = "Physical To Date require.";
                    error = true;
                }

                if (new Date(self.physical_from) > new Date(self.physical_to)){
                    alert("Physical To Date should not be earlier than Physical From Date");
                    error = true;
                }

                if (new Date(self.physical_to) > new Date(self.due_in_date)){
                    self.physical_to_error_msg = "Physical To Date should not be greater than Due In Date.";
                    error = true;
                }
            }

            if (policyType == "liability" || policyType == "both") {
                if (!self.liability_from || self.liability_from == null || self.liability_from == "") {
                    self.liability_from_error_msg = "Liability From Date Required.";
                    error = true;
                }

                if (self.actual_from_date != null && self.actual_from_date != "") {
                    if (new Date(self.liability_from) < new Date(self.actual_from_date)){
                        self.liability_from_error_msg = "Liability From Date should not be earlier than Actual Out Date";
                        error = true;
                    }
                }else{
                    if (self.due_out_date != null && self.due_out_date != "") {
                        if (new Date(self.liability_from) < new Date(self.due_out_date)){
                            self.liability_from_error_msg = "Liability From Date should not be earlier than Due Out Date";
                            error = true;
                        }
                    }
                }
                if (!self.liability_to || self.liability_to == null || self.liability_to == "") {
                    self.liability_to_error_msg = "Liability To Date Required.";
                    error = true;
                }

                if (new Date(self.liability_from) > new Date(self.liability_to)){
                    alert("Liability To Date should not be earlier than Liability From Date");
                    error = true;
                }

                if (new Date(self.liability_to) > new Date(self.due_in_date)){
                    self.liability_to_error_msg = "Liability To Date should not be greater than Due In Date.";
                    error = true;
                }
            }

        }else{
            if (policyType == "" || policyType == "physical" || policyType == "liability") {
                if (!self.due_out_date || self.due_out_date == null || self.due_out_date == "") {
                    self.due_out_datetime_error_msg = "Due Out Date require.";
                    error = true;
                }

                if (!self.due_in_date || self.due_in_date == null || self.due_in_date == "") {
                    self.due_in_datetime_error_msg = "Due In Date require.";
                    error = true;
                }
                if (policyType == "physical" || policyType == "liability") {
                    if (self.contract_type_id == null || !self.contract_type_id.value) {
                        self.contract_type_error_msg = "Contract Type require.";
                        error = true;
                    }
                }
            }
            // if (!self.insurance_from || self.insurance_from == null || self.insurance_from == "") {
            //     self.insurance_from_error_msg = "Insurance From Date require.";
            //     error = true;
            // }

            // if (!self.insurance_to || self.insurance_to == null || self.insurance_to == "") {
            //     self.insurance_to_error_msg = "Insurance To Date require.";
            //     error = true;
            // }
            if (policyType == "both" || policyType == "physical" || policyType == "liability") {
                if (self.contract_type_id == null || !self.contract_type_id.value) {
                    self.contract_type_error_msg = "Contract Type require.";
                    error = true;
                }
                if (!self.insurance_from || self.insurance_from == null || self.insurance_from == "") {
                    self.insurance_from_error_msg = "Insurance From Date require.";
                    error = true;
                }

                if (!self.insurance_to || self.insurance_to == null || self.insurance_to == "") {
                    self.insurance_to_error_msg = "Insurance To Date require.";
                    error = true;
                }

                if (new Date(self.insurance_from) > new Date(self.insurance_to)){
                    alert("Insurance To Date should not be earlier than Insurance From Date");
                    error = true;
                }
            }
        }
        if (!error) {

            self.loading = true;
            if (validate || self.onlyChargeUpdate) {

                if (policyType == "physical") {
                    var fields = {
                        customer_id:self.customer_id.value,
                        due_out_date:self.due_out_date,
                        due_in_date:self.due_in_date,
                        physical_from_date:self.physical_from,
                        physical_to_date:self.physical_to,
                        policy_type:policyType,
                        vehicle_id:self.vehicle_id.value,
                        charge_update:1,
                        id:agreementId,
                        date_change:(self.dateChange)?1:0,
                        contract_type_id:self.contract_type_id.value,
                        truck_type_id:self.requested_vehicle_type_id.value,
                        is_national_lease:self.is_national_lease,
                        is_future_rate_adj:self.is_future_rate_adj
                    };

                }else if (policyType == "liability") {
                    var fields = {
                        customer_id:self.customer_id.value,
                        due_out_date:self.due_out_date,
                        due_in_date:self.due_in_date,
                        liability_from_date:self.liability_from,
                        liability_to_date:self.liability_to,
                        policy_type:policyType,
                        vehicle_id:self.vehicle_id.value,
                        charge_update:1,
                        id:agreementId,
                        date_change:(self.dateChange)?1:0,
                        contract_type_id:self.contract_type_id.value,
                        truck_type_id:self.requested_vehicle_type_id.value,
                        is_national_lease:self.is_national_lease,
                        is_future_rate_adj:self.is_future_rate_adj
                    };
                }else if (policyType == "both") {
                    var fields = {
                        customer_id:self.customer_id.value,
                        due_out_date:self.due_out_date,
                        due_in_date:self.due_in_date,
                        physical_from_date:self.physical_from,
                        physical_to_date:self.physical_to,
                        liability_from_date:self.liability_from,
                        liability_to_date:self.liability_to,
                        policy_type:"",
                        vehicle_id:self.vehicle_id.value,
                        charge_update:1,
                        policy_fetch:"both",
                        date_change:(self.dateChange)?1:0,
                        id:agreementId,
                        contract_type_id:self.contract_type_id.value,
                        truck_type_id:self.requested_vehicle_type_id.value,
                        is_national_lease:self.is_national_lease,
                        is_future_rate_adj:self.is_future_rate_adj

                    };
                }else if (policyType == "physical-both" || policyType == "liability-both") {
                    // in case agreement dates or asset changed fetch all policy along with charge on basis of policy type
                    var chargeType = self.policyTypeLabel.toLowerCase();

                    var fields = {
                        customer_id:self.customer_id.value,
                        due_out_date:self.due_out_date,
                        due_in_date:self.due_in_date,
                        physical_from_date:self.physical_from,
                        physical_to_date:self.physical_to,
                        liability_from_date:self.liability_from,
                        liability_to_date:self.liability_to,
                        policy_type:"",
                        vehicle_id:self.vehicle_id.value,
                        charge_update:0,
                        policy_fetch:"both",
                        charge_type:chargeType,
                        id:agreementId,
                        contract_type_id:self.contract_type_id.value,
                        truck_type_id:self.requested_vehicle_type_id.value,
                        is_national_lease:self.is_national_lease,
                        is_future_rate_adj:self.is_future_rate_adj
                    };
                }else{
                    var fields = {
                        customer_id:self.customer_id.value,
                        due_out_date:self.due_out_date,
                        due_in_date:self.due_in_date,
                        insurance_from_date:self.insurance_from,
                        insurance_to_date:self.insurance_to,
                        policy_type:policyType,
                        vehicle_id:self.vehicle_id.value,
                        charge_update:0,
                        id:agreementId,
                        contract_type_id:(policyType == "")?"":self.contract_type_id.value,
                        truck_type_id:self.requested_vehicle_type_id.value,
                        is_national_lease:self.is_national_lease,
                        is_future_rate_adj:self.is_future_rate_adj
                    };
                }

            }else{
                var fields = {
                    customer_id:self.customer_id.value,
                    due_out_date:self.due_out_date,
                    due_in_date:self.due_in_date,
                    insurance_from_date:self.insurance_from,
                    insurance_to_date:self.insurance_to,
                    policy_type:policyType,
                    vehicle_id:self.vehicle_id.value,
                    charge_update:0,
                    id:agreementId,
                    contract_type_id:(policyType == "")?"":self.contract_type_id.value,
                    truck_type_id:self.requested_vehicle_type_id.value,
                    is_national_lease:self.is_national_lease,
                    is_future_rate_adj:self.is_future_rate_adj
                };
            }

            $.ajax({
                url: process.env.ROOT_API + "/fetch-insurance-policy",
                type: "POST",
                headers: this.ajxHeaders,
                data: fields,
                crossDomain: true,
                dataType: 'json',
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.insurancePolicyArr = [];
                        //in case of load data from reservation
                        if(self.resId != undefined && self.resId != '' && !self.resLoad){
                            self.resLoad = true;
                            self.insuranceChargesArr = data.content.insurance_charges;
                            self.insurancePolicyArr = data.content.insurance_policy;
                            //as no policy availabe message displayed while update
                            for (var j = 0;j < self.insurancePolicyArr.length;j++) {
                                if (self.insurancePolicyArr[j] != undefined && self.insurancePolicyArr[j] != null) {
                                    if (self.insurancePolicyArr[j].status == 'Active'){
                                        self.activeFound = 'yes';
                                    }
                                    if (self.insurancePolicyArr[j].status == 'Expired'){
                                        self.expiredFound = 'yes';
                                    }
                                }
                            }
                            return;
                        }
                        //charge to dates are same for purchasing insurance yes
                        if (self.onlyChargeUpdate) {
                            self.chargesLabelArr = data.content.insurance_charges;
                            self.insuranceChargesArr = data.content.insurance_charges;
                            if (self.policy_type.value == "both") {
                                self.policyLabelArr = [];
                                self.insPolicyArr = [];
                            }else if (self.policy_type.value == "physical" || self.policy_type.value == "liability") {
                                var defaultPolicy = "";
                                if (self.policy_type.value == "physical") {
                                    defaultPolicy = "liability";
                                }else{
                                    defaultPolicy = "physical";
                                }

                                if (self.insPolicyArr.length > 0) {
                                    self.policyLabelArr = [];
                                    var selectedPolicy = [];
                                    for (var i = 0;i < self.insPolicyArr.length;i++) {
                                        if (self.insPolicyArr[i] != undefined && self.insPolicyArr[i] != null) {
                                            if (self.insPolicyArr[i].policy_type == defaultPolicy) {
                                                var index = self.findElementIndex(self.existingPolicyArr,"id",self.insPolicyArr[i].insurance_policy_id);

                                                if (index != undefined && index != null) {
                                                    if (!self.policyLabelArr.some(e => e.id === self.existingPolicyArr[index].id)) {
                                                        self.policyLabelArr.push(self.existingPolicyArr[index]);
                                                        selectedPolicy.push({
                                                            insurance_policy_id:self.existingPolicyArr[index].id,
                                                            start_date:self.existingPolicyArr[index].start_date,
                                                            expiry_date:self.existingPolicyArr[index].expiry_date,
                                                            policy_type:self.existingPolicyArr[index].policy_type.toLowerCase()
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if (selectedPolicy.length > 0) {
                                        self.insPolicyArr = [];
                                        for (var i = 0;i <selectedPolicy.length;i++) {
                                            if (!self.insPolicyArr.some(e => e.id === selectedPolicy[i].id)) {
                                                self.insPolicyArr.push(selectedPolicy[i]);
                                            }
                                        }
                                    }
                                }else{
                                    self.addInsurancePolicy = true;
                                }
                            }
                            self.onlyChargeUpdate = false;
                            return;
                        }
                        if (validate) {
                            //update insurance charges while customer purchasing insurance yes
                            self.chargesLabelArr = data.content.insurance_charges;
                            self.insuranceChargesArr = data.content.insurance_charges;
                            if (self.dateChange && self.policy_type.value == "both") {
                                if (self.chargeDateChange == 0) {
                                    self.addInsurancePolicy = false;
                                    self.insPolicyArr = [];
                                    self.policyLabelArr = [];
                                    return;
                                }
                            }
                            if (self.dateChange) {
                                //if date change in case update agreement
                                self.insCertificateFiles = [];
                                self.validateCertificates = [];
                                self.previewCertificates = [];
                                self.removeCertificateFiles();
                            }
                            self.dateChange = false;
                            if (self.actualFromChange || self.actualToChange) {
                                self.policyLabelArr = data.content.insurance_policy;
                                self.insPolicyArr = [];
                                if (self.actualFromChange) {
                                    self.actualFromChange = false;
                                }
                                if (self.actualToChange) {
                                    self.actualToChange = false;
                                }
                            }else{
                                //update insurance charges while customer purchasing insurance yes
                                self.chargesLabelArr = data.content.insurance_charges;
                                self.insuranceChargesArr = data.content.insurance_charges;
                                var insurancePolicies = data.content.insurance_policy;
                                if (self.insPolicyArr.length > 0) {
                                    //policy already selected
                                    if (data.content.insurance_policy.length > 0) {

                                        /*if (self.policyLabelArr[0] != undefined) {
                                            var existingPolicy = self.policyLabelArr[0];
                                            if (self.policyLabelArr[1] != undefined) {
                                                var existingPolicy2 =self.policyLabelArr[1];
                                            }
                                            self.policyLabelArr = [];//already selected policy
                                            self.policyLabelArr.push(existingPolicy);
                                            if (existingPolicy2 != undefined) {//in case if policy type both with physical and liability
                                                self.policyLabelArr.push(existingPolicy2);
                                            }
                                        }

                                        if (self.policyTypeLabel.toLowerCase() == "physical" || self.policyTypeLabel.toLowerCase() == "liability") {
                                            if (self.policyLabelArr[0] != undefined) {
                                                var existingPolicy = self.policyLabelArr[0];
                                                self.policyLabelArr = [];//already selected policy
                                                self.policyLabelArr.push(existingPolicy);
                                                setTimeout(function(){
                                                    $("#selectCheckbox0").prop("checked", true); //check selected insurance policy
                                                },300);
                                            }
                                        }*/
                                        //as per new changes
                                        var foundsppol = 0;
                                        for (var i = 0;i < insurancePolicies.length;i++) {
                                            //if policy not found then add policy in policy label array
                                            if (!self.policyLabelArr.some(e => e.id === insurancePolicies[i].id)) {
                                                self.policyLabelArr.push(insurancePolicies[i]);
                                            }
                                             for(var i = 0;i<self.policyLabelArr.length;i++) {
                                                if (self.policyLabelArr[i] != undefined && self.policyLabelArr[i] != null) {
                                                    self.insurancePolicyArr.push(self.policyLabelArr[i]);
                                                }
                                            }
                                            if (self.attachedInsPol == insurancePolicies[i].id){
                                                foundsppol = 1;
                                            }
                                        }
                                        if (foundsppol == 0){
                                            self.noInsPolicyFound = true;
                                        }
                                    }
                                }else{
                                    //no policy selected
                                    var polFound = 0;
                                    self.insPolicyArr = [];
                                    self.policyLabelArr = [];
                                    //add existing policy that was added while create agreement
                                    for(var i=0;i<self.existingPolicyArr.length;i++) {
                                        self.policyLabelArr.push(self.existingPolicyArr[i]);
                                    }
                                    var foundsppol = 0;
                                    for (var i = 0;i < insurancePolicies.length;i++) {
                                        //if policy not found then add policy in policy label array
                                        if (!self.policyLabelArr.some(e => e.id === insurancePolicies[i].id)) {
                                            self.policyLabelArr.push(insurancePolicies[i]);
                                        }
                                        if (self.attachedInsPol == insurancePolicies[i].id){
                                            foundsppol = 1;
                                        }
                                    }
                                    for(var i = 0;i<self.policyLabelArr.length;i++) {
                                        if (self.policyLabelArr[i] != undefined && self.policyLabelArr[i] != null) {
                                            self.insurancePolicyArr.push(self.policyLabelArr[i]);
                                            polFound = 1;
                                        }
                                    }
                                    if (foundsppol == 0){
                                        self.noInsPolicyFound = true;
                                    }
                                    if (polFound == 1){
                                        setTimeout(function(){
                                            $("#selectCheckbox0").prop("checked", true); //check selected insurance policy
                                        },300);
                                    }
                                }
                            }
                            if (data.content.insurance_policy.length == 0) {
                                self.noInsPolicyFound = true;
                            }else{
                                self.noInsPolicyFound = false;

                                if (self.attachedInsPol != '' && data.content.insurance_policy && data.content.insurance_policy.length){
                                    var foundsppol = 0;
                                    for (var i = 0;i < data.content.insurance_policy.length;i++) {

                                        if (self.attachedInsPol == data.content.insurance_policy[i].id){
                                            foundsppol = 1;
                                        }
                                    }
                                    if (foundsppol == 0){
                                        self.noInsPolicyFound = true;
                                    }
                                }
                            }
                        }else{
                            if (self.$route.params.id != undefined){
                                //in case of self insured no
                                if (self.$route.params.id > 0 && self.customer_insured == 0) {
                                    for(var i = 0;i<self.policyLabelArr.length;i++) {
                                        if (self.policyLabelArr[i] != undefined && self.policyLabelArr[i] != null) {
                                            self.insurancePolicyArr.push(self.policyLabelArr[i]);
                                        }
                                    }
                                    var insurancePolicies = data.content.insurance_policy;
                                    for (var i = 0;i < insurancePolicies.length;i++) {
                                        //if policy not found then add policy in policy label array
                                        if (!self.insurancePolicyArr.some(e => e.id === insurancePolicies[i].id)) {
                                            self.insurancePolicyArr.push(insurancePolicies[i]);
                                        }
                                    }
                                    self.insuranceChargesArr = data.content.insurance_charges;
                                    if (self.insurancePolicyArr.length == 0) {
                                        self.noInsPolicyFound = true;
                                    }else{
                                        self.noInsPolicyFound = false;
                                    }
                                }else{
                                    self.insurancePolicyArr = data.content.insurance_policy;
                                    self.insuranceChargesArr = data.content.insurance_charges;
                                    if (self.insurancePolicyArr.length == 0) {
                                        self.noInsPolicyFound = true;
                                    }else{
                                        self.noInsPolicyFound = false;
                                    }
                                }
                            }else{
                                self.insurancePolicyArr = data.content.insurance_policy;
                                self.insuranceChargesArr = data.content.insurance_charges;
                                if (self.insurancePolicyArr.length == 0) {
                                    self.noInsPolicyFound = true;
                                }else{
                                    self.noInsPolicyFound = false;
                                }
                            }
                            /*self.insurancePolicyArr = data.content.insurance_policy;
                            self.insuranceChargesArr = data.content.insurance_charges;
                            if (self.insurancePolicyArr.length == 0) {
                                self.noInsPolicyFound = true;
                            }else{
                                self.noInsPolicyFound = false;
                            }*/
                        }
                        //as no policy availabe message displayed while update
                        for (var j = 0;j < self.insurancePolicyArr.length;j++) {
                            if (self.insurancePolicyArr[j] != undefined && self.insurancePolicyArr[j] != null) {
                                if (self.insurancePolicyArr[j].status == 'Active'){
                                    self.activeFound = 'yes';
                                }
                                if (self.insurancePolicyArr[j].status == 'Expired'){
                                    self.expiredFound = 'yes';
                                }
                            }
                        }
                        //prevent selected policy for first time in case of update
                        if (self.$route.params.id > 0 && !self.fillValues) {
                            return;
                        }else{
                            var policyFound = 0;
                            var policyType = "";
                            //show insurance policy selected if physical-liability combination found
                            if (self.customer_insured == 1) {
                                if (self.policy_type != "") {
                                    if (self.insurancePolicyArr.length == 1) {
                                        if (self.policy_type.value == "physical") {
                                            if (self.insurancePolicyArr[0].policy_type.toLowerCase() == "liability") {
                                                policyFound = 1;
                                                policyType = "liability";
                                            }
                                        }else if (self.policy_type.value == "liability") {
                                            if (self.insurancePolicyArr[0].policy_type.toLowerCase() == "physical") {
                                                policyFound = 1;
                                                policyType = "physical";
                                            }
                                        }

                                        if (policyFound == 1) {
                                            setTimeout(function(){
                                                $("#selectCheckbox0").prop("checked", true); //check selected insurance policy
                                            },300);
                                            self.insPolicyArr.push({insurance_policy_id:self.insurancePolicyArr[0].id,policy_type:policyType,start_date:self.insurancePolicyArr[0].start_date,expiry_date:self.insurancePolicyArr[0].expiry_date});
                                        }
                                    }
                                }
                            }else if (self.customer_insured == 0) {
                                if (self.insurancePolicyArr.length == 1) {

                                    if (self.insurancePolicyArr[0].policy_type.toLowerCase() == "both") {
                                        policyFound = 1;
                                        policyType = "both";
                                    }
                                }else if (self.insurancePolicyArr.length == 2) {

                                    if ( (self.insurancePolicyArr[0].policy_type.toLowerCase() == "physical" && self.insurancePolicyArr[1].policy_type.toLowerCase() == "liability")
                                        || (self.insurancePolicyArr[0].policy_type.toLowerCase() == "liability" && self.insurancePolicyArr[1].policy_type.toLowerCase() == "physical")) {
                                        policyFound = 1;
                                        policyType = "physical-liability";
                                    }
                                }

                                if (policyFound == 1) {
                                    if (policyType == "both") {

                                        setTimeout(function(){
                                            $("#selectCheckbox0"). prop("checked", true); //check selected insurance policy
                                        },300);
                                        self.insPolicyArr.push({insurance_policy_id:self.insurancePolicyArr[0].id,policy_type:policyType,start_date:self.insurancePolicyArr[0].start_date,expiry_date:self.insurancePolicyArr[0].expiry_date});

                                    }else if (policyType == "physical-liability") {

                                        setTimeout(function(){
                                            $("#selectCheckbox0"). prop("checked", true); //check selected insurance policy
                                            $("#selectCheckbox1"). prop("checked", true);
                                        },300);
                                        self.insPolicyArr.push({insurance_policy_id:self.insurancePolicyArr[0].id,policy_type:self.insurancePolicyArr[0].policy_type.toLowerCase(),start_date:self.insurancePolicyArr[0].start_date,expiry_date:self.insurancePolicyArr[0].expiry_date});
                                        self.insPolicyArr.push({insurance_policy_id:self.insurancePolicyArr[1].id,policy_type:self.insurancePolicyArr[1].policy_type.toLowerCase(),start_date:self.insurancePolicyArr[1].start_date,expiry_date:self.insurancePolicyArr[1].expiry_date});
                                    }
                                }
                            }
                        }

                        if (self.attachedInsPol != '' && data.content.insurance_policy && data.content.insurance_policy.length){
                            var foundsppol = 0;
                                for (var i = 0;i < data.content.insurance_policy.length;i++) {

                                    if (self.attachedInsPol == data.content.insurance_policy[i].id){
                                        foundsppol = 1;
                                    }
                                }
                                if (foundsppol == 0){
                                    self.noInsPolicyFound = true;
                                }
                        }

                        /*for (var j = 0;j < self.insurancePolicyArr.length;j++) {
                            if (self.insurancePolicyArr[j] != undefined && self.insurancePolicyArr[j] != null) {
                                if (self.insurancePolicyArr[j].status == 'Active'){
                                    self.activeFound = 'yes';
                                }
                                if (self.insurancePolicyArr[j].status == 'Expired'){
                                    self.expiredFound = 'yes';
                                }
                            }
                        }*/
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-find-insurance-policy')
                }
            });
        }
    },
    clickRows(evt,row,index){
        var self = this;
        self.common_error_msg = "";
        if(evt.target.checked == true){
            if (self.customer_insured == 1) {
                if (row != undefined) {
                    if (row.policy_type != undefined) {
                        if (self.policy_type != "") {
                            var checkPolicyType = "";
                            if (self.policy_type.value == "physical") {
                                checkPolicyType = "liability";
                            }else if (self.policy_type.value == "liability") {
                                checkPolicyType = "physical";
                            }

                            if (row.policy_type.toLowerCase() == "both" && (checkPolicyType != '')) {
                                self.$swal('','You cannot select Policy with Type Both','info');
                                evt.target.checked = false;
                                return;
                            }else{
                                if (self.insPolicyArr.length < 1) {
                                    self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                }else{
                                    var alreadySelected = self.insPolicyArr[0].policy_type; //already selected policy
                                    if (row.policy_type.toLowerCase() == checkPolicyType) {
                                        self.$swal('','You have already selected Policy with Type ' + row.policy_type,'info');
                                        evt.target.checked = false;
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }
            }else{
                if (row != undefined) {
                    if (row.policy_type != undefined) {
                        //as per new change
                        self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                        /*if (self.insPolicyArr.length < 1) {
                            self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                        }else{
                            var alreadySelected = self.insPolicyArr[0].policy_type; //already selected policy
                            // policy with type both already selected
                            if (alreadySelected == "both") {
                                self.$swal('','You have already selected Policy with Type Both','info');
                                evt.target.checked = false;
                                return;
                            }else if (alreadySelected == "physical") {
                                if (row.policy_type.toLowerCase() == "physical" || row.policy_type.toLowerCase() == "both") {
                                    // policy with type physical already selected
                                    if (self.insPolicyArr.length == 1) {
                                        self.$swal('','You have selected Policy with Type Physical. Please select policy with type Liability','info');
                                        evt.target.checked = false;
                                        return;
                                    }else{
                                        self.$swal('','You have already selected Policy with Type Physical and Liability','info');
                                        evt.target.checked = false;
                                        return;
                                    }
                                }else{
                                    if (self.insPolicyArr.length < 2 ) {
                                        self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                    }else{
                                        self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                        evt.target.checked = false;
                                        return;
                                    }
                                }
                            }else if (alreadySelected == "liability") {
                                if (row.policy_type.toLowerCase() == "liability" || row.policy_type.toLowerCase() == "both") {
                                    // policy with type liability already selected
                                    if (self.insPolicyArr.length == 1) {
                                        self.$swal('','You have selected Policy with Type Liability. Please select policy with type Physical','info');
                                        evt.target.checked = false;
                                        return;
                                    }else{
                                        self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                        evt.target.checked = false;
                                        return;
                                    }
                                }else{
                                    if (self.insPolicyArr.length < 2 ) {
                                        self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                    }else{
                                        self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                        evt.target.checked = false;
                                        return;
                                    }
                                }
                            }
                        }*/
                    }
                }
            }
        }else{
            var i = self.insPolicyArr.indexOf(row);
            const filteredItems = self.insPolicyArr.filter(function(item) {
                return item.insurance_policy_id !== row.id
            })
            self.insPolicyArr = filteredItems;
        }
    },
    findElementIndex(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    },
    loadInsurancePolicy() {
        var self = this;
        var selectedInsPolicy = [];
        for (var i = 0;i < self.insPolicyArr.length;i++) {
            var index = self.findElementIndex(self.insurancePolicyArr,"id",self.insPolicyArr[i].insurance_policy_id);
            $("#selectCheckbox" + index). prop("checked", true); //check selected insurance policy
        }
    },
    refreshInsurancePolicy() {
        var self = this;
        if (self.resId != undefined && self.resId != "" && !self.resLoad) {
            return;
        }
        self.common_error_msg = "";
        self.policy_type_error_msg = "";
        self.insurancePolicyArr = [];
        self.insuranceChargesArr = [];
        self.insPolicyArr = [];
        self.insurance_from_error_msg = "";
        self.insurance_to_error_msg = "";
        if (String(self.customer_insured) == "") {
            self.customer_insured_error_msg = "Customer Purchasing Insurance From Us require.";
        }else{
            if (self.customer_insured == 1) {
                if (self.policy_type != "") {
                    if (self.policy_type.value == "physical") {
                        //fetch liability insurance policy
                        self.fetchInsurancePolicy("liability");
                    }else if (self.policy_type.value == "liability") {
                        //fetch physical insurance policy
                        self.fetchInsurancePolicy("physical");
                    }else if (self.policy_type.value == "both") {
                        //fetch charges
                        self.insurancePolicyArr = [];
                        self.fetchInsurancePolicy("both");
                    }
                }
            }else if (self.customer_insured == 0) {
                self.fetchInsurancePolicy("");
            }
        }
    },
    //insurance detail link clicked or not
    changeInsuranceDetails() {
        var self = this;
        self.physical_to_error_msg = "";
        self.liability_to_error_msg = "";
        self.physical_from_error_msg = "";
        self.liability_from_error_msg = "";
        self.noInsPolicyFound = false;
        self.chargeDateChange = 0;
        // self.noInsPolicyFound = false;
        //add policy clicked or not
        // if (!self.addInsurancePolicy) {
            if (self.dateChange) {
                //if date is changed
                self.addInsurancePolicy = true;
                if (self.due_in_date != null && self.due_in_date != "") {
                    if (self.policy_type.value == "physical" || self.policy_type.value == "both") {

                        if (new Date(self.physical_to) < new Date(self.due_in_date)) {
                            self.chargeDateChange = 1;
                        }
                    }
                    if (self.policy_type.value == "liability" || self.policy_type.value == "both") {

                        if (new Date(self.liability_to) < new Date(self.due_in_date)) {
                            self.chargeDateChange = 1;
                        }
                    }
                }
                if (self.policyTypeLabel != "") {
                    if (self.policyTypeLabel.toLowerCase() == "liability") {
                        self.fetchInsurancePolicy("liability");
                    }else if (self.policyTypeLabel.toLowerCase() == "physical") {
                        self.fetchInsurancePolicy("physical"); //refresh insurance policy and charges
                    }else if (self.policyTypeLabel.toLowerCase() == "both") {
                        self.fetchInsurancePolicy("both"); //refresh insurance policy and charges
                    }
                }
                return;
            }
            var checkDate = 0;
            if (self.due_out_date != null && self.due_out_date != "") {
                //restrict insurance from and insurance to date selection between actual from and actual to
                self.optionsDateInsuranceFromLabel.minDate = self.due_out_date;
                self.optionsDateInsuranceToLabel.minDate = self.due_out_date;
                if (self.policy_type.value == "physical" || self.policy_type.value == "both") {
                    if (new Date(self.physical_from) > new Date(self.due_out_date)) {
                        checkDate = 1;
                    }
                }
                if (self.policy_type.value == "liability" || self.policy_type.value == "both") {
                    if (new Date(self.liability_from) > new Date(self.due_out_date)) {
                        checkDate = 1;
                    }
                }
            }
            if (self.due_in_date != null && self.due_in_date != "") {
                //restrict insurance from and insurance to date selection between actual from and actual to
                self.optionsDateInsuranceFromLabel.maxDate = self.due_in_date;
                self.optionsDateInsuranceToLabel.maxDate = self.due_in_date;
                if (self.policy_type.value == "physical" || self.policy_type.value == "both") {

                    if (new Date(self.physical_to) < new Date(self.due_in_date)) {
                        checkDate = 1;
                    }
                }
                if (self.policy_type.value == "liability" || self.policy_type.value == "both") {

                    if (new Date(self.liability_to) < new Date(self.due_in_date)) {
                        checkDate = 1;
                    }
                }
            }
            // self.disableInsuranceDates = false;
            if (checkDate == 0) {
                var error = false;
                setTimeout(function(){

                    for (var i = 0;i < self.insPolicyArr.length;i++) {
                        var index = self.findElementIndex(self.policyLabelArr,"id",self.insPolicyArr[i].insurance_policy_id);
                        $("#selectCheckbox" + index). prop("checked", true); //check selected insurance policy
                    }
                },500);
                if (self.policy_type.value == "physical" || self.policy_type.value == "both") {

                    if (!self.physical_from || self.physical_from == null || self.physical_from == "") {
                        self.physical_from_error_msg = "Physical From Date Required.";
                        error = true;
                    }

                    if (!self.physical_to || self.physical_to == null || self.physical_to == "") {
                        self.physical_to_error_msg = "Physical To Date Required.";
                        error = true;
                    }

                    if (self.actual_from_date != null && self.actual_from_date != "") {
                        if (new Date(self.physical_from) < new Date(self.actual_from_date)){
                            self.physical_from_error_msg = "Physical From Date should not be earlier than Actual Out Date";
                            error = true;
                        }
                    }else{
                        if (self.due_out_date != null && self.due_out_date != "") {
                            if (new Date(self.physical_from) < new Date(self.due_out_date)){
                                self.physical_from_error_msg = "Physical From Date should not be earlier than Due Out Date";
                                error = true;
                            }
                        }
                    }

                    if (new Date(self.physical_from) > new Date(self.physical_to)){
                        alert("Physical To Date should not be earlier than Physical From Date");
                        error = true;
                    }

                    if (new Date(self.physical_to) > new Date(self.due_in_date)){
                        self.physical_to_error_msg = "Physical To Date should not be greater than Actual To Date.";
                        error = true;
                    }
                }

                if (self.policy_type.value == "liability" || self.policy_type.value == "both") {

                    if (!self.liability_from || self.liability_from == null || self.liability_from == "") {
                        self.liability_from_error_msg = "Liability From Date Required.";
                        error = true;
                    }

                    if (!self.liability_to || self.liability_to == null || self.liability_to == "") {
                        self.liability_to_error_msg = "Liability To Date Required.";
                        error = true;
                    }

                    if (self.actual_from_date != null && self.actual_from_date != "") {
                        if (new Date(self.liability_from) < new Date(self.actual_from_date)){
                            self.liability_from_error_msg = "Liability From Date should not be earlier than Actual Out Date";
                            error = true;
                        }
                    }else{
                        if (self.due_out_date != null && self.due_out_date != "") {
                            if (new Date(self.liability_from) < new Date(self.due_out_date)){
                                self.liability_from_error_msg = "Liability From Date should not be earlier than Due Out Date";
                                error = true;
                            }
                        }
                    }

                    if (new Date(self.liability_from) > new Date(self.liability_to)){
                        alert("Liability To Date should not be earlier than Liability From Date");
                        error = true;
                    }

                    if (new Date(self.liability_to) > new Date(self.due_in_date)){
                        self.liability_to_error_msg = "Liability To Date should not be greater than Actual To Date.";
                        error = true;
                    }
                }
                self.addInsurancePolicy = false;
                self.onlyChargeUpdate = true;
            }else{
                self.addInsurancePolicy = true;
                setTimeout(function(){

                    for (var i = 0;i < self.insPolicyArr.length;i++) {
                        var index = self.findElementIndex(self.policyLabelArr,"id",self.insPolicyArr[i].insurance_policy_id);
                        $("#selectCheckbox" + index). prop("checked", true); //check selected insurance policy
                    }
                },500);
                /*if (self.policyTypeLabel != "") {
                    if (!self.actualToChange) {
                        if (self.policyTypeLabel.toLowerCase() == "liability") {
                            self.fetchInsurancePolicy("liability");
                        }else if (self.policyTypeLabel.toLowerCase() == "physical") {
                            self.fetchInsurancePolicy("physical"); //refresh insurance policy and charges
                        }else if (self.policyTypeLabel.toLowerCase() == "both") {
                            self.fetchInsurancePolicy("both"); //refresh insurance policy and charges
                        }
                    }
                }*/
            }
            if (self.policyTypeLabel != "") {
                if (!self.actualToChange) {
                    if (self.policyTypeLabel.toLowerCase() == "liability") {
                        self.fetchInsurancePolicy("liability");
                    }else if (self.policyTypeLabel.toLowerCase() == "physical") {
                        self.fetchInsurancePolicy("physical"); //refresh insurance policy and charges
                    }else if (self.policyTypeLabel.toLowerCase() == "both") {
                        self.fetchInsurancePolicy("both"); //refresh insurance policy and charges
                    }
                }
            }
        // }
        // else{
        //     self.addInsurancePolicy = false;
        //     self.disableInsuranceDates = true;
        // }
    },
    //prefill values if insurance detail link clicked
    prefillValues() {
        var self = this;
        self.customer_insured = self.customerInsuredLabel;
        self.insuranceChargesArr = [];
        if (self.customer_insured == 1) {
            self.insuranceChargesArr = self.chargesLabelArr;
        }
    },
    //in case customer purchasing insurance yes and update charges date
    policySelect(evt,row,index){
        var self = this;
        self.common_error_msg = "";
        if(evt.target.checked == true){
            if ( self.customerInsuredLabel == 1 ||self.customer_insured == 1) {
                if (row != undefined) {
                    if (row.policy_type != undefined) {
                        if (self.policy_type != "") {
                            var checkPolicyType = "";
                            if ( self.policyTypeLabel.toLowerCase() == "physical" ||self.policy_type.value == "physical" ) {
                                checkPolicyType = "physical";
                            }else if (self.policyTypeLabel.toLowerCase() == "liability" ||self.policy_type.value == "liability") {
                                checkPolicyType = "liability";
                            }

                            if (checkPolicyType == "physical" || checkPolicyType == "liability") {
                                if (row.policy_type.toLowerCase() == "both") {
                                    self.$swal('','You cannot select Policy with Type Both','info');
                                    evt.target.checked = false;
                                    return;
                                }
                            }

                            if (self.insPolicyArr.length < 1) {
                                self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                            }else{
                                var alreadySelected = self.insPolicyArr[0].policy_type; //already selected policy

                                if (alreadySelected == "both") {
                                    self.$swal('','You have already selected Policy with Type Both','info');
                                    evt.target.checked = false;
                                    return;
                                }else if (alreadySelected == "physical") {

                                    if (row.policy_type.toLowerCase() == "physical" || row.policy_type.toLowerCase() == "both") {
                                        // policy with type physical already selected
                                        if (self.insPolicyArr.length == 1) {
                                            self.$swal('','You have selected Policy with Type Physical. Please select policy with type Liability','info');
                                            evt.target.checked = false;
                                            return;
                                        }else{
                                            self.$swal('','You have already selected Policy with Type Physical and Liability','info');
                                            evt.target.checked = false;
                                            return;
                                        }
                                    }else{
                                        if (self.insPolicyArr.length < 2 ) {
                                            self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                        }else{
                                            self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                            evt.target.checked = false;
                                            return;
                                        }
                                    }
                                }else if (alreadySelected == "liability") {
                                    if (row.policy_type.toLowerCase() == "liability" || row.policy_type.toLowerCase() == "both") {
                                        // policy with type liability already selected
                                        if (self.insPolicyArr.length == 1) {
                                            self.$swal('','You have selected Policy with Type Liability. Please select policy with type Physical','info');
                                            evt.target.checked = false;
                                            return;
                                        }else{
                                            self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                            evt.target.checked = false;
                                            return;
                                        }
                                    }else{
                                        if (self.insPolicyArr.length < 2 ) {
                                            self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                        }else{
                                            self.$swal('','You have already selected Policy with Type Liability and Physical','info');
                                            evt.target.checked = false;
                                            return;
                                        }
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }else{
            var i = self.insPolicyArr.indexOf(row);
            const filteredItems = self.insPolicyArr.filter(function(item) {
                return item.insurance_policy_id !== row.id
            })
            self.insPolicyArr = filteredItems;
        }
    },
    onSearchContractAsset(search, loading) {
        var self = this;

        if (search.length > 0) {
            loading(true);
            self.searchField(loading, search, 'active contract', '');
        }

    },
    onSearchAgreement(search, loading) {
        var self = this;

        if (search.length > 1) {
            loading(true);
            self.searchField(loading, search, 'active_rental_agreement', '');
        }

    },

    onContractTypeSelect(event) {
        var self = this;
        // self.is_substitute = false;
        // self.contract_asset_id = "";
        if (self.contract_type_id != null && self.contract_type_id != "") {
            if (self.contract_type_id.code != undefined) {
                if (self.contract_type_id.code.toLowerCase() == "osr" || self.contract_type_id.code.toLowerCase() == "osrm"){
                    self.osrSelection = true;
                }else{
                    self.osrSelection = false;
                }
                if (self.contract_type_id.code.toLowerCase() == "transf" || self.contract_type_id.code.toLowerCase() == "comp") {
                    self.isTransferAgreement = true;//agreement type is TRANSF
                    self.contract_type_id.code.toLowerCase() == "transf" ? self.isRequired = '' : self.isRequired = 'require';
                }else{
                    self.isTransferAgreement = false;
                    self.isRequired = 'require';
                }
                if (self.contract_type_id.code.toLowerCase() == "comp") {
                    self.showFields = false;
                }else{
                    self.showFields = true;
                }
                if (self.contract_type_id.code.toLowerCase() == "transf") {
                  self.isTransferCheck = true;
                }else{
                  self.isTransferCheck = false;
                }
            }else{
                self.showFields = false;
                self.isTransferAgreement = false;
            }


            if ((self.resId != undefined && self.resId != '') || (self.penresId != undefined && self.penresId != '')){
                if (self.contract_type_id.code != 'R1'){
                    self.$swal('','Reservation rates will not be used if contract type is not R1','info');
                }
            }
        }else{
            self.showFields = false;
            self.isTransferAgreement = false;
        }
        if(self.isTransferCheck){
            self.is_substitute = false;
            self.contract_asset_id = "";
        }
        //agreement type is TRANSF
        if (self.isTransferAgreement) {
            self.customer_insured = null;
            self.customer_insured_error_msg = "";
            self.policy_type = "";
            self.insuranceNeeded = false;
            self.policy_type_error_msg = "";
            self.common_error_msg = "";
            self.insurancePolicyArr = [];
            self.insuranceChargesArr = [];
            self.insPolicyArr = [];
            self.insurance_from = "";
            self.insurance_to = "";
            self.insurance_from_error_msg = "";
            self.insurance_to_error_msg = "";
            self.noInsPolicyFound = false;
            self.insCertificateFiles = [];
            self.validateCertificates = [];
            self.removeCertificateFiles();
            self.physical_from = "";
            self.physical_to = "";
            self.liability_from = "";
            self.liability_to = "";
            self.physical_from_error_msg = "";
            self.physical_to_error_msg = "";
            self.liability_from_error_msg = "";
            self.liability_to_error_msg = "";
            self.policyLabelArr = [];
            self.existingPolicyArr = [];
            self.chargesLabelArr = [];
        }else{
            //if contract type changed in case of agreement create from reservation
            if (self.$route.query.resId != undefined && self.$route.query.resId != "") {
                if (self.customer_insured == 1) {
                    self.refreshInsurancePolicy();
                }
            }
        }

    },
    afterUploadComplete(file,response){
        var self = this;
    },
    removeCertificateFiles() {
        var self = this;
        if (self.$refs.insuranceCertificate != undefined) {
            self.$refs.insuranceCertificate.removeAllFiles();
        }
    },
    manuallyAddFile(file) {
        var self = this;
        if (self.insCertificateFiles.length == 2) {
            self.insurance_certificate_error_msg = "Maximum 2 files are allowed.";
            return;
        }
    },
    storeInsuranceCertificate(file,response) {
        var self = this;
        var uploadResponse = response;
        //push doc path in files array
        var uploadFile = 1;

        if (self.insCertificateFiles.length == 2) {
            self.insurance_certificate_error_msg = "Maximum 2 files are allowed.";
            uploadFile = 0;
        }

        if (uploadFile == 1) {
            self.insCertificateFiles.push(uploadResponse.content);
            if (file.type != undefined) {
                var extension = file.type.split("/");
                self.validateCertificates.push({
                    file_name:file.name,
                    size:file.size,
                    extension:extension[1]
                });
            }
        }
    },
    removeInsuranceCertificate(file, xhr, error) {
        var self = this;
        var agreementId = "";
        if (file.xhr != undefined) {
            var fileName = JSON.parse(file.xhr.response).content;

            var fileArr = fileName.split("/");

            self.removeFileFromServer(fileArr[1],agreementId,"temp");

            for(var i = 0;i<self.insCertificateFiles.length;i++){
                if ( self.insCertificateFiles[i].includes(fileName)) {
                    self.insCertificateFiles.splice(i,1);
                    self.validateCertificates.splice(i,1);
                }
            }
        }
    },
    removeFileFromServer(file, agreementId,flag){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/remove-insurance-certificate",
            type: "POST",
            data: {
                filePath : file,
                id: agreementId,
                flag:flag
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;

            },
            error: function (jqXHR, exception) {

                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'remove-insurance-certificate')
            }
        });

    },
    getFilePathFromUrl (value) {

        var path = "";
        var src = value.split('/');
        var file_name = src[src.length - 1];
        var orgPath = src[src.length - 2];
        path = orgPath + "/" + file_name;
        return path;

    },
    //load files in drop zone
    loadFilesPreview:function() {
        var self = this;
        if ( self.previewCertificates.length > 0 ) {

            for ( var i = 0;i<self.previewCertificates.length;i++ ) {

                var file = { size: self.previewCertificates[i].size, name: self.previewCertificates[i].file_name, type: self.previewCertificates[i].file_type};
                var url = self.previewCertificates[i].url;
                //get file path from url
                self.insCertificateFiles.push(self.getFilePathFromUrl(self.previewCertificates[i].url));
                self.validateCertificates.push({
                    file_name:self.previewCertificates[i].file_name,
                    extension:self.previewCertificates[i].extension
                });
            }
        }
    },
    removeServerFile(fileName,key) {

        var self = this;
        var agreementId = "";
        var path = window.location.pathname;
        var segments = path.split("/");
        if ( segments[3] != undefined ) {
            agreementId = segments[3];
        }

        if (confirm('Are you sure that you want to remove file? ')) {

            self.removeFileFromServer(fileName,agreementId,"server");
            self.previewCertificates.splice(key,1);

            //remove file from files array
            for ( var i = 0;i<self.insCertificateFiles.length;i++ ) {
                if ( self.insCertificateFiles[i].includes(fileName)) {
                    self.insCertificateFiles.splice(i,1);
                    self.validateCertificates.splice(i,1);
                }
            }
        }

    },
    addNewPo:function(){
        var self = this;
        var url = '&type=contract&customer='+JSON.stringify(self.customer_id);
        let routeData = this.$router.resolve({name: 'CustomerPurchaseOrderCreate',query:{data:btoa(url)}});
        window.open(routeData.href, '_blank');

    },
    addOsrAsset:function(){
        var self = this;
        var url = '&redirectFrom=osr';
        let routeData = this.$router.resolve({name: 'AssetCreate',query:{data:btoa(url)}});
        window.open(routeData.href, '_blank');
    },
    addOsrPO:function(){
        var self = this;
        var url = '&redirectFrom=osr';
        let routeData = this.$router.resolve({name: 'VendorPurchaseOrderCreate',query:{data:btoa(url)}});
        window.open(routeData.href, '_blank');
    },

    addinsuranceNeeded:function(flag){
        var self = this;

        self.insuranceNeeded = false;
        self.policy_type_error_msg = "";
        self.common_error_msg = "";
        self.insurancePolicyArr = [];
        self.insuranceChargesArr = [];
        self.insPolicyArr = [];
        self.noInsPolicyFound = false;
        self.insCertificateFiles = [];
        self.validateCertificates = [];
        self.removeCertificateFiles();
    },
    // this function takes an array of date ranges in this format:
    // [{ start: Date, end: Date}]
    // the array is first sorted, and then checked for any overlap
    overlap(dateRanges){
        var sortedRanges = dateRanges.sort((previous, current) => {
            // get the start date from previous and current
            var previousTime = previous.start.getTime();
            var currentTime = current.start.getTime();
            // if the previous is earlier than the current
            if (previousTime < currentTime) {
                return -1;
            }
            // if the previous time is the same as the current time
            if (previousTime === currentTime) {
                return 0;
            }
            // if the previous time is later than the current time
            return 1;
        });
        var result = sorted.reduce((result, current, idx, arr) => {
            // get the previous range
            if (idx === 0) { return result; }
            var previous = arr[idx-1];
            // check for any overlap
            var previousEnd = previous.end.getTime();
            var currentStart = current.start.getTime();
            var overlap = (previousEnd >= currentStart);
            // store the result
            if (overlap) {
            // yes, there is overlap
            result.overlap = true;
            // store the specific ranges that overlap
            result.ranges.push({
                previous: previous,
                current: current
            })
            }
            return result;
            // seed the reduce
        }, {overlap: false, ranges: []});
        // return the final results
        return result;
    },
    isFutureRateADJSelected(event) {
      var self = this;
      self.is_future_rate_adj = event.target.value;
    },
    isNationalLeaseSelected(event) {
        var self = this;
        self.is_national_lease = event.target.value;
        if (!self.isTransferAgreement) {
            self.common_error_msg = "";
            self.insurancePolicyArr = [];
            self.insuranceChargesArr = [];
            self.insPolicyArr = [];
            self.noInsPolicyFound = false;
            self.insCertificateFiles = [];
            self.validateCertificates = [];
            self.removeCertificateFiles();
            self.policyLabelArr = [];
            self.existingPolicyArr = [];
            self.chargesLabelArr = [];
            if (self.customer_insured == 1) {
                if (self.policy_type != "") {
                    if (self.policy_type.value == "physical") {
                        //fetch liability insurance policy
                        self.fetchInsurancePolicy("liability");
                    }else if (self.policy_type.value == "liability") {
                        //fetch physical insurance policy
                        self.fetchInsurancePolicy("physical");
                    }else if (self.policy_type.value == "both") {
                        //fetch charges
                        self.fetchInsurancePolicy("both");
                    }
                }
            }else if (self.customer_insured == 0) {
                self.fetchInsurancePolicy("");
            }
        }

        // setTimeout(function(){
        //     if (self.contracttypeArr && self.contracttypeArr.length > 0 && self.is_national_lease == 1){
        //         for(var i=0;i<self.contracttypeArr.length;i++){

        //             if (self.contracttypeArr[i].code == 'RN'){
        //                 self.contract_type_id = self.contracttypeArr[i];
        //             }
        //         }
        //     }
        // },1000);
    },
    checkAvailablity:function(){
        var self = this;
        self.due_in_datetime_error_msg = '';
        self.due_out_datetime_error_msg = '';
        self.due_out_time_error_msg = '';
        self.due_in_time_error_msg = '';
        var error=false;

        if (!self.due_out_date || self.due_out_date == null || self.due_out_date == "") {
            self.due_out_datetime_error_msg = "Due OUT Date require.";
            error = true;
        }

        if (self.due_out_time == null || self.due_out_time == "") {
            self.due_out_time_error_msg = "Due OUT Time Required.";
            error = true;
        } else {
            var validateTime = self.validateTimeFormat(self.due_out_time);
            if ( self.due_out_time.indexOf("_") > -1 || !validateTime ) {
                self.due_out_time_error_msg = "Please check Due out time format.";
                error = true;
            }
        }
        if (!self.due_in_date || self.due_in_date == "") {
            self.due_in_datetime_error_msg = "Due IN DateTime require.";
            error = true;
        }

        if (self.due_in_time == null || self.due_in_time == "") {
            self.due_in_time_error_msg = "Due IN Time Required.";
            error = true;
        } else {

            var validateTime = self.validateTimeFormat(self.due_in_time);
            if ( self.due_in_time.includes("_") || !validateTime ) {
                self.due_in_time_error_msg = "Please check Due out time format.";
                error = true;
            }
        }
        if (error){
            return;
        }
        var typeId = '';
        if (self.requested_vehicle_type_id != null && self.requested_vehicle_type_id.value){
            typeId = self.requested_vehicle_type_id.value;
        }
        var fields = {
            units:'',
            pickDate:self.due_out_date,
            dropDate:self.due_in_date,
            pickTime:self.due_out_time,
            dropTime:self.due_in_time,
            // location_id:(self.locationId != null && self.locationId != "")?self.locationId.value:"",
            location_id:'',
            type_id:typeId,
            res_type:'rental',
            flag:'all'
        };
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/get-units",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                    self.checkAvailabilityFlag = true;
                    self.rows = data.content.row;
                    self.totalRecords = data.content.totalRecords;
                    // self.filteredFlag = false;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'make-rsvtn-get-unit')
            }
        });
    },
    policyCreationForm:function(from){
        var self = this;
        self.due_out_datetime_error_msg = "";
        self.due_in_datetime_error_msg = "";
        self.customererrors = "";
        self.vehicle_error_msg = "";
        self.contract_type_error_msg = "";
        self.code_error_msg = "";
        var error = false;


        if (self.customer_id == null || !self.customer_id.value) {
            self.customererrors = "Customer Name require.";
            error = true;
        }

        if (self.vehicle_id == null || !self.vehicle_id.value) {
            self.vehicle_error_msg = "Vehicle Required.";
            error = true;
        }

        if (!self.due_out_date || self.due_out_date == null || self.due_out_date == "") {
            self.due_out_datetime_error_msg = "Due Out Date require.";
            error = true;
        }

        if (!self.due_in_date || self.due_in_date == null || self.due_in_date == "") {
            self.due_in_datetime_error_msg = "Due In Date require.";
            error = true;
        }

        if (self.contract_type_id == null || !self.contract_type_id.value) {
            self.contract_type_error_msg = "Contract Type require.";
            error = true;
        }

        if (!error) {
            if (from && from == 'add'){
                self.attachedInsPol = '';
            }
            self.dataForInsurance = {
                policy_id:self.attachedInsPol,
                customer_id: (self.customer_id.value != undefined) ? self.customer_id.value : '',
                customer : (self.customer_id.text != undefined) ? self.customer_id.text : '',
                customer_code : (self.customer_id.code != undefined) ? self.customer_id.code : '',
            }

            self.createNewPolicy = true;
        }
    },
    closeAgreement:function(){
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/agreement/close",
            type: "POST",
            data: {
                agreement_id:segments[3],
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    $("#postInvoiceModal").modal("hide");
                    self.$router.push("/rentalagreement/view/"+segments[3]);
                }else{

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    expiredPolicy:function(){
        var self = this;

        self.policyView = 'expired';
        self.expPolicy = 'active';
        self.actPolicy = '';
    }
  }
};
</script>
<style scoped>
.customPadding{
    padding-top:15px;
}
.invisible-icon {
    z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/RentalAgreementCreate.vue